webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormTypeEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ServerErrors; });
var FormTypeEnum = { "login": 1, "register": 2 };
Object.freeze(FormTypeEnum);

var ERROR_SERVER = 'ERROR_SERVER'; // -> 500 status code
var ERROR_AUTHENTICATION = 'ERROR_AUTHENTICATION'; // -> 401 status code
var ERROR_PERMISSION = 'ERROR_PERMISSION'; // -> 403 status code
var ERROR_REQUEST = 'ERROR_REQUEST'; // -> 404 status code / everything else
var ERROR_NONE = 'ERROR_NONE'; // -> 404 status code / everything else

var ServerErrors = {
    ERROR_AUTHENTICATION: ERROR_AUTHENTICATION,
    ERROR_SERVER: ERROR_SERVER,
    ERROR_PERMISSION: ERROR_PERMISSION,
    ERROR_REQUEST: ERROR_REQUEST,
    ERROR_NONE: ERROR_NONE
};



/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_constants__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RequestStatus = function () {
    function RequestStatus() {
        var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var failure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var pending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var failureType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils_constants__["b" /* ServerErrors */].ERROR_NONE;

        _classCallCheck(this, RequestStatus);

        this.success = success;
        this.failure = failure;
        this.pending = pending;
        this.failureType = failureType;
    }

    _createClass(RequestStatus, [{
        key: 'toString',
        value: function toString() {
            return 'RequestStatus[ success:' + this.success + ', failure:' + this.failure + ', pending:' + this.pending + ', failureType:' + this.failureType + ' ]';
        }
    }]);

    return RequestStatus;
}();

/* harmony default export */ __webpack_exports__["a"] = (RequestStatus);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_js_utils_api__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_onboarding_Landing__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_engagement_EngagementLayout__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_engagement_dashboard_Dashboard__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_engagement_alerts_AlertHome__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ErrorNotFound__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_engagement_related_AlertHome__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_engagement_cachedterms_CachedTerms__ = __webpack_require__(803);






// components








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_5__components_onboarding_Landing__["a" /* default */],
        redirect: '/public'

    }, {
        path: '/public',
        component: __WEBPACK_IMPORTED_MODULE_5__components_onboarding_Landing__["a" /* default */]
    }, {
        path: '/error',
        component: __WEBPACK_IMPORTED_MODULE_5__components_onboarding_Landing__["a" /* default */],
        meta: { isPublic: true }
    }, {
        path: '/engagement',
        component: __WEBPACK_IMPORTED_MODULE_6__components_engagement_EngagementLayout__["a" /* default */],
        name: 'dashboard-home',
        redirect: '/engagement/dashboard',
        meta: { requiresAuth: true }
    }, {
        path: '/engagement',
        component: __WEBPACK_IMPORTED_MODULE_6__components_engagement_EngagementLayout__["a" /* default */],
        redirect: '/engagement/dashboard',
        meta: { requiresAuth: true },
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: __WEBPACK_IMPORTED_MODULE_7__components_engagement_dashboard_Dashboard__["a" /* default */]
        }, {
            path: 'alerts',
            name: 'Alerts',
            component: __WEBPACK_IMPORTED_MODULE_8__components_engagement_alerts_AlertHome__["a" /* default */]
        }, {
            path: 'cached',
            name: 'Cached Terms',
            component: __WEBPACK_IMPORTED_MODULE_11__components_engagement_cachedterms_CachedTerms__["a" /* default */]
        }, {
            path: 'related',
            name: 'Related Terms',
            component: __WEBPACK_IMPORTED_MODULE_10__components_engagement_related_AlertHome__["a" /* default */]
        }]
    }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_9__components_common_ErrorNotFound__["a" /* default */] }]
});

router.beforeResolve(function (to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {
        console.log(to.path + ' requires auth');

        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!Object(__WEBPACK_IMPORTED_MODULE_4_src_js_utils_api__["b" /* isLoggedIn */])()) {
            next({
                path: '/'
            });
        } else {
            next();
        }
    } else if (!to.matched.some(function (record) {
        return record.meta.isPublic;
    }) && Object(__WEBPACK_IMPORTED_MODULE_4_src_js_utils_api__["b" /* isLoggedIn */])()) {
        next({
            path: '/engagement'
        });
    } else {
        next();
    }
    // next(false)
    // next('/')
    // next({ path: '/' }) //  normal path object (incl replace ...)
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_trends__ = __webpack_require__(379);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
        trends: __WEBPACK_IMPORTED_MODULE_4__modules_trends__["a" /* default */]
    },
    strict: debug,
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
        paths: ['user', 'trends']
    })]
}));

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_real__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_standalone__ = __webpack_require__(377);


console.dir(__WEBPACK_IMPORTED_MODULE_1__api_standalone__["a" /* api */]);

var isStandaloneClient = true;

if (isStandaloneClient) {
    //export default standaloneClient;
} else {
        //export default realClient;
    }

var isLoggedIn = isStandaloneClient ? __WEBPACK_IMPORTED_MODULE_1__api_standalone__["b" /* isLoggedIn */] : __WEBPACK_IMPORTED_MODULE_0__api_real__["b" /* isLoggedIn */];
var logoutUser = isStandaloneClient ? __WEBPACK_IMPORTED_MODULE_1__api_standalone__["c" /* logoutUser */] : __WEBPACK_IMPORTED_MODULE_0__api_real__["c" /* logoutUser */];
var api = isStandaloneClient ? __WEBPACK_IMPORTED_MODULE_1__api_standalone__["a" /* api */] : __WEBPACK_IMPORTED_MODULE_0__api_real__["a" /* api */];



/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeDataArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aggregateDataArray; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function normalizeData(graphdata) {
    //console.time("normalizeData")
    var max = Object.values(graphdata).reduce(function (max, current) {
        return current > max ? current : max;
    }, -1);
    var normalizeFactor = 1 / (max / 100);
    var normalized = Object.keys(graphdata).reduce(function (previous, current) {
        previous[current] = Math.round(graphdata[current] * normalizeFactor);
        return previous;
    }, {});
    //console.timeEnd("normalizeData")
    return normalized;
}

function normalizeDataArray(dataArray) {
    var normalizedArray = dataArray.map(function (value) {
        return Object.assign({}, value, { data: normalizeData(value.data) });
    });
    return normalizedArray;
}

function median(values) {
    values = values.slice(0).sort(function (a, b) {
        return a - b;
    });

    return middle(values);
}

function middle(values) {
    var len = values.length;
    var half = Math.floor(len / 2);

    if (len % 2) return (values[half - 1] + values[half]) / 2.0;else return values[half];
}

function calculateMinMaxAvgMedianOfData(graphdata) {
    var values = Object.values(graphdata);
    var min = parseInt(Math.min.apply(Math, _toConsumableArray(values)), 10);
    var max = parseInt(Math.max.apply(Math, _toConsumableArray(values)), 10);
    var sum = 0;
    for (var i = 0; i < values.length; i++) {
        sum += parseInt(values[i], 10); //don't forget to add the base
    }
    var avg = parseInt(sum / values.length, 10);
    var _median = parseInt(median(values), 10);

    return Object.assign({}, {
        min: min,
        max: max,
        avg: avg,
        median: _median
    });
}

function aggregateDataArray(dataArray) {
    var additionalDataArray = dataArray.map(function (value) {
        return Object.assign({}, value, calculateMinMaxAvgMedianOfData(value.data));
    });
    return additionalDataArray;
}



/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CURRENT_QUERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_CURRENT_QUERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TREND_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRENDS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CACHED_TRENDS_SET; });
var USER_SET = 'USER_SET';
var USER_CLEAR = 'USER_CLEAR';
var SET_CURRENT_QUERIES = 'SET_CURRENT_QUERIES';
var CLEAR_CURRENT_QUERIES = 'CLEAR_CURRENT_QUERIES';

var TREND_ADD = 'TREND_ADD';
var TRENDS_CLEAR = 'TRENDS_CLEAR';
var CACHED_TRENDS_SET = 'CACHED_TRENDS_SET';

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMailValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPasswordValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNameValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPasswordStrength; });
var emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
var smallCharRegex = /[a-z]+/;
var capitalCharRegex = /[A-Z]+/;
var numberCharRegex = /[0-9]+/;
var specialCharRegex = /[^A-Za-z0-9]+/;

// calculates the strength of a password and returns the strength on a scale from
// 0 to 8 where 8 is a very strong password and 0 a very weak one
var getPasswordStrength = function getPasswordStrength(password) {
  var strength = 0;

  if (password.length > 0) {
    strength += smallCharRegex.test(password); // contains a-z
    strength += capitalCharRegex.test(password); // contains A-Z
    strength += numberCharRegex.test(password); // contains 0-9
    strength += specialCharRegex.test(password); // contains special character
    strength += Math.floor(Math.min(4, password.length / 3)); // 0-12 characters result in 0-4 points
  }
  return strength;
};

var isMailValid = function isMailValid(mail) {
  return mail.length > 0 && emailRegex.test(mail);
};
var isPasswordValid = function isPasswordValid(password) {
  return password.length > 4;
};
var isNameValid = function isNameValid(name) {
  return name.length > 2;
};



/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_engagement_common_sidebar__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globalComponents__ = __webpack_require__(821);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__components_engagement_common_sidebar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__globalComponents__["a" /* default */]);

// stores current route in store 
var unsync = Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
    }
});

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1614f88e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1614f88e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(342);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("76e90e64", content, true);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports
exports.i(__webpack_require__(343), "");

// module
exports.push([module.i, "\n/*!\n\n =========================================================\n * Paper Dashboard - v1.1.2\n =========================================================\n\n * Product Page: http://www.creative-tim.com/product/paper-dashboard\n * Copyright 2017 Creative Tim (http://www.creative-tim.com)\n * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */.brand,.h1,.h2,.h3,.h4,.h5,.h6,.navbar,.td-name,a,h1,h2,h3,h4,h5,h6,p,td{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Muli,Helvetica,Arial,sans-serif}.h1,.h2,.h3,.h4,h1,h2,h3,h4{font-weight:400;margin:30px 0 15px}.h1,h1{font-size:3.2em}.h2,h2{font-size:2.6em}.h3,h3{font-size:1.825em;line-height:1.4;margin:20px 0 10px}.h4,h4{font-size:1.5em;font-weight:600;line-height:1.2em}.h5,h5{font-size:1.25em;font-weight:400;line-height:1.4em;margin-bottom:15px}.h6,h6{font-size:.9em;font-weight:600;text-transform:uppercase}p{font-size:16px;line-height:1.4em}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{color:#9a9a9a;font-weight:300;line-height:1.4em}h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:60%}.title-uppercase{text-transform:uppercase}blockquote{font-style:italic}blockquote small{font-style:normal}.text-muted{color:#ddd}.text-primary,.text-primary:hover{color:#427c89}.text-info,.text-info:hover{color:#3091b2}.text-success,.text-success:hover{color:#229863}.text-warning,.text-warning:hover{color:#bb992f}.text-danger,.text-danger:hover{color:#b33c12}.glyphicon{line-height:1}strong{color:#403d39}.icon-primary{color:#7a9e9f}.icon-info{color:#68b3c8}.icon-success{color:#41b883}.icon-warning{color:#f3bb45}.icon-danger{color:#eb5e28}.chart-legend .text-primary,.chart-legend .text-primary:hover{color:#7a9e9f}.chart-legend .text-info,.chart-legend .text-info:hover{color:#68b3c8}.chart-legend .text-success,.chart-legend .text-success:hover{color:#41b883}.chart-legend .text-warning,.chart-legend .text-warning:hover{color:#f3bb45}.chart-legend .text-danger,.chart-legend .text-danger:hover{color:#eb5e28}body{color:#66615b;font-size:14px;font-family:Muli,Arial,sans-serif}body .wrapper{min-height:100vh;position:relative}a{color:#68b3c8}a:focus,a:hover{color:#3091b2;text-decoration:none}a:active,a:focus,button::-moz-focus-inner,input::-moz-focus-inner,input[type=file]>input[type=button]::-moz-focus-inner,select::-moz-focus-inner{outline:0!important}.navbar-toggle,.ui-slider-handle:focus,button:focus,input:focus{outline:0!important}.navbar.navbar-default{z-index:2}.form-control,.input-group-addon,.navbar,.navbar .alert,.tagsinput{-webkit-transition:all .3s linear;-moz-transition:all .3s linear;-o-transition:all .3s linear;-ms-transition:all .3s linear;transition:all .3s linear}.sidebar .nav a,.table>tbody>tr .td-actions .btn{-webkit-transition:all .15s ease-in;-moz-transition:all .15s ease-in;-o-transition:all .15s ease-in;-ms-transition:all .15s ease-in;transition:all .15s ease-in}.btn{-webkit-transition:all .1s ease-in;-moz-transition:all .1s ease-in;-o-transition:all .1s ease-in;-ms-transition:all .1s ease-in;transition:all .1s ease-in}.fa{width:21px;text-align:center}.fa-base{font-size:1.25em!important}.margin-top{margin-top:50px}hr{border-color:#f1eae0}.wrapper{position:relative;top:0;height:100vh}@media (min-width:992px){.typo-line{padding-left:140px;margin-bottom:40px;position:relative}.typo-line .category{transform:translateY(-50%);top:50%;left:0;position:absolute}}.icon-section{margin:0 0 3em;clear:both;overflow:hidden}.icon-container{width:240px;padding:.7em 0;float:left;position:relative;text-align:left}.icon-container [class*=\" ti-\"],.icon-container [class^=ti-]{color:#000;position:absolute;margin-top:3px;transition:.3s}.icon-container:hover [class*=\" ti-\"],.icon-container:hover [class^=ti-]{font-size:2.2em;margin-top:-5px}.icon-container:hover .icon-name{color:#000}.icon-name{color:#aaa;margin-left:35px;font-size:.8em;transition:.3s}.icon-container:hover .icon-name{margin-left:45px}.places-buttons .btn{margin-bottom:30px}.sidebar .nav>li.active-pro{position:absolute;width:100%;bottom:10px}.sidebar .nav>li.active-pro a{background:hsla(0,0%,100%,.14);opacity:1;color:#fff}.table-upgrade td:nth-child(2),.table-upgrade td:nth-child(3){text-align:center}.sidebar{position:fixed;top:0;bottom:0;left:0;z-index:1;background-size:cover;background-position:50%}.sidebar .sidebar-wrapper{position:relative;height:100%;overflow-y:auto;overflow-x:hidden;width:260px;z-index:4;box-shadow:inset -1px 0 0 0 #ddd}.sidebar .sidebar-background{position:absolute;z-index:1;height:100%;width:100%;display:block;top:0;left:0;background-size:cover;background-position:50%}.off-canvas-sidebar,.sidebar{width:260px;display:block;font-weight:200}.off-canvas-sidebar .logo,.sidebar .logo{padding:13px 0;margin:0 20px}.off-canvas-sidebar .logo p,.sidebar .logo p{float:left;font-size:20px;margin:10px;line-height:20px}.off-canvas-sidebar .logo .simple-text,.sidebar .logo .simple-text{padding:4px 0;display:block;font-size:14px;text-align:center;font-weight:600;line-height:40px;text-align:left}.off-canvas-sidebar .logo .simple-text .logo-img,.sidebar .logo .simple-text .logo-img{width:40px;display:inline-block;height:40px;margin-left:0;margin-right:10px;background:#fff;border-radius:40px;text-align:center}.off-canvas-sidebar .logo .simple-text .logo-img img,.sidebar .logo .simple-text .logo-img img{max-width:35px}.off-canvas-sidebar .nav li>a,.sidebar .nav li>a{margin:10px 0;padding-left:25px;padding-right:25px;opacity:.7}.off-canvas-sidebar .nav li:hover>a,.sidebar .nav li:hover>a{opacity:1}.off-canvas-sidebar .nav li.active>a,.sidebar .nav li.active>a{color:#7a9e9f;opacity:1}.off-canvas-sidebar .nav p,.sidebar .nav p{margin:0;line-height:30px;font-size:12px;font-weight:600;text-transform:uppercase}.off-canvas-sidebar .nav i,.sidebar .nav i{font-size:24px;float:left;margin-right:15px;line-height:30px;width:30px;text-align:center}.off-canvas-sidebar:after,.off-canvas-sidebar:before,.sidebar:after,.sidebar:before{display:block;content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;z-index:2;background:#fff}.off-canvas-sidebar:after,.off-canvas-sidebar:before,.off-canvas-sidebar[data-background-color=white]:after,.off-canvas-sidebar[data-background-color=white]:before,.sidebar:after,.sidebar:before,.sidebar[data-background-color=white]:after,.sidebar[data-background-color=white]:before{background-color:#fff}.off-canvas-sidebar #style-3::-webkit-scrollbar-track,.off-canvas-sidebar[data-background-color=white] #style-3::-webkit-scrollbar-track,.sidebar #style-3::-webkit-scrollbar-track,.sidebar[data-background-color=white] #style-3::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px #fff;background-color:#fff}.off-canvas-sidebar #style-3::-webkit-scrollbar,.off-canvas-sidebar[data-background-color=white] #style-3::-webkit-scrollbar,.sidebar #style-3::-webkit-scrollbar,.sidebar[data-background-color=white] #style-3::-webkit-scrollbar{width:6px;background-color:#66615b}.off-canvas-sidebar #style-3::-webkit-scrollbar-thumb,.off-canvas-sidebar[data-background-color=white] #style-3::-webkit-scrollbar-thumb,.sidebar #style-3::-webkit-scrollbar-thumb,.sidebar[data-background-color=white] #style-3::-webkit-scrollbar-thumb{background-color:#fff}.off-canvas-sidebar .logo,.off-canvas-sidebar[data-background-color=white] .logo,.sidebar .logo,.sidebar[data-background-color=white] .logo{border-bottom:1px solid rgba(102,97,91,.3)}.off-canvas-sidebar .logo .simple-text,.off-canvas-sidebar .logo p,.off-canvas-sidebar .nav li:not(.active)>a,.off-canvas-sidebar[data-background-color=white] .logo .simple-text,.off-canvas-sidebar[data-background-color=white] .logo p,.off-canvas-sidebar[data-background-color=white] .nav li:not(.active)>a,.sidebar .logo .simple-text,.sidebar .logo p,.sidebar .nav li:not(.active)>a,.sidebar[data-background-color=white] .logo .simple-text,.sidebar[data-background-color=white] .logo p,.sidebar[data-background-color=white] .nav li:not(.active)>a{color:#66615b}.off-canvas-sidebar .nav .divider,.off-canvas-sidebar[data-background-color=white] .nav .divider,.sidebar .nav .divider,.sidebar[data-background-color=white] .nav .divider{background-color:rgba(102,97,91,.2)}.off-canvas-sidebar[data-background-color=black]:after,.off-canvas-sidebar[data-background-color=black]:before,.sidebar[data-background-color=black]:after,.sidebar[data-background-color=black]:before{background-color:#212120}.off-canvas-sidebar[data-background-color=black] #style-3::-webkit-scrollbar-track,.sidebar[data-background-color=black] #style-3::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px #212120;background-color:#212120}.off-canvas-sidebar[data-background-color=black] #style-3::-webkit-scrollbar,.sidebar[data-background-color=black] #style-3::-webkit-scrollbar{width:6px;background-color:#fff}.off-canvas-sidebar[data-background-color=black] #style-3::-webkit-scrollbar-thumb,.sidebar[data-background-color=black] #style-3::-webkit-scrollbar-thumb{background-color:#212120}.off-canvas-sidebar[data-background-color=black] .logo,.sidebar[data-background-color=black] .logo{border-bottom:1px solid hsla(0,0%,100%,.3)}.off-canvas-sidebar[data-background-color=black] .logo .simple-text,.off-canvas-sidebar[data-background-color=black] .logo p,.off-canvas-sidebar[data-background-color=black] .nav li:not(.active)>a,.sidebar[data-background-color=black] .logo .simple-text,.sidebar[data-background-color=black] .logo p,.sidebar[data-background-color=black] .nav li:not(.active)>a{color:#fff}.off-canvas-sidebar[data-background-color=black] .nav .divider,.sidebar[data-background-color=black] .nav .divider{background-color:hsla(0,0%,100%,.2)}.off-canvas-sidebar[data-background-color=darkblue]:after,.off-canvas-sidebar[data-background-color=darkblue]:before,.sidebar[data-background-color=darkblue]:after,.sidebar[data-background-color=darkblue]:before{background-color:#35495e}.off-canvas-sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar-track,.sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px #35495e;background-color:#35495e}.off-canvas-sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar,.sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar{width:6px;background-color:#fff}.off-canvas-sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar-thumb,.sidebar[data-background-color=darkblue] #style-3::-webkit-scrollbar-thumb{background-color:#35495e}.off-canvas-sidebar[data-background-color=darkblue] .logo,.sidebar[data-background-color=darkblue] .logo{border-bottom:1px solid hsla(0,0%,100%,.3)}.off-canvas-sidebar[data-background-color=darkblue] .logo .simple-text,.off-canvas-sidebar[data-background-color=darkblue] .logo p,.off-canvas-sidebar[data-background-color=darkblue] .nav li:not(.active)>a,.sidebar[data-background-color=darkblue] .logo .simple-text,.sidebar[data-background-color=darkblue] .logo p,.sidebar[data-background-color=darkblue] .nav li:not(.active)>a{color:#fff}.off-canvas-sidebar[data-background-color=darkblue] .nav .divider,.sidebar[data-background-color=darkblue] .nav .divider{background-color:hsla(0,0%,100%,.2)}.off-canvas-sidebar[data-background-color=pretrendr]:after,.off-canvas-sidebar[data-background-color=pretrendr]:before,.sidebar[data-background-color=pretrendr]:after,.sidebar[data-background-color=pretrendr]:before{background-color:#053948}.off-canvas-sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar-track,.sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px #053948;background-color:#053948}.off-canvas-sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar,.sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar{width:6px;background-color:#fff}.off-canvas-sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar-thumb,.sidebar[data-background-color=pretrendr] #style-3::-webkit-scrollbar-thumb{background-color:#053948}.off-canvas-sidebar[data-background-color=pretrendr] .logo,.sidebar[data-background-color=pretrendr] .logo{border-bottom:1px solid hsla(0,0%,100%,.3)}.off-canvas-sidebar[data-background-color=pretrendr] .logo .simple-text,.off-canvas-sidebar[data-background-color=pretrendr] .logo p,.off-canvas-sidebar[data-background-color=pretrendr] .nav li:not(.active)>a,.sidebar[data-background-color=pretrendr] .logo .simple-text,.sidebar[data-background-color=pretrendr] .logo p,.sidebar[data-background-color=pretrendr] .nav li:not(.active)>a{color:#fff}.off-canvas-sidebar[data-background-color=pretrendr] .nav .divider,.sidebar[data-background-color=pretrendr] .nav .divider{background-color:hsla(0,0%,100%,.2)}.off-canvas-sidebar[data-active-color=primary] .nav li.active>a,.sidebar[data-active-color=primary] .nav li.active>a{color:#7a9e9f;opacity:1}.off-canvas-sidebar[data-active-color=info] .nav li.active>a,.sidebar[data-active-color=info] .nav li.active>a{color:#68b3c8;opacity:1}.off-canvas-sidebar[data-active-color=success] .nav li.active>a,.sidebar[data-active-color=success] .nav li.active>a{color:#41b883;opacity:1}.off-canvas-sidebar[data-active-color=warning] .nav li.active>a,.sidebar[data-active-color=warning] .nav li.active>a{color:#f3bb45;opacity:1}.off-canvas-sidebar[data-active-color=danger] .nav li.active>a,.sidebar[data-active-color=danger] .nav li.active>a{color:#eb5e28;opacity:1}.off-canvas-sidebar[data-active-color=pretrendr] .nav li.active>a,.sidebar[data-active-color=pretrendr] .nav li.active>a{color:#e96772;opacity:1}.main-panel{background-color:#f8f8f8;position:relative;z-index:2;float:right;width:calc(100% - 260px);min-height:100%}.main-panel>.content{padding:30px 15px;min-height:calc(100% - 123px)}.main-panel>.footer{border-top:1px solid rgba(0,0,0,.1)}.main-panel .navbar{margin-bottom:0}.main-panel,.sidebar{-webkit-transition-property:top,bottom;transition-property:top,bottom;-webkit-transition-duration:.2s,.2s;transition-duration:.2s,.2s;-webkit-transition-timing-function:linear,linear;transition-timing-function:linear,linear;-webkit-overflow-scrolling:touch}.sidebar{max-height:100%;height:100%;overflow:hidden;overflow-y:hidden}.form-control:-moz-placeholder,.form-control::-moz-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.form-control::-webkit-input-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.form-control:-ms-input-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.form-control{background-color:#fffcf5;border:medium none;border-radius:4px;color:#66615b;font-size:14px;transition:background-color .3s ease 0s;padding:7px 18px;height:40px}.form-control,.form-control:focus{-webkit-box-shadow:none;box-shadow:none}.form-control:focus{background-color:#fff;outline:0!important}.has-error .form-control,.has-error .form-control:focus,.has-success .form-control,.has-success .form-control:focus{-webkit-box-shadow:none;box-shadow:none}.has-success .form-control{background-color:#abf3cb;color:#41b883}.has-success .form-control.border-input{border:1px solid #41b883}.has-success .form-control:focus{background-color:#fff}.has-error .form-control{background-color:#ffc0a4;color:#eb5e28}.has-error .form-control.border-input{border:1px solid #eb5e28}.has-error .form-control:focus{background-color:#fff}.form-control+.form-control-feedback{border-radius:6px;font-size:14px;margin-top:-7px;position:absolute;right:10px;top:50%;vertical-align:middle}.form-control.border-input{border:1px solid #ccc5b9}.open .form-control{border-bottom-color:transparent}.input-lg{height:55px;padding:11px 30px}.has-error .control-label,.has-error .form-control-feedback{color:#eb5e28}.has-success .control-label,.has-success .form-control-feedback{color:#41b883}.input-group-addon{background-color:#fffcf5;border:medium none;border-radius:4px}.has-error .input-group-addon,.has-success .input-group-addon{background-color:#fff}.has-error .form-control:focus+.input-group-addon{color:#eb5e28}.has-success .form-control:focus+.input-group-addon{color:#41b883}.form-control:focus+.input-group-addon,.form-control:focus~.input-group-addon{background-color:#fff}.border-input .input-group-addon{border:1px solid #ccc5b9}.input-group{margin-bottom:15px}.input-group[disabled] .input-group-addon{background-color:#e3e3e3}.input-group-addon:first-child,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-right:0 none}.input-group-addon:last-child,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-left:0 none}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#e3e3e3;cursor:not-allowed;color:#9a9a9a;opacity:1;filter:alpha(opacity=100)}.form-control[disabled]::-moz-placeholder{color:#9a9a9a;opacity:1;filter:alpha(opacity=100)}.form-control[disabled]:-moz-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.form-control[disabled]::-webkit-input-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.form-control[disabled]:-ms-input-placeholder{color:#ddd;opacity:1;filter:alpha(opacity=100)}.input-group-btn .btn{border-width:1px;padding:9px 18px}.input-group-btn .btn-default:not(.btn-fill){border-color:#ddd}.input-group-btn:last-child>.btn{margin-left:0}textarea.form-control{max-width:100%;padding:10px 18px;resize:none}.alert{border:0;border-radius:0;color:#fff;padding:10px 15px;font-size:14px}.container .alert{border-radius:4px}.navbar .alert{border-radius:0;left:0;position:absolute;right:0;top:85px;width:100%;z-index:3}.navbar:not(.navbar-transparent) .alert{top:70px}.alert span[data-notify=icon]{font-size:30px;display:block;left:15px;position:absolute;top:50%;margin-top:-20px}.alert .close~span{display:block;max-width:89%}.alert[data-notify=container]{padding:10px 10px 10px 20px;border-radius:4px}.alert.alert-with-icon{padding-left:65px}.alert-info{background-color:#7ce4fe;color:#3091b2}.alert-success{background-color:#8ef3c5;color:#229863}.alert-warning{background-color:#ffe28c;color:#bb992f}.alert-danger{background-color:#ff8f5e;color:#b33c12}.table tbody tr>td,.table tbody tr>th,.table tfoot tr>td,.table tfoot tr>th,.table thead tr>td,.table thead tr>th{border-top:1px solid #ccc5b9}.table>thead>tr>th{border-bottom-width:0;font-size:1.25em;font-weight:300}.table .checkbox,.table .radio{margin-top:0;margin-bottom:22px;padding:0;width:15px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:12px;vertical-align:middle}.table .th-description{max-width:150px}.table .td-price{font-size:26px;font-weight:300;margin-top:5px;text-align:right}.table .td-total{font-weight:600;font-size:1.25em;padding-top:20px;text-align:right}.table .td-actions .btn.btn-sm,.table .td-actions .btn.btn-xs{padding-left:3px;padding-right:3px}.table>tbody>tr{position:relative}.table-striped tbody>tr:nth-of-type(odd){background-color:#fff}.table-striped tbody>tr:nth-of-type(2n){background-color:#fffcf5}.table-striped>tbody>tr>td,.table-striped>tbody>tr>th,.table-striped>tfoot>tr>td,.table-striped>tfoot>tr>th,.table-striped>thead>tr>td,.table-striped>thead>tr>th{padding:15px 8px}.checkbox,.radio{margin-bottom:12px;padding-left:30px;position:relative;-webkit-transition:color,opacity .25s linear;transition:color,opacity .25s linear;font-size:14px;font-weight:400;line-height:1.5;color:#66615b;cursor:pointer}.checkbox .icons,.radio .icons{color:#66615b;display:block;height:20px;left:0;position:absolute;top:0;width:20px;text-align:center;line-height:21px;font-size:20px;cursor:pointer;-webkit-transition:color,opacity .15s linear;transition:color,opacity .15s linear;opacity:.5}.checkbox.checked .icons,.radio.checked .icons{opacity:1}.checkbox input,.radio input{outline:none!important;display:none}.checkbox label,.radio label{padding-left:10px}.checkbox .icons .first-icon,.checkbox .icons .second-icon,.radio .icons .first-icon,.radio .icons .second-icon{display:inline-table;position:absolute;left:0;top:0;background-color:transparent;margin:0;opacity:1;filter:alpha(opacity=100)}.checkbox .icons .second-icon,.radio .icons .second-icon{opacity:0;filter:alpha(opacity=0)}.checkbox:hover,.radio:hover{-webkit-transition:color .2s linear;transition:color .2s linear}.checkbox:hover .first-icon,.radio:hover .first-icon{opacity:0;filter:alpha(opacity=0)}.checkbox:hover .second-icon,.radio:hover .second-icon{opacity:1;filter:alpha(opacity=100)}.checkbox.checked .first-icon,.radio.checked .first-icon{opacity:0;filter:alpha(opacity=0)}.checkbox.checked .second-icon,.radio.checked .second-icon{opacity:1;filter:alpha(opacity=100);-webkit-transition:color .2s linear;transition:color .2s linear}.checkbox.disabled,.radio.disabled{cursor:default;color:#ddd}.checkbox.disabled .icons,.radio.disabled .icons{color:#ddd}.checkbox.disabled .first-icon,.radio.disabled .first-icon{opacity:1;filter:alpha(opacity=100)}.checkbox.disabled .second-icon,.radio.disabled .second-icon{opacity:0;filter:alpha(opacity=0)}.checkbox.disabled.checked .icons,.radio.disabled.checked .icons{color:#ddd}.checkbox.disabled.checked .first-icon,.radio.disabled.checked .first-icon{opacity:0;filter:alpha(opacity=0)}.checkbox.disabled.checked .second-icon,.radio.disabled.checked .second-icon{opacity:1;color:#ddd;filter:alpha(opacity=100)}.nav>li>a:focus,.nav>li>a:hover{background-color:transparent}.navbar{border:0;border-radius:0;font-size:16px;z-index:0}.navbar .navbar-brand{font-weight:600;margin:5px 0;padding:20px 15px;font-size:20px}.navbar .navbar-nav>li>a{line-height:1.42857;margin:15px 0;padding:10px 15px}.navbar .navbar-nav>li>a i,.navbar .navbar-nav>li>a p{display:inline-block;margin:0}.navbar .navbar-nav>li>a i{position:relative;top:1px}.navbar .navbar-nav>li>a.btn{margin:15px 3px;padding:7px 18px}.navbar .btn{margin:15px 3px;font-size:14px}.navbar .btn-simple{font-size:16px}.navbar-nav>li>.dropdown-menu{border-radius:6px;margin-top:-5px}.navbar-default{background-color:#f8f8f8;border-bottom:1px solid #ddd}.navbar-default .brand{color:#66615b!important}.navbar-default .navbar-nav>li>a:not(.btn){color:#9a9a9a}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:not(.btn):focus,.navbar-default .navbar-nav>.active>a:not(.btn):hover,.navbar-default .navbar-nav>li>a:not(.btn):focus,.navbar-default .navbar-nav>li>a:not(.btn):hover{background-color:transparent;border-radius:3px;color:#68b3c8;opacity:1;filter:alpha(opacity=100)}.navbar-default .navbar-nav>.dropdown>a:focus .caret,.navbar-default .navbar-nav>.dropdown>a:hover .caret{border-bottom-color:#68b3c8;border-top-color:#68b3c8}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:transparent;color:#68b3c8}.navbar-default .navbar-nav .navbar-toggle:focus,.navbar-default .navbar-nav .navbar-toggle:hover{background-color:transparent}.navbar-default:not(.navbar-transparent) .btn-default:hover{color:#68b3c8;border-color:#68b3c8}.navbar-default:not(.navbar-transparent) .btn-neutral,.navbar-default:not(.navbar-transparent) .btn-neutral:active,.navbar-default:not(.navbar-transparent) .btn-neutral:hover{color:#9a9a9a}.navbar-form{-webkit-box-shadow:none;box-shadow:none}.navbar-form .form-control{border-radius:0;border:0;padding:0;background-color:transparent;height:22px;font-size:16px;line-height:1.4em;color:#e3e3e3}.navbar-transparent .navbar-form .form-control,[class*=navbar-ct] .navbar-form .form-control{color:#fff;border:0;border-bottom:1px solid hsla(0,0%,100%,.6)}.navbar-ct-primary{background-color:#8ecfd5}.navbar-ct-info{background-color:#7ce4fe}.navbar-ct-success{background-color:#8ef3c5}.navbar-ct-warning{background-color:#ffe28c}.navbar-ct-danger{background-color:#ff8f5e}.navbar-transparent{padding-top:15px;background-color:transparent;border-bottom:1px solid transparent}.navbar-toggle{margin-top:19px;margin-bottom:19px;border:0}.navbar-toggle .icon-bar{background-color:#fff}.navbar-toggle .navbar-collapse,.navbar-toggle .navbar-form{border-color:transparent}.navbar-toggle.navbar-default .navbar-toggle:focus,.navbar-toggle.navbar-default .navbar-toggle:hover{background-color:transparent}.navbar-transparent .navbar-brand,[class*=navbar-ct] .navbar-brand{opacity:.9;filter:alpha(opacity=90)}.navbar-transparent .navbar-brand:focus,.navbar-transparent .navbar-brand:hover,[class*=navbar-ct] .navbar-brand:focus,[class*=navbar-ct] .navbar-brand:hover{background-color:transparent;opacity:1;filter:alpha(opacity=100)}.navbar-transparent .navbar-brand:not([class*=text]),[class*=navbar-ct] .navbar-brand:not([class*=text]){color:#fff}.navbar-transparent .navbar-nav>li>a:not(.btn),[class*=navbar-ct] .navbar-nav>li>a:not(.btn){color:#fff;border-color:#fff;opacity:.8;filter:alpha(opacity=80)}.navbar-transparent .navbar-nav>.active>a:focus:not(.btn),.navbar-transparent .navbar-nav>.active>a:hover:not(.btn),.navbar-transparent .navbar-nav>.active>a:not(.btn),.navbar-transparent .navbar-nav>li>a:focus:not(.btn),.navbar-transparent .navbar-nav>li>a:hover:not(.btn),[class*=navbar-ct] .navbar-nav>.active>a:focus:not(.btn),[class*=navbar-ct] .navbar-nav>.active>a:hover:not(.btn),[class*=navbar-ct] .navbar-nav>.active>a:not(.btn),[class*=navbar-ct] .navbar-nav>li>a:focus:not(.btn),[class*=navbar-ct] .navbar-nav>li>a:hover:not(.btn){background-color:transparent;border-radius:3px;color:#fff;opacity:1;filter:alpha(opacity=100)}.navbar-transparent .navbar-nav .nav>li>a.btn:hover,[class*=navbar-ct] .navbar-nav .nav>li>a.btn:hover{background-color:transparent}.navbar-transparent .navbar-nav>.dropdown>a .caret,.navbar-transparent .navbar-nav>.dropdown>a:focus .caret,.navbar-transparent .navbar-nav>.dropdown>a:hover .caret,[class*=navbar-ct] .navbar-nav>.dropdown>a .caret,[class*=navbar-ct] .navbar-nav>.dropdown>a:focus .caret,[class*=navbar-ct] .navbar-nav>.dropdown>a:hover .caret{border-bottom-color:#fff;border-top-color:#fff}.navbar-transparent .navbar-nav>.open>a,.navbar-transparent .navbar-nav>.open>a:focus,.navbar-transparent .navbar-nav>.open>a:hover,[class*=navbar-ct] .navbar-nav>.open>a,[class*=navbar-ct] .navbar-nav>.open>a:focus,[class*=navbar-ct] .navbar-nav>.open>a:hover{background-color:transparent;color:#fff;opacity:1;filter:alpha(opacity=100)}.navbar-transparent .btn-default,[class*=navbar-ct] .btn-default{color:#fff;border-color:#fff}.navbar-transparent .btn-default.btn-fill,[class*=navbar-ct] .btn-default.btn-fill{color:#9a9a9a;background-color:#fff;opacity:.9;filter:alpha(opacity=90)}.navbar-transparent .btn-default.btn-fill.active,.navbar-transparent .btn-default.btn-fill:active,.navbar-transparent .btn-default.btn-fill:focus,.navbar-transparent .btn-default.btn-fill:hover,.navbar-transparent .open .dropdown-toggle.btn-fill.btn-default,[class*=navbar-ct] .btn-default.btn-fill.active,[class*=navbar-ct] .btn-default.btn-fill:active,[class*=navbar-ct] .btn-default.btn-fill:focus,[class*=navbar-ct] .btn-default.btn-fill:hover,[class*=navbar-ct] .open .dropdown-toggle.btn-fill.btn-default{border-color:#fff;opacity:1;filter:alpha(opacity=100)}.footer{background-attachment:fixed;position:relative;line-height:20px}.footer nav ul{list-style:none;margin:0;padding:0;font-weight:400}.footer nav ul li{display:inline-block;padding:10px 15px;margin:15px 3px;line-height:20px;text-align:center}.footer nav ul a:not(.btn){color:#66615b;display:block;margin-bottom:3px}.footer nav ul a:not(.btn):focus,.footer nav ul a:not(.btn):hover{color:#403d39}.footer .copyright{color:#66615b;font-size:14px;white-space:nowrap;margin:15px 3px;line-height:20px;text-align:center}.footer .heart{color:#eb5e28}.dropdown-menu{background-color:#fffcf5;border:0 none;border-radius:6px;display:block;margin-top:10px;padding:0;position:absolute;visibility:hidden;z-index:9000;opacity:0;filter:alpha(opacity=0);-webkit-box-shadow:0 2px rgba(17,16,15,.1),0 2px 10px rgba(17,16,15,.1);box-shadow:0 2px rgba(17,16,15,.1),0 2px 10px rgba(17,16,15,.1)}.open .dropdown-menu{opacity:1;filter:alpha(opacity=100);visibility:visible}.dropdown-menu .divider{background-color:#f1eae0;margin:0}.dropdown-menu .dropdown-header{color:#9a9a9a;font-size:12px;padding:10px 15px}.select .dropdown-menu{border-radius:0 0 10px 10px;-webkit-box-shadow:none;box-shadow:none;-webkit-transform-origin:50% -40px;-moz-transform-origin:50% -40px;-o-transform-origin:50% -40px;-ms-transform-origin:50% -40px;transform-origin:50% -40px;-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);-ms-transform:scale(1);transform:scale(1);-webkit-transition:all .15s linear;-moz-transition:all .15s linear;-o-transition:all .15s linear;-ms-transition:all .15s linear;transition:all .15s linear;margin-top:-20px}.select.open .dropdown-menu{margin-top:-1px}.dropdown-menu>li>a{color:#66615b;font-size:14px;padding:10px 15px;-webkit-transition:none;-moz-transition:none;-o-transition:none;-ms-transition:none;transition:none}.dropdown-menu>li>a img{margin-top:-3px}.dropdown-menu>li>a:focus{outline:0!important}.btn-group.select .dropdown-menu{min-width:100%}.dropdown-menu>li:first-child>a{border-top-left-radius:6px;border-top-right-radius:6px}.dropdown-menu>li:last-child>a{border-bottom-left-radius:6px;border-bottom-right-radius:6px}.select .dropdown-menu>li:first-child>a{border-radius:0;border-bottom:0 none}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-color:#66615b;color:hsla(0,0%,100%,.7);opacity:1;text-decoration:none}.dropdown-menu.dropdown-primary>li>a:focus,.dropdown-menu.dropdown-primary>li>a:hover{background-color:#7a9e9f}.dropdown-menu.dropdown-info>li>a:focus,.dropdown-menu.dropdown-info>li>a:hover{background-color:#68b3c8}.dropdown-menu.dropdown-success>li>a:focus,.dropdown-menu.dropdown-success>li>a:hover{background-color:#41b883}.dropdown-menu.dropdown-warning>li>a:focus,.dropdown-menu.dropdown-warning>li>a:hover{background-color:#f3bb45}.dropdown-menu.dropdown-danger>li>a:focus,.dropdown-menu.dropdown-danger>li>a:hover{background-color:#eb5e28}.btn-group.select{overflow:hidden}.btn-group.select.open{overflow:visible}.card{border-radius:6px;box-shadow:0 2px 2px hsla(38,16%,76%,.5);background-color:#fff;color:#343a40;margin-bottom:20px;position:relative;z-index:1}.card .image{width:100%;overflow:hidden;height:260px;border-radius:6px 6px 0 0;position:relative;-webkit-transform-style:preserve-3d;-moz-transform-style:preserve-3d;transform-style:preserve-3d}.card .image img{width:100%}.card .content{padding:15px 15px 10px}.card .header{padding:20px 20px 0;font-size:18px}.card .description{font-size:16px;color:#66615b}.card h6{font-size:12px;margin:0}.card .category,.card label{font-size:16px;font-weight:400;color:#343a40;margin-bottom:0}.card .category i,.card label i{font-size:16px}.card label{font-size:15px;margin-bottom:5px}.card .title{margin:0;color:#343a40;font-weight:300}.card .avatar{width:50px;height:50px;overflow:hidden;border-radius:50%;margin-right:5px}.card .footer{padding:0;line-height:30px}.card .footer .legend{padding:5px 0}.card .footer hr{margin-top:5px;margin-bottom:5px}.card .stats{color:#a9a9a9;font-weight:300}.card .stats i{margin-right:2px;min-width:15px}.card .footer div,.card .stats i{display:inline-block}.card .author{font-size:12px;font-weight:600;text-transform:uppercase}.card .author i{font-size:14px}.card.card-separator:after{height:100%;right:-15px;top:0;width:1px;background-color:#ddd;content:\"\";position:absolute}.card .ct-chart{margin:30px 0;height:245px}.card .table tbody td:first-child,.card .table thead th:first-child{padding-left:15px}.card .table tbody td:last-child,.card .table thead th:last-child{padding-right:15px}.card .alert{border-radius:4px;position:relative}.card .alert.alert-with-icon{padding-left:65px}.card .icon-big{font-size:3em;min-height:64px}.card .numbers{font-size:2em;text-align:right}.card .numbers p{margin:0}.card ul.team-members li{padding:10px 0}.card ul.team-members li:not(:last-child){border-bottom:1px solid #f1eae0}.card-user .image{border-radius:8px 8px 0 0;height:150px;position:relative;overflow:hidden}.card-user .image img{width:100%}.card-user .image-plain{height:0;margin-top:110px}.card-user .author{text-align:center;text-transform:none;margin-top:-65px}.card-user .author .title{color:#403d39}.card-user .author .title small{color:#ccc5b9}.card-user .avatar{width:100px;height:100px;border-radius:50%;position:relative;margin-bottom:15px}.card-user .avatar.border-white{border:5px solid #fff}.card-user .avatar.border-gray{border:5px solid #ccc5b9}.card-user .title{font-weight:600;line-height:24px}.card-user .description{margin-top:10px}.card-user .content{min-height:200px}.card-user.card-plain .avatar{height:190px;width:190px}.card-map .map{height:500px;padding-top:20px}.card-map .map>div{height:100%}.card-price .footer,.card-user .footer{padding:5px 15px 10px}.card-price hr,.card-user hr{margin:5px 15px}.card-plain{background-color:transparent;box-shadow:none;border-radius:0}.card-plain .image{border-radius:4px}@media (min-width:992px){.navbar-form{margin-top:21px;margin-bottom:21px;padding-left:5px;padding-right:5px}.navbar-search-form{display:none}.dropdown .dropdown-menu,.navbar-nav>li>.dropdown-menu{transform:translate3d(0,-40px,0);transition:all .3s cubic-bezier(.215,.61,.355,1) 0s,opacity .3s ease 0s,height 0s linear .35s}.dropdown.open .dropdown-menu,.navbar-nav>li.open>.dropdown-menu{transform:translateZ(0)}.navbar-nav>li>.dropdown-menu:before{border-bottom:11px solid #f1eae0;top:-11px}.navbar-nav>li>.dropdown-menu:after,.navbar-nav>li>.dropdown-menu:before{border-left:11px solid transparent;border-right:11px solid transparent;content:\"\";display:inline-block;position:absolute;right:12px}.navbar-nav>li>.dropdown-menu:after{border-bottom:11px solid #fffcf5;top:-10px}.navbar-nav.navbar-left>li>.dropdown-menu:after,.navbar-nav.navbar-left>li>.dropdown-menu:before{right:auto;left:12px}.navbar .navbar-header{margin-left:10px}.footer:not(.footer-big) nav>ul li:first-child{margin-left:0}body .navbar-collapse.collapse.off-canvas-sidebar{display:none!important}.card form [class*=col-]{padding:6px}.card form [class*=col-]:first-child{padding-left:15px}.card form [class*=col-]:last-child{padding-right:15px}}@media (max-width:991px){.sidebar{display:none}.main-panel{width:100%}.navbar-transparent{padding-top:15px;background-color:rgba(0,0,0,.45)}body{position:relative}h6{font-size:1em}.wrapper{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);background-color:#fff}.navbar .container,.wrapper{-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1);left:0}.navbar .container{width:100%;position:relative}.navbar .navbar-collapse.collapsing,.navbar .navbar-collapse.off-canvas-sidebar.collapse,.navbar .navbar-collapse.off-canvas-sidebar.collapse.in,.navbar .navbar-collapse.off-canvas-sidebar.collapsing{display:none!important}.navbar-nav>li{float:none;position:relative;display:block}.off-canvas-sidebar{position:fixed;display:block;top:0;height:100%;width:230px;right:0;z-index:1032;visibility:visible;background-color:#999;overflow-y:visible;border-top:none;text-align:left;padding-right:0;padding-left:0;-webkit-transform:translate3d(230px,0,0);-moz-transform:translate3d(230px,0,0);-o-transform:translate3d(230px,0,0);-ms-transform:translate3d(230px,0,0);transform:translate3d(230px,0,0);-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1)}.off-canvas-sidebar .sidebar-wrapper{position:relative;z-index:3;overflow-y:scroll;height:100%;box-shadow:inset 1px 0 0 0 #ddd}.off-canvas-sidebar .nav{margin-top:0;padding:10px 15px 0}.off-canvas-sidebar .nav>li>a{margin:0;color:#66615b;text-transform:uppercase;font-weight:600;font-size:12px;line-height:1.4em;padding:10px 0}.off-canvas-sidebar .nav>li>a.active,.off-canvas-sidebar .nav>li>a:hover{color:#403d39}.off-canvas-sidebar .nav>li>a .caret,.off-canvas-sidebar .nav>li>a .notification,.off-canvas-sidebar .nav>li>a p{display:inline-block}.off-canvas-sidebar .nav>li>a .caret{float:right;position:relative;top:12px}.off-canvas-sidebar .nav>li>a i{font-size:18px;margin-right:10px;line-height:26px}.off-canvas-sidebar .nav>li.active>a:before{border-left:12px solid #ddd;left:0}.off-canvas-sidebar .nav>li.active>a:after,.off-canvas-sidebar .nav>li.active>a:before{border-right:none;border-top:12px solid transparent;border-bottom:12px solid transparent;right:auto;margin-left:-15px;top:10px}.off-canvas-sidebar .nav>li.active>a:after{border-left:12px solid #f4f3ef;left:-1px}.off-canvas-sidebar:after{background-color:#f4f3ef;background-image:linear-gradient(180deg,transparent 0,hsla(0,0%,44%,0) 60%,hsla(0,0%,73%,.15))}.off-canvas-sidebar.has-image:after,.off-canvas-sidebar:after{top:0;left:0;height:100%;width:100%;position:absolute;display:block;content:\"\";z-index:1}.off-canvas-sidebar.has-image:after{background-color:hsla(0,0%,7%,.8)}.off-canvas-sidebar .logo{position:relative;z-index:4;padding-top:11px;padding-bottom:11px}.off-canvas-sidebar .divider{height:1px;margin:10px 0}.nav-open .navbar-collapse{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.nav-open .navbar .container{left:-230px}.nav-open .wrapper{left:0;-webkit-transform:translate3d(-230px,0,0);-moz-transform:translate3d(-230px,0,0);-o-transform:translate3d(-230px,0,0);-ms-transform:translate3d(-230px,0,0);transform:translate3d(-230px,0,0)}.navbar-toggle .icon-bar{display:block;position:relative;background:#fff;width:24px;height:2px;border-radius:1px;margin:0 auto}.navbar-header .navbar-toggle{margin:10px 15px 10px 0;width:40px;height:40px}.bar1,.bar2,.bar3{outline:1px solid transparent}.bar1{top:0;-webkit-animation:topbar-back .5s linear 0s;-moz-animation:topbar-back .5s linear 0s;animation:topbar-back .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.bar2{opacity:1}.bar3{bottom:0;-webkit-animation:bottombar-back .5s linear 0s;-moz-animation:bottombar-back .5s linear 0s;animation:bottombar-back .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.toggled .bar1{top:6px;-webkit-animation:topbar-x .5s linear 0s;-moz-animation:topbar-x .5s linear 0s;animation:topbar-x .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.toggled .bar2{opacity:0}.toggled .bar3{bottom:6px;-webkit-animation:bottombar-x .5s linear 0s;-moz-animation:bottombar-x .5s linear 0s;animation:bottombar-x .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}@keyframes topbar-x{0%{top:0;transform:rotate(0deg)}45%{top:6px;transform:rotate(145deg)}75%{transform:rotate(130deg)}to{transform:rotate(135deg)}}@-webkit-keyframes topbar-x{0%{top:0;-webkit-transform:rotate(0deg)}45%{top:6px;-webkit-transform:rotate(145deg)}75%{-webkit-transform:rotate(130deg)}to{-webkit-transform:rotate(135deg)}}@-moz-keyframes topbar-x{0%{top:0;-moz-transform:rotate(0deg)}45%{top:6px;-moz-transform:rotate(145deg)}75%{-moz-transform:rotate(130deg)}to{-moz-transform:rotate(135deg)}}@keyframes topbar-back{0%{top:6px;transform:rotate(135deg)}45%{transform:rotate(-10deg)}75%{transform:rotate(5deg)}to{top:0;transform:rotate(0)}}@-webkit-keyframes topbar-back{0%{top:6px;-webkit-transform:rotate(135deg)}45%{-webkit-transform:rotate(-10deg)}75%{-webkit-transform:rotate(5deg)}to{top:0;-webkit-transform:rotate(0)}}@-moz-keyframes topbar-back{0%{top:6px;-moz-transform:rotate(135deg)}45%{-moz-transform:rotate(-10deg)}75%{-moz-transform:rotate(5deg)}to{top:0;-moz-transform:rotate(0)}}@keyframes bottombar-x{0%{bottom:0;transform:rotate(0deg)}45%{bottom:6px;transform:rotate(-145deg)}75%{transform:rotate(-130deg)}to{transform:rotate(-135deg)}}@-webkit-keyframes bottombar-x{0%{bottom:0;-webkit-transform:rotate(0deg)}45%{bottom:6px;-webkit-transform:rotate(-145deg)}75%{-webkit-transform:rotate(-130deg)}to{-webkit-transform:rotate(-135deg)}}@-moz-keyframes bottombar-x{0%{bottom:0;-moz-transform:rotate(0deg)}45%{bottom:6px;-moz-transform:rotate(-145deg)}75%{-moz-transform:rotate(-130deg)}to{-moz-transform:rotate(-135deg)}}@keyframes bottombar-back{0%{bottom:6px;transform:rotate(-135deg)}45%{transform:rotate(10deg)}75%{transform:rotate(-5deg)}to{bottom:0;transform:rotate(0)}}@-webkit-keyframes bottombar-back{0%{bottom:6px;-webkit-transform:rotate(-135deg)}45%{-webkit-transform:rotate(10deg)}75%{-webkit-transform:rotate(-5deg)}to{bottom:0;-webkit-transform:rotate(0)}}@-moz-keyframes bottombar-back{0%{bottom:6px;-moz-transform:rotate(-135deg)}45%{-moz-transform:rotate(10deg)}75%{-moz-transform:rotate(-5deg)}to{bottom:0;-moz-transform:rotate(0)}}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@-moz-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.dropdown-menu .divider{background-color:hsla(0,0%,90%,.15)}.navbar-nav{margin:1px 0}.dropdown-menu{display:none}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-color:transparent}.navbar-fixed-top{-webkit-backface-visibility:hidden}#bodyClick{height:100%;width:100%;position:fixed;opacity:0;top:0;left:auto;right:230px;content:\"\";z-index:9999;overflow-x:hidden}.form-control+.form-control-feedback{margin-top:-8px}.navbar-toggle:focus,.navbar-toggle:hover{background-color:transparent!important}.btn.dropdown-toggle{margin-bottom:0}.media-post .author{width:20%;float:none!important;display:block;margin:0 auto 10px}.media-post .media-body{width:100%}.navbar-collapse.collapse{height:100%!important}.navbar-collapse.collapse.in{display:block}.navbar-header .collapse,.navbar-toggle{display:block!important}.navbar-header{float:none}.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.main-panel>.content{padding-left:0;padding-right:0}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:transparent}.footer .copyright{padding:0 15px;width:100%}}@media (min-width:992px){.table-full-width{margin-left:-15px;margin-right:-15px}.table-responsive{overflow:visible}}@media (max-width:991px){.table-responsive{width:100%;margin-bottom:15px;border:1px solid #ddd;overflow-x:scroll;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-overflow-scrolling:touch}}html{position:relative;min-height:100%}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(107) + ");src:url(" + __webpack_require__(107) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(344) + ") format(\"woff2\"),url(" + __webpack_require__(345) + ") format(\"woff\"),url(" + __webpack_require__(346) + ") format(\"truetype\"),url(" + __webpack_require__(347) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:transparent;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);

// exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app"
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar},attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 354 */,
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_js_router__ = __webpack_require__(43);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








// initial state
// shape: {
//  user:{ },
//  currentSearchQueries: []
// }
var state = {
    user: {
        id: '',
        username: '',
        email: '',
        firstname: '',
        lastname: '',
        authorities: [],
        isLoggedIn: false
    },
    currentSearchQueries: []

    // getters
};var getters = {};

// actions
var actions = {
    clearCurrentSearchQuery: function clearCurrentSearchQuery(_ref) {
        var commit = _ref.commit,
            state = _ref.state;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* CLEAR_CURRENT_QUERIES */]);
            resolve();
        });
    },
    updateCurrentSearchQueries: function updateCurrentSearchQueries(_ref2, queries) {
        var commit = _ref2.commit,
            state = _ref2.state;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_CURRENT_QUERIES */], queries);
            resolve();
        });
    },
    loginUser: function loginUser(_ref3, _ref4) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var username = _ref4.username,
            password = _ref4.password;

        return new Promise(function (resolve, reject) {

            __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* api */].auth.postLogin(username, password).then(function (response) {
                if (response != undefined && response.data != undefined && response.data.id != undefined) {
                    var authorities = [];
                    if (response.data.authorities != undefined && response.data.authorities.size >= 1) {
                        authorities = response.data.authorities.reduce(function (total, item) {
                            total.push(item.authority);
                            return total;
                        }, []);
                    }
                    var userdata = Object.assign({}, {
                        id: response.data.id,
                        username: response.data.username,
                        email: response.data.email,
                        firstname: response.data.firstname,
                        lastname: response.data.lastname,
                        authorities: authorities,
                        isLoggedIn: true
                    });

                    var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        success: true
                    });

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* USER_SET */], userdata);
                    resolve(reqStatus);
                } else {
                    var _reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        failure: true,
                        failureType: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST
                    });

                    reject(_reqStatus);
                }
            }).catch(function (error) {
                var failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_NONE;
                var errorCode = 404;
                if (error && error.response && error.response.status > 0) {
                    errorCode = error.response.status;
                }

                if (errorCode >= 500) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_SERVER;
                } else if (errorCode = 401) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_AUTHENTICATION;
                } else if (errorCode = 403) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_PERMISSION;
                } else {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST;
                }

                var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                    pending: false,
                    failure: true,
                    failureType: failure
                });
                reject(reqStatus);
            });
        });
    },
    registerUser: function registerUser(_ref5, _ref6) {
        var commit = _ref5.commit,
            state = _ref5.state;
        var username = _ref6.username,
            firstname = _ref6.firstname,
            lastname = _ref6.lastname,
            email = _ref6.email,
            password = _ref6.password;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* api */].auth.postRegistration(username, firstname, lastname, email, password).then(function (response) {
                if (response != undefined && response.data != undefined && response.data.id != undefined) {
                    var authorities = [];
                    if (response.data.authorities != undefined && response.data.authorities.size >= 1) {
                        authorities = response.data.authorities.reduce(function (total, item) {
                            total.push(item.authority);
                            return total;
                        }, []);
                    }
                    var userdata = Object.assign({}, {
                        id: response.data.id,
                        username: response.data.username,
                        email: response.data.email,
                        firstname: response.data.firstname,
                        lastname: response.data.lastname,
                        authorities: authorities,
                        isLoggedIn: false
                    });

                    var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        success: true
                    });

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* USER_SET */], userdata);
                    resolve(reqStatus);
                } else {
                    var _reqStatus2 = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        failure: true,
                        failureType: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST
                    });
                    reject(_reqStatus2);
                }
            }).catch(function (error) {
                var failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_NONE;
                var errorCode = 404;
                if (error && error.response && error.response.status > 0) {
                    errorCode = error.response.status;
                }

                if (errorCode >= 500) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_SERVER;
                } else if (errorCode = 401) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_AUTHENTICATION;
                } else if (errorCode = 403) {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_PERMISSION;
                } else {
                    failure = __WEBPACK_IMPORTED_MODULE_1__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST;
                }
                var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_2__models_RequestStatus__["a" /* default */](), {
                    pending: false,
                    failure: true,
                    failureType: failure
                });
                reject(reqStatus);
            });
        });
    },
    logoutUser: function logoutUser(_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state;

        return new Promise(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_api__["c" /* logoutUser */])();
            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* USER_CLEAR */]);
            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* CLEAR_CURRENT_QUERIES */]);
            __WEBPACK_IMPORTED_MODULE_4_src_js_router__["a" /* default */].push({
                path: "/"
            });
            resolve();
        });
    }
};

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* USER_SET */], function (state, user) {
    //set new user
    state.user = Object.assign({}, state.user, user);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* USER_CLEAR */], function (state) {
    //clear user
    state.user = {};
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_CURRENT_QUERIES */], function (state, queries) {
    state.currentSearchQueries = [].concat(_toConsumableArray(queries));
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* CLEAR_CURRENT_QUERIES */], function (state) {
    //clear queries
    state.currentSearchQueries = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store2__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_store__ = __webpack_require__(44);





/******************** Base API / Client Configuration ********************/

var port = "8081/";
var localhostUrl = "http://localhost:" + port;
var stagingUrl = "https://amos-backend-staging.flmuchow.com/";
var liveUrl = "https://amos-backend-prod.flmuchow.com/";

var baseUrl = stagingUrl;
baseUrl = "feature/independent-frontend" && "feature/independent-frontend".includes("master") ? liveUrl : stagingUrl;

function writeAuthToken(token) {
  __WEBPACK_IMPORTED_MODULE_2_store2___default.a.set('authToken', token);
  return token;
}

function getAuthToken() {
  return __WEBPACK_IMPORTED_MODULE_2_store2___default.a.get('authToken');
}

var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: baseUrl
  //baseUrl,
});

if (getAuthToken() && getAuthToken().length > 5) {
  Object.assign(axiosInstance.defaults, {
    headers: {
      'x-auth-token': getAuthToken()
    }
  });
}

// Intercepts all responses, retrieves the x auth token and sets it to all following requests headers!
axiosInstance.interceptors.response.use(function (response) {
  var authToken = getAuthToken();
  if (response.status == 401) {
    console.log("backend session is expired, logout user");
    __WEBPACK_IMPORTED_MODULE_3_src_js_store__["a" /* default */].dispatch('logoutUser').then(function (event) {}).catch();
  } else if (response && response.headers && response.headers['x-auth-token']) {
    var _authToken = writeAuthToken(response.headers['x-auth-token']);
    if (_authToken && _authToken.length > 5) {
      Object.assign(axiosInstance.defaults, {
        headers: {
          'x-auth-token': _authToken
        }
      });
    }
  }

  return response;
}, function (error) {
  console.log(error.response);
  if (error.response.status == 401) {
    console.log("backend session is expired, logout user");
    __WEBPACK_IMPORTED_MODULE_3_src_js_store__["a" /* default */].dispatch('logoutUser').then(function (event) {}).catch();
  }
  return Promise.reject(error);
});
/* unused harmony default export */ var _unused_webpack_default_export = (axiosInstance);

var isLoggedIn = function isLoggedIn() {
  var authToken = getAuthToken() ? getAuthToken() : authToken;
  return authToken && authToken.length > 5;
};

var logoutUser = function logoutUser() {
  writeAuthToken("");
};

/******************** Pretrendr Backend API Endpoints ********************/

/***** auth *****/
var postLogin = function postLogin(username, password) {
  return axiosInstance.post('/auth/login', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
    username: username,
    password: password
  }));
};

var postCompleteRegistration = function postCompleteRegistration(username, password) {
  var firstname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : username;
  var lastname = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : username;
  var email = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : username + "@test.com";
  var address = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "addres1";
  var phone = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "phoneNr";
  return axiosInstance.post('/auth/register', {
    "username": username,
    "password": password,
    "firstname": firstname,
    "lastname": lastname,
    "email": email,
    "address": address,
    "phone": phone
  });
};

var postRegistration = function postRegistration(username, firstname, lastname, email, password) {
  return axiosInstance.post('/auth/register', {
    "username": username,
    "firstname": firstname,
    "lastname": lastname,
    "password": password,
    "email": email
  });
};

var doLogout = function doLogout() {
  return axiosInstance.get('/auth/logout');
};

var auth = {
  postLogin: postLogin,
  postRegistration: postRegistration,
  postCompleteRegistration: postCompleteRegistration,
  doLogout: doLogout
};

/***** user *****/
var getAll = function getAll() {
  return axiosInstance.get('/api/user/getAll');
};

var user = {
  getAll: getAll
};

/***** graph *****/
var getWordcountByDay = function getWordcountByDay(query, method, timerange, normalize) {
  return axiosInstance.get('/api/gdelt/wordcountByDay/' + query + '?' + timerange + '&normalize=' + (normalize ? 'true' : 'false') + '&method=' + method);
};

var graph = {
  getWordcountByDay: getWordcountByDay
};

var uploadDataToFirestore = function uploadDataToFirestore(query, method, timerange, data) {
  var uploadData = {
    query: query,
    method: method,
    timerange: timerange,
    data: data
  };
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('http://localhost:5000/pretrendr-d5939/us-central1/addWordcountData', uploadData);
};

var getWordcountDataFromFirestore = function getWordcountDataFromFirestore(query, method) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:5000/pretrendr-d5939/us-central1/getWordcountData?query=' + query + '&method=' + method);
};

var api = {
  auth: auth,
  user: user,
  graph: graph,
  uploadDataToFirestore: uploadDataToFirestore,
  getWordcountDataFromFirestore: getWordcountDataFromFirestore
};



/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store2__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_assets_wordcounts_trump__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_assets_wordcounts_trump___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_assets_wordcounts_trump__);






var availableTerms = ["trump"];

/******************** Base API / Client Configuration ********************/

function writeAuthToken(token) {
  __WEBPACK_IMPORTED_MODULE_2_store2___default.a.set('authToken', token);
  return token;
}

function getAuthToken() {
  return __WEBPACK_IMPORTED_MODULE_2_store2___default.a.get('authToken');
}

var isLoggedIn = function isLoggedIn() {
  var authToken = getAuthToken() ? getAuthToken() : authToken;
  return authToken && authToken.length > 5;
};

var logoutUser = function logoutUser() {
  writeAuthToken("");
};

/******************** Pretrendr Backend API Endpoints ********************/

/***** auth *****/
var postLogin = function postLogin(username, password) {
  return new Promise(function (resolve, reject) {
    if (username == "user2" && password == "pass2") {
      var response = {
        data: {
          id: 123,
          username: "user2",
          email: "user2@test.de",
          firstname: "John",
          lastname: "Doee",
          authorities: [],
          isLoggedIn: true
        }
      };
      writeAuthToken("loggedIn");
      resolve(response);
    } else {
      var errorResponse = {
        status: 401
      };
      reject(errorResponse);
    }
  });
};
//axiosInstance.post('/auth/login', qs.stringify({
//    username: username,
//    password: password
//}));

var postCompleteRegistration = function postCompleteRegistration(username, password) {
  var firstname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : username;
  var lastname = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : username;
  var email = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : username + "@test.com";
  var address = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "addres1";
  var phone = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "phoneNr";

  return new Promise(function (resolve, reject) {
    var errorResponse = {
      status: 401
    };
    reject(errorResponse);
  });
};
//axiosInstance.post('/auth/register', {
//    "username": username,
//    "password": password,
//    "firstname": firstname,
//    "lastname": lastname,
//    "email": email,
//    "address": address,
//    "phone": phone
//});

var postRegistration = function postRegistration(username, firstname, lastname, email, password) {
  return new Promise(function (resolve, reject) {
    var errorResponse = {
      status: 401
    };
    reject(errorResponse);
  });
};
//axiosInstance.post('/auth/register', {
//    "username": username,
//    "firstname": firstname,
//    "lastname": lastname,
//    "password": password,
//    "email": email,
//});


var auth = {
  postLogin: postLogin,
  postRegistration: postRegistration,
  postCompleteRegistration: postCompleteRegistration
};

var localFirebaseUrl = "http://localhost:5000/pretrendr-d5939/us-central1";
var remoteFirebaseUrl = "https://us-central1-pretrendr-d5939.cloudfunctions.net";
var firebaseUrl = remoteFirebaseUrl;
/***** graph *****/
var getWordcountByDay = function getWordcountByDay(query, method, timerange, normalize) {
  /*return new Promise((resolve, reject)=> {
      if(query.indexOf("trump")>= 0){
          const response = {
              data: trump
          }
          resolve(response)
      }else{
          const errorResponse = {
              status: 404
          }
          reject(errorResponse)
      }
  })*/
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(firebaseUrl + '/getWordcountData?query=' + query + '&method=' + method);

  //axiosInstance.get(`/api/gdelt/wordcountByDay/${query}?${timerange}&normalize=${normalize? 'true': 'false'}&method=${method}`);
};
var uploadDataToFirestore = function uploadDataToFirestore(query, method, timerange, data) {
  var uploadData = {
    query: query,
    method: method,
    timerange: timerange,
    data: data
  };
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(firebaseUrl + '/addWordcountData', uploadData);
};

var getCachedTrends = function getCachedTrends() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(firebaseUrl + '/getAllCachedTerms');
};

var graph = {
  getWordcountByDay: getWordcountByDay,
  getCachedTrends: getCachedTrends
};

var api = {
  auth: auth,
  graph: graph
};



/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = {"20170101":1432,"20170102":2115,"20170103":7632,"20170104":6664,"20170105":7133,"20170106":8352,"20170107":4041,"20170108":3993,"20170109":6418,"20170110":6925,"20170111":13123,"20170112":10291,"20170113":8729,"20170114":7022,"20170115":6606,"20170116":10903,"20170117":11636,"20170118":10297,"20170119":11190,"20170120":23310,"20170121":15929,"20170122":11620,"20170123":13602,"20170124":17003,"20170125":17722,"20170126":20320,"20170127":19112,"20170128":15993,"20170129":19164,"20170130":23214,"20170131":23630,"20170201":17614,"20170202":18254,"20170203":15841,"20170204":12678,"20170205":10692,"20170206":11451,"20170207":14578,"20170208":13290,"20170209":12955,"20170210":16356,"20170211":7342,"20170212":7602,"20170213":10409,"20170214":11634,"20170215":12367,"20170216":12968,"20170217":12811,"20170218":5189,"20170219":7307,"20170220":9663,"20170221":9544,"20170222":8475,"20170223":9442,"20170224":10675,"20170225":6261,"20170226":5011,"20170227":10183,"20170228":12972,"20170301":21572,"20170302":9279,"20170303":7626,"20170304":6538,"20170305":6534,"20170306":10880,"20170307":10156,"20170308":8373,"20170309":7975,"20170310":7628,"20170311":4995,"20170312":4809,"20170313":6512,"20170314":6212,"20170315":10948,"20170316":16882,"20170317":12899,"20170318":6752,"20170319":3461,"20170320":7303,"20170321":7829,"20170322":7770,"20170323":6661,"20170324":8472,"20170325":3844,"20170326":2706,"20170327":5388,"20170328":8666,"20170329":8559,"20170330":8934,"20170331":7314,"20170401":3210,"20170402":2899,"20170403":7350,"20170404":7343,"20170405":7857,"20170406":8746,"20170407":10705,"20170408":4660,"20170409":3322,"20170410":4895,"20170411":5029,"20170412":8124,"20170413":7855,"20170414":6492,"20170415":3441,"20170416":4166,"20170417":4470,"20170418":7648,"20170419":6113,"20170420":5630,"20170421":7573,"20170422":4441,"20170423":3117,"20170424":5292,"20170425":9565,"20170426":11049,"20170427":9878,"20170428":8747,"20170429":6251,"20170430":7042,"20170501":7845,"20170502":6766,"20170503":5897,"20170504":5082,"20170505":3875,"20170506":2623,"20170507":1344,"20170508":6222,"20170509":5823,"20170510":9810,"20170511":6537,"20170512":8960,"20170513":5006,"20170514":2624,"20170515":5853,"20170516":12325,"20170517":11883,"20170518":10290,"20170519":9058,"20170520":7208,"20170521":6908,"20170522":11606,"20170523":10452,"20170524":9130,"20170525":10423,"20170526":7363,"20170527":5030,"20170528":3407,"20170529":4258,"20170530":4832,"20170531":11401,"20170601":7750,"20170602":12540,"20170603":4485,"20170604":4126,"20170605":8957,"20170606":8817,"20170607":10999,"20170608":9513,"20170609":8356,"20170610":4107,"20170611":2661,"20170612":7232,"20170613":7760,"20170614":4412,"20170615":4958,"20170616":6446,"20170617":3213,"20170618":2081,"20170619":3045,"20170620":4273,"20170621":4015,"20170622":5221,"20170623":5062,"20170624":2809,"20170625":2265,"20170626":4503,"20170627":4258,"20170628":4160,"20170629":4549,"20170630":5961,"20170701":3291,"20170702":2468,"20170703":4076,"20170704":2891,"20170705":3461,"20170706":6268,"20170707":7686,"20170708":5736,"20170709":4015,"20170710":6024,"20170711":5494,"20170712":7052,"20170713":7459,"20170714":7321,"20170715":2820,"20170716":2161,"20170717":2801,"20170718":4826,"20170719":7712,"20170720":5462,"20170721":4372,"20170722":4090,"20170723":2542,"20170724":4657,"20170725":6891,"20170726":7995,"20170727":6431,"20170728":5676,"20170729":5196,"20170730":2687,"20170731":3979,"20170801":6212,"20170802":6885,"20170803":6306,"20170804":5743,"20170805":1849,"20170806":2192,"20170807":2642,"20170808":3630,"20170809":5697,"20170810":4354,"20170811":4192,"20170812":2839,"20170813":2584,"20170814":5099,"20170815":8494,"20170816":9602,"20170817":7401,"20170818":7043,"20170819":4873,"20170820":2606,"20170821":3989,"20170822":9704,"20170823":9808,"20170824":5631,"20170825":4135,"20170826":5664,"20170827":3333,"20170828":6145,"20170829":6338,"20170830":5265,"20170831":3772,"20170901":4278,"20170902":4887,"20170903":3336,"20170904":3205,"20170905":5906,"20170906":8031,"20170907":6560,"20170908":5121,"20170909":1674,"20170910":1665,"20170911":3667,"20170912":3631,"20170913":3764,"20170914":7345,"20170915":4403,"20170916":2425,"20170917":2324,"20170918":4772,"20170919":7612,"20170920":7346,"20170921":6237,"20170922":5626,"20170923":3605,"20170924":1860,"20170925":4426,"20170926":4748,"20170927":6449,"20170928":4891,"20170929":3638,"20170930":2942,"20171001":1986,"20171002":3882,"20171003":4893,"20171004":5029,"20171005":3141,"20171006":4280,"20171007":3042,"20171008":3099,"20171009":3380,"20171010":4061,"20171011":5443,"20171012":6845,"20171013":8826,"20171014":3861,"20171015":2181,"20171016":3856,"20171017":5957,"20171018":6422,"20171019":6950,"20171020":5577,"20171021":4678,"20171022":2796,"20171023":6737,"20171024":6976,"20171025":7374,"20171026":6989,"20171027":5027,"20171028":2831,"20171029":2044,"20171030":6692,"20171031":6321,"20171101":6367,"20171102":4816,"20171103":8004,"20171104":4935,"20171105":2322,"20171106":5827,"20171107":7159,"20171108":6446,"20171109":5831,"20171110":5400,"20171111":4577,"20171112":5325,"20171113":5691,"20171114":5220,"20171115":4181,"20171116":4237,"20171117":3134,"20171118":2943,"20171119":1613,"20171120":3865,"20171121":4791,"20171122":3631,"20171123":1724,"20171124":2730,"20171125":2165,"20171126":1302,"20171127":4335,"20171128":6371,"20171129":6123,"20171130":6011,"20171201":5982,"20171202":4910,"20171203":5002,"20171204":8349,"20171205":7234,"20171206":8888,"20171207":7610,"20171208":6325,"20171209":4214,"20171210":2785,"20171211":5266,"20171212":6228,"20171213":5606,"20171214":2803,"20171215":5620,"20171216":3078,"20171217":4120,"20171218":4614,"20171219":4486,"20171220":4016,"20171221":4682,"20171222":4769,"20171223":2264,"20171224":3633,"20171225":1960,"20171226":1211,"20171227":2684,"20171228":2704,"20171229":4082,"20171230":1689,"20171231":1316}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_js_router__ = __webpack_require__(43);


var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










// initial state
// shape: {
//  trends:[],
// }
// trend: {
//  query: "",
//  method: "",
//  data: "",
//  timerange: "",
//  lastFetchedMillis: 12345
// }
//
var state = {
    trends: [],
    cachedTrendsList: []

    // getters
};var getters = {
    getTrendByDay: function getTrendByDay(state) {
        return function (query, method, timerange) {
            var data = state.trends.find(function (trend) {
                return query === trend.query && method === trend.method && timerange === trend.timerange;
            });
            data = Object.assign({}, data);

            // refresh data when it is older than 7 days
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.lastFetchedMillis), 'days') > 7) {
                return {};
            }
            return Object.assign({}, data);
        };
    }

    // actions
};var actions = {
    clearTrends: function clearTrends(_ref) {
        var commit = _ref.commit,
            state = _ref.state;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* TRENDS_CLEAR */]);
            resolve();
        });
    },
    getWordcountByDay: function getWordcountByDay(_ref2, _ref3) {
        var commit = _ref2.commit,
            state = _ref2.state;
        var query = _ref3.query,
            method = _ref3.method,
            timerange = _ref3.timerange,
            normalize = _ref3.normalize;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* api */].graph.getWordcountByDay(query, method, timerange, normalize).then(function (response) {
                if (response != undefined && response.data != undefined) {
                    var data = response.data;
                    var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        success: true
                    });
                    var trend = Object.assign({}, {
                        query: query,
                        method: method,
                        data: data,
                        timerange: timerange,
                        lastFetchedMillis: __WEBPACK_IMPORTED_MODULE_1_moment___default()().valueOf()
                    });

                    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* TREND_ADD */], trend);
                    resolve({ reqStatus: reqStatus, trend: trend });
                } else {
                    var _reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        failure: true,
                        failureType: __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST
                    });

                    reject(_reqStatus);
                }
            }).catch(function (error) {
                var failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_NONE;
                var errorCode = 404;
                if (error && error.response && error.response.status > 0) {
                    errorCode = error.response.status;
                }
                if (errorCode >= 500) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_SERVER;
                } else if (errorCode = 401) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_AUTHENTICATION;
                } else if (errorCode = 403) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_PERMISSION;
                } else {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST;
                }

                var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                    pending: false,
                    failure: true,
                    failureType: failure
                });
                reject(reqStatus);
            });
        });
    },
    getCachedTrends: function getCachedTrends(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* api */].graph.getCachedTrends().then(function (response) {
                if (response != undefined && response.data != undefined) {
                    var data = response.data;
                    var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        success: true
                    });

                    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CACHED_TRENDS_SET */], data);
                    resolve({ reqStatus: reqStatus, data: data });
                } else {
                    var _reqStatus2 = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                        pending: false,
                        failure: true,
                        failureType: __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST
                    });

                    reject(_reqStatus2);
                }
            }).catch(function (error) {
                var failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_NONE;
                var errorCode = 404;
                if (error && error.response && error.response.status > 0) {
                    errorCode = error.response.status;
                }
                if (errorCode >= 500) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_SERVER;
                } else if (errorCode = 401) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_AUTHENTICATION;
                } else if (errorCode = 403) {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_PERMISSION;
                } else {
                    failure = __WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ServerErrors */].ERROR_REQUEST;
                }

                var reqStatus = Object.assign({}, new __WEBPACK_IMPORTED_MODULE_4__models_RequestStatus__["a" /* default */](), {
                    pending: false,
                    failure: true,
                    failureType: failure
                });
                reject(reqStatus);
            });
        });
    }
};

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* TREND_ADD */], function (state, trend) {

    var oldTrendIndex = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(state.trends, function (t) {
        return t.query === trend.query && t.method === trend.method && t.timerange === trend.timerange;
    });
    if (oldTrendIndex >= 0) {
        state.trends = Object.assign([].concat(_toConsumableArray(state.trends)), _defineProperty({}, oldTrendIndex, trend));
    } else {
        state.trends = [].concat(_toConsumableArray(state.trends), [trend]);
    }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* TRENDS_CLEAR */], function (state) {
    state.trends = [];
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CACHED_TRENDS_SET */], function (state, trends) {
    state.cachedTrendsList = trends;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 120,
	"./af.js": 120,
	"./ar": 121,
	"./ar-dz": 122,
	"./ar-dz.js": 122,
	"./ar-kw": 123,
	"./ar-kw.js": 123,
	"./ar-ly": 124,
	"./ar-ly.js": 124,
	"./ar-ma": 125,
	"./ar-ma.js": 125,
	"./ar-sa": 126,
	"./ar-sa.js": 126,
	"./ar-tn": 127,
	"./ar-tn.js": 127,
	"./ar.js": 121,
	"./az": 128,
	"./az.js": 128,
	"./be": 129,
	"./be.js": 129,
	"./bg": 130,
	"./bg.js": 130,
	"./bm": 131,
	"./bm.js": 131,
	"./bn": 132,
	"./bn.js": 132,
	"./bo": 133,
	"./bo.js": 133,
	"./br": 134,
	"./br.js": 134,
	"./bs": 135,
	"./bs.js": 135,
	"./ca": 136,
	"./ca.js": 136,
	"./cs": 137,
	"./cs.js": 137,
	"./cv": 138,
	"./cv.js": 138,
	"./cy": 139,
	"./cy.js": 139,
	"./da": 140,
	"./da.js": 140,
	"./de": 141,
	"./de-at": 142,
	"./de-at.js": 142,
	"./de-ch": 143,
	"./de-ch.js": 143,
	"./de.js": 141,
	"./dv": 144,
	"./dv.js": 144,
	"./el": 145,
	"./el.js": 145,
	"./en-au": 146,
	"./en-au.js": 146,
	"./en-ca": 147,
	"./en-ca.js": 147,
	"./en-gb": 148,
	"./en-gb.js": 148,
	"./en-ie": 149,
	"./en-ie.js": 149,
	"./en-nz": 150,
	"./en-nz.js": 150,
	"./eo": 151,
	"./eo.js": 151,
	"./es": 152,
	"./es-do": 153,
	"./es-do.js": 153,
	"./es-us": 154,
	"./es-us.js": 154,
	"./es.js": 152,
	"./et": 155,
	"./et.js": 155,
	"./eu": 156,
	"./eu.js": 156,
	"./fa": 157,
	"./fa.js": 157,
	"./fi": 158,
	"./fi.js": 158,
	"./fo": 159,
	"./fo.js": 159,
	"./fr": 160,
	"./fr-ca": 161,
	"./fr-ca.js": 161,
	"./fr-ch": 162,
	"./fr-ch.js": 162,
	"./fr.js": 160,
	"./fy": 163,
	"./fy.js": 163,
	"./gd": 164,
	"./gd.js": 164,
	"./gl": 165,
	"./gl.js": 165,
	"./gom-latn": 166,
	"./gom-latn.js": 166,
	"./gu": 167,
	"./gu.js": 167,
	"./he": 168,
	"./he.js": 168,
	"./hi": 169,
	"./hi.js": 169,
	"./hr": 170,
	"./hr.js": 170,
	"./hu": 171,
	"./hu.js": 171,
	"./hy-am": 172,
	"./hy-am.js": 172,
	"./id": 173,
	"./id.js": 173,
	"./is": 174,
	"./is.js": 174,
	"./it": 175,
	"./it.js": 175,
	"./ja": 176,
	"./ja.js": 176,
	"./jv": 177,
	"./jv.js": 177,
	"./ka": 178,
	"./ka.js": 178,
	"./kk": 179,
	"./kk.js": 179,
	"./km": 180,
	"./km.js": 180,
	"./kn": 181,
	"./kn.js": 181,
	"./ko": 182,
	"./ko.js": 182,
	"./ky": 183,
	"./ky.js": 183,
	"./lb": 184,
	"./lb.js": 184,
	"./lo": 185,
	"./lo.js": 185,
	"./lt": 186,
	"./lt.js": 186,
	"./lv": 187,
	"./lv.js": 187,
	"./me": 188,
	"./me.js": 188,
	"./mi": 189,
	"./mi.js": 189,
	"./mk": 190,
	"./mk.js": 190,
	"./ml": 191,
	"./ml.js": 191,
	"./mr": 192,
	"./mr.js": 192,
	"./ms": 193,
	"./ms-my": 194,
	"./ms-my.js": 194,
	"./ms.js": 193,
	"./mt": 195,
	"./mt.js": 195,
	"./my": 196,
	"./my.js": 196,
	"./nb": 197,
	"./nb.js": 197,
	"./ne": 198,
	"./ne.js": 198,
	"./nl": 199,
	"./nl-be": 200,
	"./nl-be.js": 200,
	"./nl.js": 199,
	"./nn": 201,
	"./nn.js": 201,
	"./pa-in": 202,
	"./pa-in.js": 202,
	"./pl": 203,
	"./pl.js": 203,
	"./pt": 204,
	"./pt-br": 205,
	"./pt-br.js": 205,
	"./pt.js": 204,
	"./ro": 206,
	"./ro.js": 206,
	"./ru": 207,
	"./ru.js": 207,
	"./sd": 208,
	"./sd.js": 208,
	"./se": 209,
	"./se.js": 209,
	"./si": 210,
	"./si.js": 210,
	"./sk": 211,
	"./sk.js": 211,
	"./sl": 212,
	"./sl.js": 212,
	"./sq": 213,
	"./sq.js": 213,
	"./sr": 214,
	"./sr-cyrl": 215,
	"./sr-cyrl.js": 215,
	"./sr.js": 214,
	"./ss": 216,
	"./ss.js": 216,
	"./sv": 217,
	"./sv.js": 217,
	"./sw": 218,
	"./sw.js": 218,
	"./ta": 219,
	"./ta.js": 219,
	"./te": 220,
	"./te.js": 220,
	"./tet": 221,
	"./tet.js": 221,
	"./th": 222,
	"./th.js": 222,
	"./tl-ph": 223,
	"./tl-ph.js": 223,
	"./tlh": 224,
	"./tlh.js": 224,
	"./tr": 225,
	"./tr.js": 225,
	"./tzl": 226,
	"./tzl.js": 226,
	"./tzm": 227,
	"./tzm-latn": 228,
	"./tzm-latn.js": 228,
	"./tzm.js": 227,
	"./uk": 229,
	"./uk.js": 229,
	"./ur": 230,
	"./ur.js": 230,
	"./uz": 231,
	"./uz-latn": 232,
	"./uz-latn.js": 232,
	"./uz.js": 231,
	"./vi": 233,
	"./vi.js": 233,
	"./x-pseudo": 234,
	"./x-pseudo.js": 234,
	"./yo": 235,
	"./yo.js": 235,
	"./zh-cn": 236,
	"./zh-cn.js": 236,
	"./zh-hk": 237,
	"./zh-hk.js": 237,
	"./zh-tw": 238,
	"./zh-tw.js": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b542c58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__(422);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b542c58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b542c58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(387);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0106876a", content, true);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "body[data-v-9b542c58],html[data-v-9b542c58]{width:100%;height:100%}.lead[data-v-9b542c58]{font-size:18px;font-weight:400}.intro-header[data-v-9b542c58]{padding-top:50px;padding-bottom:50px;text-align:center;color:#f8f8f8;background:url(" + __webpack_require__(388) + ") no-repeat 50%;background-size:cover}.intro-logo>img[data-v-9b542c58]{position:relative;max-width:200px}.intro-message[data-v-9b542c58]{position:relative;padding-bottom:20%}.intro-message>h1[data-v-9b542c58]{margin:0;text-shadow:2px 2px 3px rgba(0,0,0,.6);font-size:5em}.intro-divider[data-v-9b542c58]{width:400px;border-top:1px solid #f8f8f8;border-bottom:1px solid rgba(0,0,0,.2)}.intro-message>h3[data-v-9b542c58]{text-shadow:2px 2px 3px rgba(0,0,0,.6)}.row.display-flex[data-v-9b542c58]{display:flex;flex-wrap:wrap}.row.display-flex>[class*=col-][data-v-9b542c58]{display:flex;flex-direction:column;justify-content:center}@media (max-width:767px){.intro-message[data-v-9b542c58]{padding-bottom:15%}.intro-message>h1[data-v-9b542c58]{font-size:3em}ul.intro-social-buttons>li[data-v-9b542c58]{display:block;margin-bottom:20px;padding:0}ul.intro-social-buttons>li[data-v-9b542c58]:last-child{margin-bottom:0}.intro-divider[data-v-9b542c58]{width:100%}}.network-name[data-v-9b542c58]{text-transform:uppercase;font-size:14px;font-weight:400;letter-spacing:2px}.content-section-a[data-v-9b542c58]{padding:50px 0;background-color:#f8f8f8}.content-section-b[data-v-9b542c58]{padding:50px 0;border-top:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7}.content-section-a .img-responsive[data-v-9b542c58],.content-section-b .img-responsive[data-v-9b542c58]{box-shadow:1px 1px 10px 0 rgba(50,50,50,.5)}.section-heading[data-v-9b542c58]{margin-bottom:30px}.section-heading-spacer[data-v-9b542c58]{float:left;width:200px;border-top:3px solid #e7e7e7}.banner[data-v-9b542c58]{padding:100px 0;color:#f8f8f8;background:url(" + __webpack_require__(389) + ") no-repeat 50%;background-size:cover}.banner h2[data-v-9b542c58]{margin:0;text-shadow:2px 2px 3px rgba(0,0,0,.6);font-size:3em}.banner ul[data-v-9b542c58]{margin-bottom:0}.banner-social-buttons[data-v-9b542c58]{float:right;margin-top:0}.carousel-inner>.item>a>img[data-v-9b542c58],.carousel-inner>.item>img[data-v-9b542c58],.resize[data-v-9b542c58],.thumbnail>img[data-v-9b542c58],.thumbnail a>img[data-v-9b542c58]{display:block;max-width:55%;height:70%}@media (max-width:1199px){ul.banner-social-buttons[data-v-9b542c58]{float:left;margin-top:15px}}@media (max-width:767px){.banner h2[data-v-9b542c58]{margin:0;text-shadow:2px 2px 3px rgba(0,0,0,.6);font-size:3em}ul.banner-social-buttons>li[data-v-9b542c58]{display:block;margin-bottom:20px;padding:0}ul.banner-social-buttons>li[data-v-9b542c58]:last-child{margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blur.c5b04c3.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-bg.3548b4a.jpg";

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_GitInfo__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_OnboardingModal__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LandingHeader__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LandingFooter__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Landing",
  components: {
    GitInfo: __WEBPACK_IMPORTED_MODULE_0__components_common_GitInfo__["a" /* default */],
    OnboardingModal: __WEBPACK_IMPORTED_MODULE_1__modal_OnboardingModal__["a" /* default */],
    LandingHeader: __WEBPACK_IMPORTED_MODULE_2__LandingHeader__["a" /* default */],
    LandingFooter: __WEBPACK_IMPORTED_MODULE_3__LandingFooter__["a" /* default */]
  },
  data: function data() {
    return {
      modalActive: false,
      modalType: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* FormTypeEnum */].login,
      FormTypeEnum: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* FormTypeEnum */]
    };
  },
  methods: {
    open: function open(which) {
      this.modalActive = true;
      this.modalType = which;
    },
    close: function close(event) {
      event.preventDefault();
      this.modalActive = false;
    }
  },
  computed: {
    isGitInfoShown: function isGitInfoShown() {
      if (Object({"COMMIT":"36ba96b","BRANCH":"feature/independent-frontend","DATE":"2018-02-13T21:09:52.000Z","MESSAGE":"added list of all currently cached terms","AUTHOR":"Patrick Willmann"}) === undefined) {
        return false;
      }
      return Object({"COMMIT":"36ba96b","BRANCH":"feature/independent-frontend","DATE":"2018-02-13T21:09:52.000Z","MESSAGE":"added list of all currently cached terms","AUTHOR":"Patrick Willmann"}) && "feature/independent-frontend" && !"feature/independent-frontend".includes("master");
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GitInfo_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54419a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GitInfo_vue__ = __webpack_require__(395);
function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GitInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54419a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GitInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(393);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("16edb2a4", content, true);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "#git-info{color:grey;display:flex;flex-direction:row;justify-content:center}", ""]);

// exports


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GitInfo',
  props: ['isActive'],
  data: function data() {
    return {
      date: '',
      author: '',
      commit: '',
      branch: ''
    };
  },
  mounted: function mounted() {
    var date = new Date("2018-02-13T21:09:52.000Z").toLocaleString("de-DE");
    this.date = date;
    this.author = "Patrick Willmann";
    this.commit = "36ba96b";
    this.branch = "feature/independent-frontend";
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"border border-primary",attrs:{"id":"git-info"}},[_c('span',[_vm._v(_vm._s(_vm.branch)+" : "),_c('i',[_vm._v("("+_vm._s(_vm.commit)+")")]),_vm._v(" "),_c('b',[_vm._v("by")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.author))]),_vm._v(" "),_c('b',[_vm._v("on")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.date))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingModal_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177b286d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingModal_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-177b286d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177b286d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9573f9c4", content, true);

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".onboarding-form.form-login[data-v-177b286d],.onboarding-form.form-register[data-v-177b286d]{padding:75px 25px 25px;display:none}.onboarding-form.form-login.active[data-v-177b286d],.onboarding-form.form-register.active[data-v-177b286d]{display:block}.onboarding-form.form-login .alert[data-v-177b286d],.onboarding-form.form-register .alert[data-v-177b286d]{border-radius:0}.onboarding-form.form-login input[data-v-177b286d],.onboarding-form.form-register input[data-v-177b286d]{width:100%;padding:10px;margin-bottom:10px;border:1px solid #eee}.onboarding-form.form-login input[type=submit][data-v-177b286d],.onboarding-form.form-register input[type=submit][data-v-177b286d]{color:#f6f6f6;border:0;margin-bottom:0;background-color:#053948;cursor:pointer}.onboarding-form.form-login input[type=submit][data-v-177b286d]:active,.onboarding-form.form-login input[type=submit][data-v-177b286d]:hover,.onboarding-form.form-register input[type=submit][data-v-177b286d]:active,.onboarding-form.form-register input[type=submit][data-v-177b286d]:hover{background-color:#127281}.onboarding-form.form-login input[type=submit].disabled[data-v-177b286d],.onboarding-form.form-register input[type=submit].disabled[data-v-177b286d]{background-color:#8ea5ac}.onboarding-form.form-login .links[data-v-177b286d],.onboarding-form.form-register .links[data-v-177b286d]{text-align:center;padding-top:25px}.onboarding-form.form-login .links a[data-v-177b286d],.onboarding-form.form-register .links a[data-v-177b286d]{color:#343a40}.user-modal-container[data-v-177b286d]{position:fixed;width:100%;height:100%;top:0;left:0;opacity:0;visibility:hidden;cursor:pointer;overflow-y:auto;z-index:99999;font-family:Lato,Helvetica Neue,Helvetica,Arial,\"sans-serif\";font-size:14px;background-color:hsla(0,0%,7%,.9);-webkit-transition:all .25s linear;-moz-transition:all .25s linear;-o-transition:all .25s linear;-ms-transition:all .25s linear;transition:all .25s linear}.user-modal-container [data-v-177b286d]{box-sizing:border-box;padding-left:0}.user-modal-container.active[data-v-177b286d]{opacity:1;visibility:visible}.user-modal-container .user-modal[data-v-177b286d]{position:relative;margin:50px auto;width:90%;max-width:500px;background-color:#f8f8f8;cursor:auto}.user-modal-container ul.form-switcher[data-v-177b286d]{margin:0;padding:0}.user-modal-container ul.form-switcher li[data-v-177b286d]{list-style:none;display:inline-block;width:50%;float:left;margin:0}.user-modal-container ul.form-switcher li a[data-v-177b286d]{width:100%;display:block;height:50px;line-height:50px;color:#666;background-color:#ddd;text-align:center}.user-modal-container ul.form-switcher li a.active[data-v-177b286d]{color:#000;background-color:#f8f8f8}", ""]);

// exports


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginForm__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegisterForm__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-modal',
  components: { LoginForm: __WEBPACK_IMPORTED_MODULE_0__LoginForm__["a" /* default */], RegisterForm: __WEBPACK_IMPORTED_MODULE_1__RegisterForm__["a" /* default */] },
  props: {
    isActive: Boolean,
    type: {
      validator: function validator(value) {
        return value === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* FormTypeEnum */].login || value === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* FormTypeEnum */].register;
      },
      default: __WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* FormTypeEnum */].login
    }
  },

  data: function data() {
    return {
      FormTypeEnum: __WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* FormTypeEnum */]
    };
  },
  methods: {
    close: function close() {
      this.isSubmitting = false;
      this.$emit('close');
    },
    flip: function flip(which) {
      this.isSubmitting = false;
      if (this.type === this.FormTypeEnum.register) {
        this.$emit('changeType', this.FormTypeEnum.login);
      } else {
        this.$emit('changeType', this.FormTypeEnum.register);
      }
    }

  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f70490b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(404);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f70490b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6fa758fa", content, true);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".onboarding-form.form-login,.onboarding-form.form-register{padding:75px 25px 25px;display:none}.onboarding-form.form-login.active,.onboarding-form.form-register.active{display:block}.onboarding-form.form-login .alert,.onboarding-form.form-register .alert{border-radius:0}.onboarding-form.form-login input,.onboarding-form.form-register input{width:100%;padding:10px;margin-bottom:10px;border:1px solid #eee}.onboarding-form.form-login input[type=submit],.onboarding-form.form-register input[type=submit]{color:#f6f6f6;border:0;margin-bottom:0;background-color:#053948;cursor:pointer}.onboarding-form.form-login input[type=submit]:active,.onboarding-form.form-login input[type=submit]:hover,.onboarding-form.form-register input[type=submit]:active,.onboarding-form.form-register input[type=submit]:hover{background-color:#127281}.onboarding-form.form-login input[type=submit].disabled,.onboarding-form.form-register input[type=submit].disabled{background-color:#8ea5ac}.onboarding-form.form-login .links,.onboarding-form.form-register .links{text-align:center;padding-top:25px}.onboarding-form.form-login .links a,.onboarding-form.form-register .links a{color:#343a40}", ""]);

// exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validation__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_js_models_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_utils_constants__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login-form",
  props: {
    active: Boolean
  },
  data: function data() {
    return {
      username: "",
      password: "",
      errorText: "",
      hasError: false,
      reqStatus: new __WEBPACK_IMPORTED_MODULE_2_src_js_models_RequestStatus__["a" /* default */]()
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
    // arrow functions can make the code very succinct!
    user: function user(state) {
      return state.user.user;
    }
  }),
  mounted: function mounted() {
    // fill in username if user just registered
    if (this.user != undefined && this.user.username != undefined && this.user.username.length > 2) {
      this.username = this.user.username;
    }
  },

  methods: {
    submit: function submit() {
      var data = {
        form: this.type
      };

      var validLoginData = this.validateLogin(this.username, this.password);
      if (validLoginData) {
        data.password = this.password;
        data.user = this.username;
        this.doLogin(this.username, this.password);
      }
    },
    doLogin: function doLogin(name, password) {
      var _this = this;

      this.reqStatus.pending = true;
      this.$store.dispatch("loginUser", {
        username: name,
        password: password
      }).then(function (requestStatus) {
        _this.reqStatus = requestStatus;
        console.log(_this.user);
        _this.$router.push({
          path: "engagement"
        });
      }).catch(function (requestStatus) {
        _this.reqStatus = requestStatus;
        console.log(requestStatus);
        if (_this.reqStatus !== __WEBPACK_IMPORTED_MODULE_3_src_js_utils_constants__["b" /* ServerErrors */].ERROR_SERVER) {
          _this.showLoginError("Login failure - please try again!");
        } else {
          _this.showLoginError("Server error - please try again later!");
        }
      });
      /*api.auth
          .postLogin(name, password)
          .then(response => {
            this.$router.push({
              path: "engagement"
            });
          })
          .catch(error => {
            let isServerError =
              !error ||
              !error.response ||
              !error.response.status ||
              error.response.status >= 500;
            if (!isServerError) {
              this.showLoginError("Login failure - please try again!");
            } else {
              this.showLoginError("Server error - please try again later!");
            }
          });*/
    },
    validateLogin: function validateLogin(name, password) {
      var isValid = false;
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["c" /* isNameValid */])(name)) {
        this.showLoginError("Please enter a valid username!");
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["d" /* isPasswordValid */])(password)) {
        this.showLoginError("Please enter a valid password!");
      } else {
        isValid = true;
        this.hideLoginError();
      }

      return isValid;
    },
    showLoginError: function showLoginError(message) {
      if (typeof message === "string" || message instanceof String) {
        this.hasError = true;
        this.errorText = message;
      } else {
        this.hasError = false;
      }
    },
    hideLoginError: function hideLoginError() {
      this.hasError = false;
    },
    openRegistration: function openRegistration() {
      this.$emit("openRegistration");
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onboarding-form form-login",class:{active: _vm.active},attrs:{"id":"form-login"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"id":"form-username","type":"text","name":"user","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.username=$event.target.value},_vm.hideLoginError],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"change":_vm.hideLoginError}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"id":"form-password","type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.hideLoginError],"change":_vm.hideLoginError}}),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',{class:{disabled: _vm.reqStatus.pending},attrs:{"id":"form-login-submit","type":"submit","value":"Login"},on:{"click":function($event){$event.stopPropagation();_vm.submit()}}}),_vm._v(" "),_c('div',{staticClass:"links"},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openRegistration()}}},[_vm._v("Don't have an account yet?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d93bb08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d93bb08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d93bb08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(407);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("705941aa", content, true);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".onboarding-form.form-login[data-v-4d93bb08],.onboarding-form.form-register[data-v-4d93bb08]{padding:75px 25px 25px;display:none}.onboarding-form.form-login.active[data-v-4d93bb08],.onboarding-form.form-register.active[data-v-4d93bb08]{display:block}.onboarding-form.form-login .alert[data-v-4d93bb08],.onboarding-form.form-register .alert[data-v-4d93bb08]{border-radius:0}.onboarding-form.form-login input[data-v-4d93bb08],.onboarding-form.form-register input[data-v-4d93bb08]{width:100%;padding:10px;margin-bottom:10px;border:1px solid #eee}.onboarding-form.form-login input[type=submit][data-v-4d93bb08],.onboarding-form.form-register input[type=submit][data-v-4d93bb08]{color:#f6f6f6;border:0;margin-bottom:0;background-color:#053948;cursor:pointer}.onboarding-form.form-login input[type=submit][data-v-4d93bb08]:active,.onboarding-form.form-login input[type=submit][data-v-4d93bb08]:hover,.onboarding-form.form-register input[type=submit][data-v-4d93bb08]:active,.onboarding-form.form-register input[type=submit][data-v-4d93bb08]:hover{background-color:#127281}.onboarding-form.form-login input[type=submit].disabled[data-v-4d93bb08],.onboarding-form.form-register input[type=submit].disabled[data-v-4d93bb08]{background-color:#8ea5ac}.onboarding-form.form-login .links[data-v-4d93bb08],.onboarding-form.form-register .links[data-v-4d93bb08]{text-align:center;padding-top:25px}.onboarding-form.form-login .links a[data-v-4d93bb08],.onboarding-form.form-register .links a[data-v-4d93bb08]{color:#343a40}div.alert-success[data-v-4d93bb08]{margin-top:10px}", ""]);

// exports


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validation__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_js_models_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_utils_constants__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var colors = ["", "#F09090", "#EBA096", "#E5B09C", "#E0C0A2", "#DBCFA7", "#D6DFAD", "#D0EFB3", "#CBFFB9"];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "register-form",
  props: {
    active: Boolean
  },
  data: function data() {
    return {
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      errorText: "",
      requestStatus: new __WEBPACK_IMPORTED_MODULE_2_src_js_models_RequestStatus__["a" /* default */](),
      hasError: false,

      // Style Password Input Field
      regPwStyle: {
        backgroundColor: ""
      },

      // Style Email Input Field
      regEmailStyle: {
        backgroundColor: ""
      }
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
    // arrow functions can make the code very succinct!
    user: function user(state) {
      return state.user.user;
    }
  }),
  mounted: function mounted() {
    this.clearRegistration();
  },

  methods: {
    submit: function submit() {
      //this.isSubmitting = true;

      var validData = this.validateRegistration(this.username, this.firstname, this.lastname, this.email, this.password);

      if (validData) {
        this.doRegistration(this.username, this.firstname, this.lastname, this.email, this.password);
      }
    },
    doRegistration: function doRegistration(name, firstname, lastname, email, password) {
      var _this = this;

      this.requestStatus.pending = true;
      this.$store.dispatch("registerUser", {
        username: name,
        firstname: firstname,
        lastname: lastname,
        email: email,
        password: password
      }).then(function (requestStatus) {
        _this.requestStatus = requestStatus;
        _this.openLogin();
      }).catch(function (error) {

        _this.requestStatus = error;
        if (_this.requestStatus !== __WEBPACK_IMPORTED_MODULE_3_src_js_utils_constants__["b" /* ServerErrors */].ERROR_SERVER) {
          _this.showError("User already registered!");
        } else {
          _this.showError("Server error - please try again later!");
        }
      });
    },
    clearRegistration: function clearRegistration() {
      this.username = "";
      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.password = "";
      this.requestStatus = new __WEBPACK_IMPORTED_MODULE_2_src_js_models_RequestStatus__["a" /* default */]();
    },
    validateRegistration: function validateRegistration(name, firstname, lastname, mail, password) {
      var validRegistration = false;
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["c" /* isNameValid */])(name)) {
        this.showError("Please enter a valid name!");
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["c" /* isNameValid */])(firstname)) {
        this.showError("Please enter a valid firstname!");
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["c" /* isNameValid */])(lastname)) {
        this.showError("Please enter a valid lastname!");
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["b" /* isMailValid */])(mail)) {
        this.showError("Please enter a valid mail!");
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["d" /* isPasswordValid */])(password)) {
        this.showError("Please enter a valid password!");
      } else {
        validRegistration = true;
        this.hideError();
      }
      return validRegistration;
    },

    checkEmail: function checkEmail() {
      this.hideError();
      if (this.email.length > 0) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["b" /* isMailValid */])(this.email)) {
          this.regEmailStyle.backgroundColor = colors[colors.length - 1];
        } else {
          this.regEmailStyle.backgroundColor = colors[1];
        }
      } else {
        this.regEmailStyle.backgroundColor = colors[0];
      }
    },
    checkPassword: function checkPassword() {
      this.hideError();
      var strength = Object(__WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* getPasswordStrength */])(this.password);

      if (strength > 0 && strength < colors.length) {
        this.regPwStyle.backgroundColor = colors[strength];
      } else {
        this.regPwStyle.backgroundColor = colors[0];
      }
    },
    showError: function showError(message) {
      if (typeof message === "string" || message instanceof String) {
        this.hasError = true;
        this.errorText = message;
      } else {
        this.hasError = false;
      }
    },
    hideError: function hideError() {
      this.hasError = false;
    },
    openLogin: function openLogin() {
      this.$emit("openLogin");
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onboarding-form form-register",class:{active: _vm.active},attrs:{"id":"form-register"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"id":"register-username","type":"text","name":"name","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.username=$event.target.value},_vm.hideError]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"}],attrs:{"id":"register-firstname","type":"text","name":"firstname","placeholder":"Firstname"},domProps:{"value":(_vm.firstname)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value},_vm.hideError]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"}],attrs:{"id":"register-lastname","type":"text","name":"lastname","placeholder":"Lastname"},domProps:{"value":(_vm.lastname)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value},_vm.hideError]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",style:(_vm.regEmailStyle),attrs:{"id":"register-email","type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.checkEmail]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"pwinput",style:(_vm.regPwStyle),attrs:{"id":"register-password","type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.checkPassword]}}),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',{class:{disabled: _vm.requestStatus.pending},attrs:{"id":"registerSubmit","type":"submit","value":"Register"},on:{"click":function($event){$event.stopPropagation();_vm.submit()}}}),_vm._v(" "),(_vm.requestStatus.success && !_vm.requestStatus.pending)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    Congratulations "+_vm._s(_vm.user.username)+"! You can now start to use pretrendr.\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"links"},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openLogin()}}},[_vm._v("Already have an account?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-modal-container",class:{active: _vm.isActive},attrs:{"id":"login-modal"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.close($event)}}},[_c('div',{staticClass:"user-modal"},[_c('ul',{staticClass:"form-switcher"},[_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.flip('register')}}},[_c('a',{class:{active: _vm.type === _vm.FormTypeEnum.register},attrs:{"href":"","id":"register-form"}},[_vm._v("Register")])]),_vm._v(" "),_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.flip('login')}}},[_c('a',{class:{active: _vm.type === _vm.FormTypeEnum.login},attrs:{"href":"","id":"login-form"}},[_vm._v("Login")])])]),_vm._v(" "),(_vm.type == _vm.FormTypeEnum.register && _vm.isActive)?_c('register-form',{attrs:{"active":_vm.type == _vm.FormTypeEnum.register},on:{"openLogin":function($event){_vm.flip(_vm.FormTypeEnum.login)}}}):_vm._e(),_vm._v(" "),(_vm.type == _vm.FormTypeEnum.login && _vm.isActive)?_c('login-form',{attrs:{"active":_vm.type == _vm.FormTypeEnum.login},on:{"openRegistration":function($event){_vm.flip(_vm.FormTypeEnum.register)}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingHeader_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df6185fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingHeader_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df6185fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df6185fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9721ee00", content, true);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".topnav[data-v-df6185fe]{font-size:14px;background-color:#fff;color:#053948}.topnav .icon[data-v-df6185fe]{height:30px;display:inline-block}.topnav a.topnav[data-v-df6185fe]{display:flex;flex-direction:row;justify-content:center;align-items:center}.topnav a.topnav b[data-v-df6185fe]{margin-left:5px}.topnav div.collapse a[data-v-df6185fe],.topnav div.collapsing a[data-v-df6185fe]{padding:5px 15px}.topnav .navbar-collapse[data-v-df6185fe]{height:auto!important}", ""]);

// exports


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing-header',
  methods: {
    openRegister: function openRegister() {
      this.$emit('openRegistration');
    },
    openLogin: function openLogin() {
      this.$emit('openLogin');
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default navbar-fixed-top topnav",attrs:{"role":"navigation"}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"container topnav"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"bs-example-navbar-collapse-1"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('a',{attrs:{"href":"#register","id":"header-link-register"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openRegister()}}},[_vm._v("Register")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#login","id":"header-link-login"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openLogin()}}},[_vm._v("Login")])])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#bs-example-navbar-collapse-1"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand topnav",attrs:{"href":"#"}},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(416)}}),_vm._v(" "),_c('b',[_vm._v("PRETRENDR")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAwIiBoZWlnaHQ9IjcwMCIgdmlld0JveD0iMCAwIDcwMCA3MDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0iIzA1Mzk0OCIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGQ9Ik01OTEuNjU2IDIyNS42NzJjLTIzLjYyMyAyMS41NTMtNTQuOTkzIDM0LjUwNC04OC45NjggMzQuNTA0LS44NTIgMC0xLjcwMi0uMDA4LTIuNTUtLjAyNEw0OTEgMjU5Ljk4VjE0OC4yNzZMNTI4LjMxIDExMGg2My4zNDZ2MTE1LjY3MnpNNDkxIDI2NC45MDRsMi43NyA1LjQyOGMxMS4zNTIgMjIuMjUgMTcuMzUzIDQ2LjkyNyAxNy4zNTMgNzIuNDc4IDAgMjguMTktNy4zMDQgNTQuNjc0LTIwLjEyMyA3Ny42NjR2LTE1NS41N3pNMzM4LjY2IDUwMi4wMWMtMzkuMjYtMy4xMDQtNzQuNTI0LTIwLjQwNC0xMDAuNjYtNDYuNzdWMTU0Ljc3bDM4LjY2My0yNy44MjNoMjMuOTk4bDM4IDMzLjQ3VjUwMi4wMXptLTEyNy04MS44NmMtMTIuNzA3LTIyLjkxNS0xOS45NDMtNDkuMjgyLTE5Ljk0My03Ny4zNCAwLTI1LjU1IDYtNTAuMjI3IDE3LjM1NC03Mi40NzhsMi41OS01LjA3NVY0MjAuMTV6bTAtMTYwLjE2OGwtOC45NTcuMTdjLS44NS4wMTYtMS43LjAyNC0yLjU1LjAyNC0zNC4wOCAwLTY1LjUxNy0xMy4wMjctODkuMTUzLTM0LjY3M1YyMThoMTAwLjY2djQxLjk4MnptMjUzIDE5NS40NGMtMjYuMTU4IDI2LjMwMy02MS40MiA0My41NDQtMTAwLjY2IDQ2LjYwMlYyMzhoMTAwLjY2djIxNy40MjN6Ii8+CiAgICA8cGF0aCBkPSJNNTMwLjQ3OCA3NS45NGwtOTIuNTQgOTIuMzU4Yy4wMzYuNTE2LjA1NCAxLjAzNy4wNTQgMS41NiAwIDEyLjQyOC0xMC4wNzMgMjIuNS0yMi41IDIyLjUtMTIuMDczIDAtMjEuOTI1LTkuNTA4LTIyLjQ3Ni0yMS40NDVsLTkzLjYyMy04MC4yNWMtMS4yNjUuMjIyLTIuNTY1LjMzNy0zLjg5My4zMzctMS44NDcgMC0zLjY0Mi0uMjIzLTUuMzYtLjY0MkwxODMuODE3IDE2NC4zOWMtMS40MiAxMS4wNjItMTAuODcgMTkuNjEtMjIuMzE2IDE5LjYxLTEyLjQyNiAwLTIyLjUtMTAuMDc0LTIyLjUtMjIuNXMxMC4wNzQtMjIuNSAyMi41LTIyLjVjMS44NDcgMCAzLjY0Mi4yMjMgNS4zNi42NDJMMjczLjE4MyA2NS42MUMyNzQuNjA0IDU0LjU0NyAyODQuMDU0IDQ2IDI5NS41IDQ2YzExLjk0MyAwIDIxLjcxMyA5LjMwNiAyMi40NTUgMjEuMDYybDk0LjAwMiA4MC41NzRjMS4xNTItLjE4MiAyLjMzMi0uMjc3IDMuNTM1LS4yNzcuMzE1IDAgLjYyOC4wMDYuOTQuMDJsOTIuMDktOTEuOTE0TDQ5MiA0MC4wNThsNzIuODItMjMuODEyLTE4LjY3NSA3NC4zMDMtMTUuNjY3LTE0LjYxeiIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgICA8cGF0aCBkPSJNNjM3Ljc4MyAxNjAuNzY0QzY3MS40NzUgMjEzLjU3MiA2OTEgMjc2LjI5NiA2OTEgMzQzLjU4YzAgMTg3Ljk3Mi0xNTIuMzggMzQwLjM1My0zNDAuMzUyIDM0MC4zNTMtMTg3Ljk3IDAtMzQwLjM1LTE1Mi4zOC0zNDAuMzUtMzQwLjM1MiAwLTY4LjAzNCAxOS45NjItMTMxLjQwNyA1NC4zNS0xODQuNTggMTMuOTkgNjEuOTMgNjkuMzQ3IDEwOC4xNzYgMTM1LjUwNSAxMDguMTc2Ljg5NiAwIDEuNzktLjAxIDIuNjgzLS4wMjYtMTEuNTg1IDIyLjcwNy0xOC4xMiA0OC40Mi0xOC4xMiA3NS42NiAwIDkyLjA2NyA3NC42MzcgMTY2LjcwMiAxNjYuNzA0IDE2Ni43MDIgOTIuMDY4IDAgMTY2LjcwMy03NC42MzUgMTY2LjcwMy0xNjYuNzAyIDAtMjcuMjQtNi41MzMtNTIuOTUzLTE4LjExOC03NS42Ni44OTIuMDE3IDEuNzg2LjAyNiAyLjY4My4wMjYgNjUuNTI4IDAgMTIwLjQ2LTQ1LjM3IDEzNS4wOTUtMTA2LjQxMnoiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingFooter_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1cd90f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingFooter_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f1cd90f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1cd90f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("41d24144", content, true);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "footer[data-v-6f1cd90f]{padding:50px 0;background-color:#f8f8f8}p.copyright[data-v-6f1cd90f]{margin:15px 0 0}", ""]);

// exports


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing-footer'
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('ul',{staticClass:"list-inline"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',{staticClass:"footer-menu-divider"},[_vm._v("⋅")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#about-pretrendr"}},[_vm._v("About Pretrendr")])]),_vm._v(" "),_c('li',{staticClass:"footer-menu-divider"},[_vm._v("⋅")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#about-us"}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',{staticClass:"footer-menu-divider"},[_vm._v("⋅")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#contact"}},[_vm._v("Contact")])])]),_vm._v(" "),_c('p',{staticClass:"copyright text-muted small"},[_vm._v("Copyright © pretrendr 2017. All Rights Reserved")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('landing-header',{on:{"openRegistration":function($event){_vm.open(_vm.FormTypeEnum.register)},"openLogin":function($event){_vm.open(_vm.FormTypeEnum.login)}}},[_c('git-info',{attrs:{"isActive":_vm.isGitInfoShown}})],1),_vm._v(" "),_c('a',{attrs:{"id":"home"}}),_vm._v(" "),_c('div',{staticClass:"intro-header",style:({'padding-top': _vm.isGitInfoShown ? '80px': '50px'})},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"intro-message"},[_c('h1',[_vm._v("pretrendr")]),_vm._v(" "),_c('h3',[_vm._v("Analyse and Visualize your data and identify trends")]),_vm._v(" "),_c('hr',{staticClass:"intro-divider"}),_vm._v(" "),_c('ul',{staticClass:"list-inline intro-social-buttons"},[_c('li',[_c('a',{ref:"register",staticClass:"btn btn-default btn-lg register",attrs:{"href":"#register"},on:{"click":function($event){$event.preventDefault();_vm.open(_vm.FormTypeEnum.register)}}},[_vm._v("Register Now")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn btn-default btn-lg login",attrs:{"href":"#login"},on:{"click":function($event){$event.preventDefault();_vm.open(_vm.FormTypeEnum.login)}}},[_vm._v("Login")])])])])])])])]),_vm._v(" "),_c('a',{attrs:{"id":"about-pretrendr"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{attrs:{"id":"about-us"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('a',{attrs:{"name":"contact"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('landing-footer'),_vm._v(" "),_c('onboarding-modal',{attrs:{"is-active":_vm.modalActive,"type":_vm.modalType},on:{"close":function($event){_vm.modalActive = false},"changeType":function (newType) { return _vm.modalType = newType; }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-logo"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(423)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section-a"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row display-flex"},[_c('div',{staticClass:"col-lg-5 col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About pretrendr")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Pretrendr is an open source project to predict technology trends out of open data sources. \n            It is a web-based solution to extract trend data out of the worlds broadcast, print and web news and predict \n            if it will become a trend.")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Pretrendr simplifies the identification of existing and emerging trends that reshape industries. \n            News are linked and refined to evaluate trends in order to deliver accurate results. We provide an easy-to-use \n            webpage where trends can be monitored\n            and identified.")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-2 col-sm-6"},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__(424),"alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section-b"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row display-flex"},[_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Us")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            We are a team of seven students from the TU Berlin who came together in a course about agile methods and \n            open source software development. Each team member is studying towards the master of science degree in a \n            software related field. Lara, Tristan, Joud and Scott are studying Computer Science, Florian and Patrick \n            Information Systems Management and Antonia Computer Engineering.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__(425),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(426),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Patrick")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Patrick is a graduate student studying Information Systems Management at TU Berlin.\n            During this project he has worked on the Frontend, Vue.js, Node.js, Git, Java, Javascript, Continuos Integration, CircleCi and Session Handling.\n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/patrick-willmann/"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(427),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Lara")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Lara is a graduate student studying Computer Science at TU Berlin.\n            During this project she has worked on the Frontend, Graphs, D3.js, Workbench, GDELT, JavaScript, Java, Query Optimization and Elasticsearch.\n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/lara-christmann"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(428),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Tristan")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Tristan is a graduate student studying Computer Science at TU Berlin.\n            During this project he has worked on the Backend, Spring/Boot , REST, Databases, Java, Elasticsearch, Query Optimization and AWS S3.\n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on Github :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-default btn-lg",attrs:{"href":"https://github.com/Astarch"}},[_c('i',{staticClass:"fa fa-github fa-fw"}),_vm._v(" "),_c('span',{staticClass:"network-name"},[_vm._v("Github")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(429),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Antonia")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Antonia is a graduate student studying Computer Engineering at TU Berlin.\n            During this project she has worked on the Workbench, Open Data Sources, GDELT, Query Optimization, Elasticsearch, Metrics and Use Cases.\n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/antonia-düker-b25b2211a/"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(430),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Florian")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Florian is a graduate student studying Information Systems Management at TU Berlin.\n            During this project he has worked on the Architecture, AWS, Backend, REST, Java, circleCI, Databases and Elasticsearch.\n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/florian-muchow/"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(431),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Joud")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Joud is a graduate student studying Computer Science at TU Berlin.\n            During this project she has worked on the Backend, Spring boot, Metrics, Postman, AWS S3 and Architecture. \n          ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/joud-sayed-issa-3b740327/"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-lg-offset-1 col-sm-push-6  col-sm-6"},[_c('img',{staticClass:"resize",attrs:{"src":__webpack_require__(432),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-pull-6  col-sm-6"},[_c('hr',{staticClass:"section-heading-spacer"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h2',{staticClass:"section-heading"},[_vm._v("About Scott")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n             Scott is a graduate student studying Computer Science at TU Berlin.\n            During this project he has worked on the Frontend, Workbench, Test Environment, Elastic Map Reduce and Elasticsearch.            ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Get connected on LinkedIn :\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"https://www.linkedin.com/in/scottyswork"}},[_c('i',{staticClass:"fa fa-linkedin fa-fw",attrs:{"aria-hidden":"true"}})])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('h2',[_vm._v("Connect to pretrendr:")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('ul',{staticClass:"list-inline banner-social-buttons"},[_c('li',[_c('a',{staticClass:"btn btn-default btn-lg",attrs:{"href":"https://github.com/Astarch/amos-ws18-proj3"}},[_c('i',{staticClass:"fa fa-github fa-fw"}),_vm._v(" "),_c('span',{staticClass:"network-name"},[_vm._v("Github")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.b03387c.png";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aboutpretrendr.dbde377.jpg";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pretrendr_1.9b8dd0a.jpg";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/patrick.d05e402.jpg";

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lara.99a1ffe.jpg";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tristan.767b065.jpg";

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/antonia.b7c0f7b.jpg";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/florian.7746a0a.jpg";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/joud.849273c.jpg";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scott.8a97cd5.jpg";

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EngagementLayout_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c440c090_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EngagementLayout_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EngagementLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c440c090_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EngagementLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3c71557c", content, true);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_ContentHeader__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_ContentFooter__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EngagementContent__ = __webpack_require__(445);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContentHeader: __WEBPACK_IMPORTED_MODULE_0__base_ContentHeader__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__base_ContentFooter__["a" /* default */],
    EngagementContent: __WEBPACK_IMPORTED_MODULE_2__EngagementContent__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentHeader_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5beb97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentHeader_vue__ = __webpack_require__(440);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5beb97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(_vm.routeName))])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2987a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__(444);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d2987a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright pull-right"},[_c('p',{staticClass:"copyright text-muted small"},[_vm._v("Copyright © pretrendr 2017. All Rights Reserved")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EngagementContent_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcc76b4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EngagementContent_vue__ = __webpack_require__(449);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcc76b4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EngagementContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcc76b4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EngagementContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(447);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0ae13fd7", content, true);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "div.content[data-v-dcc76b4a]{margin-bottom:80px}.fade-enter-active[data-v-dcc76b4a],.fade-leave-active[data-v-dcc76b4a]{transition:opacity .1s}.fade-enter[data-v-dcc76b4a],.fade-leave-to[data-v-dcc76b4a]{opacity:0}", ""]);

// exports


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"engagement-layout"}},[_c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}}),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('content-header'),_vm._v(" "),_c('engagement-content',{nativeOn:{"click":function($event){_vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1),_vm._v(" "),_c('side-bar',{attrs:{"type":"navbar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('ul',{staticClass:"nav navbar-nav"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a95238c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a95238c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a95238c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(453);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4715b164", content, true);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".pretty [data-v-6a95238c]{box-sizing:border-box}.pretty input[data-v-6a95238c]:not([type=checkbox]):not([type=radio]){display:none}.pretty[data-v-6a95238c]{position:relative;display:inline-block;margin-right:1em;white-space:nowrap;line-height:1}.pretty input[data-v-6a95238c]{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.pretty .state label[data-v-6a95238c]{position:static;display:inline-block;font-weight:400;margin:0;text-indent:1.5em;min-width:calc(1em + 2px)}.pretty .state label[data-v-6a95238c]:after,.pretty .state label[data-v-6a95238c]:before{content:\"\";width:calc(1em + 2px);height:calc(1em + 2px);display:block;box-sizing:border-box;border-radius:0;border:1px solid transparent;z-index:0;position:absolute;left:0;top:calc((0% - (100% - 1em)) - 8%);background-color:transparent}.pretty .state label[data-v-6a95238c]:before{border-color:#bdc3c7}.pretty .state.p-is-hover[data-v-6a95238c],.pretty .state.p-is-indeterminate[data-v-6a95238c]{display:none}@keyframes zoom-data-v-6a95238c{0%{opacity:0;transform:scale(0)}}@keyframes tada-data-v-6a95238c{0%{animation-timing-function:ease-in;opacity:0;transform:scale(7)}38%{animation-timing-function:ease-out;opacity:1;transform:scale(1)}55%{animation-timing-function:ease-in;transform:scale(1.5)}72%{animation-timing-function:ease-out;transform:scale(1)}81%{animation-timing-function:ease-in;transform:scale(1.24)}89%{animation-timing-function:ease-out;transform:scale(1)}95%{animation-timing-function:ease-in;transform:scale(1.04)}to{animation-timing-function:ease-out;transform:scale(1)}}@keyframes jelly-data-v-6a95238c{0%{transform:scaleX(1)}30%{transform:scale3d(.75,1.25,1)}40%{transform:scale3d(1.25,.75,1)}50%{transform:scale3d(.85,1.15,1)}65%{transform:scale3d(1.05,.95,1)}75%{transform:scale3d(.95,1.05,1)}to{transform:scaleX(1)}}@keyframes rotate-data-v-6a95238c{0%{opacity:0;transform:translateZ(-200px) rotate(-45deg)}to{opacity:1;transform:translateZ(0) rotate(0)}}@keyframes pulse-data-v-6a95238c{0%{box-shadow:0 0 0 0 #bdc3c7}to{box-shadow:0 0 0 1.5em hsla(204,8%,76%,0)}}.pretty.p-default.p-fill .state label[data-v-6a95238c]:after{transform:scale(1)}.pretty.p-default .state label[data-v-6a95238c]:after{transform:scale(.6)}.pretty.p-default input:checked~.state label[data-v-6a95238c]:after{background-color:#bdc3c7!important}.pretty.p-default.p-thick .state label[data-v-6a95238c]:after,.pretty.p-default.p-thick .state label[data-v-6a95238c]:before{border-width:0.14286em}.pretty.p-default.p-thick .state label[data-v-6a95238c]:after{transform:scale(.4)!important}.pretty.p-icon .state .icon[data-v-6a95238c]{position:absolute;font-size:1em;width:calc(1em + 2px);height:calc(1em + 2px);left:0;z-index:1;text-align:center;line-height:normal;top:calc((0% - (100% - 1em)) - 8%);border:1px solid transparent;opacity:0}.pretty.p-icon .state .icon[data-v-6a95238c]:before{margin:0;width:100%;height:100%;text-align:center;display:flex;flex:1;justify-content:center;align-items:center;line-height:1}.pretty.p-icon input:checked~.state .icon[data-v-6a95238c]{opacity:1}.pretty.p-icon input:checked~.state label[data-v-6a95238c]:before{border-color:#5a656b}.pretty.p-svg .state .svg[data-v-6a95238c]{position:absolute;font-size:1em;width:calc(1em + 2px);height:calc(1em + 2px);left:0;z-index:1;text-align:center;line-height:normal;top:calc((0% - (100% - 1em)) - 8%);border:1px solid transparent;opacity:0}.pretty.p-svg .state svg[data-v-6a95238c]{margin:0;width:100%;height:100%;text-align:center;display:flex;flex:1;justify-content:center;align-items:center;line-height:1}.pretty.p-svg input:checked~.state .svg[data-v-6a95238c]{opacity:1}.pretty.p-image .state img[data-v-6a95238c]{opacity:0;position:absolute;width:calc(1em + 2px);height:calc(1em + 2px);top:0;top:calc((0% - (100% - 1em)) - 8%);left:0;z-index:0;text-align:center;line-height:normal;transform:scale(.8)}.pretty.p-image input:checked~.state img[data-v-6a95238c]{opacity:1}.pretty.p-switch input[data-v-6a95238c]{min-width:2em}.pretty.p-switch .state[data-v-6a95238c]{position:relative}.pretty.p-switch .state[data-v-6a95238c]:before{content:\"\";border:1px solid #bdc3c7;border-radius:60px;width:2em;box-sizing:unset;height:calc(1em + 2px);position:absolute;top:0;top:calc((0% - (100% - 1em)) - 16%);z-index:0;transition:all .5s ease}.pretty.p-switch .state label[data-v-6a95238c]{text-indent:2.5em}.pretty.p-switch .state label[data-v-6a95238c]:after,.pretty.p-switch .state label[data-v-6a95238c]:before{transition:all .5s ease;border-radius:100%;left:0;border-color:transparent;transform:scale(.8)}.pretty.p-switch .state label[data-v-6a95238c]:after{background-color:#bdc3c7!important}.pretty.p-switch input:checked~.state[data-v-6a95238c]:before{border-color:#5a656b}.pretty.p-switch input:checked~.state label[data-v-6a95238c]:before{opacity:0}.pretty.p-switch input:checked~.state label[data-v-6a95238c]:after{background-color:#5a656b!important;left:1em}.pretty.p-switch.p-fill input:checked~.state[data-v-6a95238c]:before{border-color:#5a656b;background-color:#5a656b!important}.pretty.p-switch.p-fill input:checked~.state label[data-v-6a95238c]:before{opacity:0}.pretty.p-switch.p-fill input:checked~.state label[data-v-6a95238c]:after{background-color:#fff!important;left:1em}.pretty.p-switch.p-slim .state[data-v-6a95238c]:before{height:.1em;background:#bdc3c7!important;top:calc(50% - .1em)}.pretty.p-switch.p-slim input:checked~.state[data-v-6a95238c]:before{border-color:#5a656b;background-color:#5a656b!important}.pretty.p-has-hover input:hover~.state[data-v-6a95238c]:not(.p-is-hover){display:none}.pretty.p-has-hover input:hover~.state.p-is-hover .icon[data-v-6a95238c],.pretty.p-has-hover input:hover~.state.p-is-hover[data-v-6a95238c]{display:block}.pretty.p-has-focus input:focus~.state label[data-v-6a95238c]:before{box-shadow:0 0 3px 0 #bdc3c7}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state[data-v-6a95238c]:not(.p-is-indeterminate){display:none}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state.p-is-indeterminate[data-v-6a95238c]{display:block}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state.p-is-indeterminate .icon[data-v-6a95238c]{display:block;opacity:1}.pretty.p-toggle .state.p-on[data-v-6a95238c]{opacity:0;display:none}.pretty.p-toggle .state .icon[data-v-6a95238c],.pretty.p-toggle .state.p-off[data-v-6a95238c],.pretty.p-toggle .state .svg[data-v-6a95238c],.pretty.p-toggle .state img[data-v-6a95238c]{opacity:1;display:inherit}.pretty.p-toggle .state.p-off .icon[data-v-6a95238c]{color:#bdc3c7}.pretty.p-toggle input:checked~.state.p-on[data-v-6a95238c]{opacity:1;display:inherit}.pretty.p-toggle input:checked~.state.p-off[data-v-6a95238c]{opacity:0;display:none}.pretty.p-plain.p-toggle .state label[data-v-6a95238c]:before,.pretty.p-plain input:checked~.state label[data-v-6a95238c]:before{content:none}.pretty.p-plain.p-plain .icon[data-v-6a95238c]{transform:scale(1.1)}.pretty.p-round .state label[data-v-6a95238c]:after,.pretty.p-round .state label[data-v-6a95238c]:before{border-radius:100%}.pretty.p-round.p-icon .state .icon[data-v-6a95238c]{border-radius:100%;overflow:hidden}.pretty.p-round.p-icon .state .icon[data-v-6a95238c]:before{transform:scale(.8)}.pretty.p-curve .state label[data-v-6a95238c]:after,.pretty.p-curve .state label[data-v-6a95238c]:before{border-radius:20%}.pretty.p-smooth .icon[data-v-6a95238c],.pretty.p-smooth .svg[data-v-6a95238c],.pretty.p-smooth label[data-v-6a95238c]:after,.pretty.p-smooth label[data-v-6a95238c]:before{transition:all .5s ease}.pretty.p-smooth input:checked+.state label[data-v-6a95238c]:after{transition:all .3s ease}.pretty.p-smooth.p-default input:checked+.state label[data-v-6a95238c]:after,.pretty.p-smooth input:checked+.state .icon[data-v-6a95238c],.pretty.p-smooth input:checked+.state .svg[data-v-6a95238c],.pretty.p-smooth input:checked+.state img[data-v-6a95238c]{animation:zoom-data-v-6a95238c .2s ease}.pretty.p-smooth.p-plain input:checked+.state label[data-v-6a95238c]:before{content:\"\";transform:scale(0);transition:all .5s ease}.pretty.p-tada:not(.p-default) input:checked+.state .icon[data-v-6a95238c],.pretty.p-tada:not(.p-default) input:checked+.state .svg[data-v-6a95238c],.pretty.p-tada:not(.p-default) input:checked+.state img[data-v-6a95238c],.pretty.p-tada:not(.p-default) input:checked+.state label[data-v-6a95238c]:after,.pretty.p-tada:not(.p-default) input:checked+.state label[data-v-6a95238c]:before{animation:tada-data-v-6a95238c .7s cubic-bezier(.25,.46,.45,.94) 1 alternate;opacity:1}.pretty.p-jelly:not(.p-default) input:checked+.state .icon[data-v-6a95238c],.pretty.p-jelly:not(.p-default) input:checked+.state .svg[data-v-6a95238c],.pretty.p-jelly:not(.p-default) input:checked+.state img[data-v-6a95238c],.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-6a95238c]:after,.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-6a95238c]:before{animation:jelly-data-v-6a95238c .7s cubic-bezier(.25,.46,.45,.94);opacity:1}.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-6a95238c]:before{border-color:transparent}.pretty.p-rotate:not(.p-default) input:checked~.state .icon[data-v-6a95238c],.pretty.p-rotate:not(.p-default) input:checked~.state .svg[data-v-6a95238c],.pretty.p-rotate:not(.p-default) input:checked~.state img[data-v-6a95238c],.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-6a95238c]:after,.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-6a95238c]:before{animation:rotate-data-v-6a95238c .7s cubic-bezier(.25,.46,.45,.94);opacity:1}.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-6a95238c]:before{border-color:transparent}.pretty.p-pulse:not(.p-switch) input:checked~.state label[data-v-6a95238c]:before{animation:pulse-data-v-6a95238c 1s}.pretty input[disabled][data-v-6a95238c]{cursor:not-allowed;display:none}.pretty input[disabled]~[data-v-6a95238c]{opacity:.5}.pretty.p-locked input[data-v-6a95238c]{display:none;cursor:not-allowed}.pretty.p-toggle .state.p-primary label[data-v-6a95238c]:after,.pretty input:checked~.state.p-primary label[data-v-6a95238c]:after{background-color:#428bca!important}.pretty.p-toggle .state.p-primary .icon[data-v-6a95238c],.pretty.p-toggle .state.p-primary .svg[data-v-6a95238c],.pretty input:checked~.state.p-primary .icon[data-v-6a95238c],.pretty input:checked~.state.p-primary .svg[data-v-6a95238c]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-primary-o label[data-v-6a95238c]:before,.pretty input:checked~.state.p-primary-o label[data-v-6a95238c]:before{border-color:#428bca}.pretty.p-toggle .state.p-primary-o label[data-v-6a95238c]:after,.pretty input:checked~.state.p-primary-o label[data-v-6a95238c]:after{background-color:transparent}.pretty.p-toggle .state.p-primary-o .icon[data-v-6a95238c],.pretty.p-toggle .state.p-primary-o .svg[data-v-6a95238c],.pretty.p-toggle .state.p-primary-o svg[data-v-6a95238c],.pretty input:checked~.state.p-primary-o .icon[data-v-6a95238c],.pretty input:checked~.state.p-primary-o .svg[data-v-6a95238c],.pretty input:checked~.state.p-primary-o svg[data-v-6a95238c]{color:#428bca;stroke:#428bca}.pretty.p-default:not(.p-fill) input:checked~.state.p-primary-o label[data-v-6a95238c]:after{background-color:#428bca!important}.pretty.p-switch input:checked~.state.p-primary[data-v-6a95238c]:before{border-color:#428bca}.pretty.p-switch.p-fill input:checked~.state.p-primary[data-v-6a95238c]:before{background-color:#428bca!important}.pretty.p-switch.p-slim input:checked~.state.p-primary[data-v-6a95238c]:before{border-color:#245682;background-color:#245682!important}.pretty.p-toggle .state.p-info label[data-v-6a95238c]:after,.pretty input:checked~.state.p-info label[data-v-6a95238c]:after{background-color:#5bc0de!important}.pretty.p-toggle .state.p-info .icon[data-v-6a95238c],.pretty.p-toggle .state.p-info .svg[data-v-6a95238c],.pretty input:checked~.state.p-info .icon[data-v-6a95238c],.pretty input:checked~.state.p-info .svg[data-v-6a95238c]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-info-o label[data-v-6a95238c]:before,.pretty input:checked~.state.p-info-o label[data-v-6a95238c]:before{border-color:#5bc0de}.pretty.p-toggle .state.p-info-o label[data-v-6a95238c]:after,.pretty input:checked~.state.p-info-o label[data-v-6a95238c]:after{background-color:transparent}.pretty.p-toggle .state.p-info-o .icon[data-v-6a95238c],.pretty.p-toggle .state.p-info-o .svg[data-v-6a95238c],.pretty.p-toggle .state.p-info-o svg[data-v-6a95238c],.pretty input:checked~.state.p-info-o .icon[data-v-6a95238c],.pretty input:checked~.state.p-info-o .svg[data-v-6a95238c],.pretty input:checked~.state.p-info-o svg[data-v-6a95238c]{color:#5bc0de;stroke:#5bc0de}.pretty.p-default:not(.p-fill) input:checked~.state.p-info-o label[data-v-6a95238c]:after{background-color:#5bc0de!important}.pretty.p-switch input:checked~.state.p-info[data-v-6a95238c]:before{border-color:#5bc0de}.pretty.p-switch.p-fill input:checked~.state.p-info[data-v-6a95238c]:before{background-color:#5bc0de!important}.pretty.p-switch.p-slim input:checked~.state.p-info[data-v-6a95238c]:before{border-color:#2390b0;background-color:#2390b0!important}.pretty.p-toggle .state.p-success label[data-v-6a95238c]:after,.pretty input:checked~.state.p-success label[data-v-6a95238c]:after{background-color:#5cb85c!important}.pretty.p-toggle .state.p-success .icon[data-v-6a95238c],.pretty.p-toggle .state.p-success .svg[data-v-6a95238c],.pretty input:checked~.state.p-success .icon[data-v-6a95238c],.pretty input:checked~.state.p-success .svg[data-v-6a95238c]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-success-o label[data-v-6a95238c]:before,.pretty input:checked~.state.p-success-o label[data-v-6a95238c]:before{border-color:#5cb85c}.pretty.p-toggle .state.p-success-o label[data-v-6a95238c]:after,.pretty input:checked~.state.p-success-o label[data-v-6a95238c]:after{background-color:transparent}.pretty.p-toggle .state.p-success-o .icon[data-v-6a95238c],.pretty.p-toggle .state.p-success-o .svg[data-v-6a95238c],.pretty.p-toggle .state.p-success-o svg[data-v-6a95238c],.pretty input:checked~.state.p-success-o .icon[data-v-6a95238c],.pretty input:checked~.state.p-success-o .svg[data-v-6a95238c],.pretty input:checked~.state.p-success-o svg[data-v-6a95238c]{color:#5cb85c;stroke:#5cb85c}.pretty.p-default:not(.p-fill) input:checked~.state.p-success-o label[data-v-6a95238c]:after{background-color:#5cb85c!important}.pretty.p-switch input:checked~.state.p-success[data-v-6a95238c]:before{border-color:#5cb85c}.pretty.p-switch.p-fill input:checked~.state.p-success[data-v-6a95238c]:before{background-color:#5cb85c!important}.pretty.p-switch.p-slim input:checked~.state.p-success[data-v-6a95238c]:before{border-color:#357935;background-color:#357935!important}.pretty.p-toggle .state.p-warning label[data-v-6a95238c]:after,.pretty input:checked~.state.p-warning label[data-v-6a95238c]:after{background-color:#f0ad4e!important}.pretty.p-toggle .state.p-warning .icon[data-v-6a95238c],.pretty.p-toggle .state.p-warning .svg[data-v-6a95238c],.pretty input:checked~.state.p-warning .icon[data-v-6a95238c],.pretty input:checked~.state.p-warning .svg[data-v-6a95238c]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-warning-o label[data-v-6a95238c]:before,.pretty input:checked~.state.p-warning-o label[data-v-6a95238c]:before{border-color:#f0ad4e}.pretty.p-toggle .state.p-warning-o label[data-v-6a95238c]:after,.pretty input:checked~.state.p-warning-o label[data-v-6a95238c]:after{background-color:transparent}.pretty.p-toggle .state.p-warning-o .icon[data-v-6a95238c],.pretty.p-toggle .state.p-warning-o .svg[data-v-6a95238c],.pretty.p-toggle .state.p-warning-o svg[data-v-6a95238c],.pretty input:checked~.state.p-warning-o .icon[data-v-6a95238c],.pretty input:checked~.state.p-warning-o .svg[data-v-6a95238c],.pretty input:checked~.state.p-warning-o svg[data-v-6a95238c]{color:#f0ad4e;stroke:#f0ad4e}.pretty.p-default:not(.p-fill) input:checked~.state.p-warning-o label[data-v-6a95238c]:after{background-color:#f0ad4e!important}.pretty.p-switch input:checked~.state.p-warning[data-v-6a95238c]:before{border-color:#f0ad4e}.pretty.p-switch.p-fill input:checked~.state.p-warning[data-v-6a95238c]:before{background-color:#f0ad4e!important}.pretty.p-switch.p-slim input:checked~.state.p-warning[data-v-6a95238c]:before{border-color:#c77c11;background-color:#c77c11!important}.pretty.p-toggle .state.p-danger label[data-v-6a95238c]:after,.pretty input:checked~.state.p-danger label[data-v-6a95238c]:after{background-color:#d9534f!important}.pretty.p-toggle .state.p-danger .icon[data-v-6a95238c],.pretty.p-toggle .state.p-danger .svg[data-v-6a95238c],.pretty input:checked~.state.p-danger .icon[data-v-6a95238c],.pretty input:checked~.state.p-danger .svg[data-v-6a95238c]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-danger-o label[data-v-6a95238c]:before,.pretty input:checked~.state.p-danger-o label[data-v-6a95238c]:before{border-color:#d9534f}.pretty.p-toggle .state.p-danger-o label[data-v-6a95238c]:after,.pretty input:checked~.state.p-danger-o label[data-v-6a95238c]:after{background-color:transparent}.pretty.p-toggle .state.p-danger-o .icon[data-v-6a95238c],.pretty.p-toggle .state.p-danger-o .svg[data-v-6a95238c],.pretty.p-toggle .state.p-danger-o svg[data-v-6a95238c],.pretty input:checked~.state.p-danger-o .icon[data-v-6a95238c],.pretty input:checked~.state.p-danger-o .svg[data-v-6a95238c],.pretty input:checked~.state.p-danger-o svg[data-v-6a95238c]{color:#d9534f;stroke:#d9534f}.pretty.p-default:not(.p-fill) input:checked~.state.p-danger-o label[data-v-6a95238c]:after{background-color:#d9534f!important}.pretty.p-switch input:checked~.state.p-danger[data-v-6a95238c]:before{border-color:#d9534f}.pretty.p-switch.p-fill input:checked~.state.p-danger[data-v-6a95238c]:before{background-color:#d9534f!important}.pretty.p-switch.p-slim input:checked~.state.p-danger[data-v-6a95238c]:before{border-color:#a02622;background-color:#a02622!important}.pretty.p-bigger .icon[data-v-6a95238c],.pretty.p-bigger .img[data-v-6a95238c],.pretty.p-bigger .svg[data-v-6a95238c],.pretty.p-bigger label[data-v-6a95238c]:after,.pretty.p-bigger label[data-v-6a95238c]:before{font-size:1.2em!important;top:calc((0% - (100% - 1em)) - 35%)!important}.pretty.p-bigger label[data-v-6a95238c]{text-indent:1.7em}@media print{.pretty .state .icon[data-v-6a95238c],.pretty .state[data-v-6a95238c]:before,.pretty .state label[data-v-6a95238c]:after,.pretty .state label[data-v-6a95238c]:before{color-adjust:exact;-webkit-print-color-adjust:exact;print-color-adjust:exact}}div.datatable[data-v-6a95238c]{overflow:auto;max-height:400px;height:auto}#spinner[data-v-6a95238c]{display:flex;justify-content:center;align-items:center;position:absolute}#spinner.overlay[data-v-6a95238c]{width:100%;height:400px}#spinner .hide[data-v-6a95238c]{display:none}#spinner .sk-child[data-v-6a95238c]:before,.sk-child[data-v-6a95238c]{background-color:#127281}div.alert-danger[data-v-6a95238c]{background-color:#ffc107;color:#cd1d2c;position:relative;min-height:1px;margin-right:15px;margin-left:15px;border-radius:5px;display:flex;justify-content:space-between;align-items:center}div.alert-danger i[data-v-6a95238c]{cursor:pointer}.topic-chips h4[data-v-6a95238c]{margin-top:0;font-size:1em}.topic-chips span[data-v-6a95238c]{font-size:1.05em;margin:5px;float:left;display:flex;align-items:center}.topic-chips span span[data-v-6a95238c]{max-width:10em;text-overflow:ellipsis;white-space:nowrap;display:inline-block;overflow:hidden}.topic-chips i[data-v-6a95238c]{vertical-align:middle;line-height:1;font-size:.7em;margin:0 2px;cursor:pointer}.contentframe[data-v-6a95238c]{height:400px}", ""]);

// exports


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_js_models_RequestStatus__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_utils_api__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_utils_datahelper__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Card__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Searchbar__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graph_Graph__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_js_components_engagement_common_AdditionalDataTable__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_BounceLoader_vue__ = __webpack_require__(772);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_6__common_Card__["a" /* default */],
    Graph: __WEBPACK_IMPORTED_MODULE_8__graph_Graph__["a" /* default */],
    SearchBar: __WEBPACK_IMPORTED_MODULE_7__common_Searchbar__["a" /* default */],
    BounceLoader: __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_BounceLoader_vue__["a" /* default */],
    AdditionalData: __WEBPACK_IMPORTED_MODULE_9_src_js_components_engagement_common_AdditionalDataTable__["a" /* default */]
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data: function data() {
    return {
      timerange: "from=20170101&to=20171231",
      trendIndicatorMessage: "",
      queries: [],
      queryTerm: "",
      queryMethod: "ANY",
      isLoading: false,
      reqStatus: new __WEBPACK_IMPORTED_MODULE_3_src_js_models_RequestStatus__["a" /* default */](),
      graphdata: undefined,
      errorMessage: "",
      showNormalizedData: false,
      colors: ["#e6194b", "#3cb44b", "#f58231", "#0082c8", "#911eb4", "#d2f53c", "#fabebe", "#aaffc3", "#008080", "#46f0f0"],
      availableColors: this.colors
    };
  },

  computed: {
    hasTrends: function hasTrends() {
      return this.queries.length > 0 || this.isLoading;
    },
    hasError: function hasError() {
      return this.errorMessage.length > 0;
    },
    prettyTimerange: function prettyTimerange() {
      var prettyDateFormat = "ll";
      var test = this.timerange.split("&");
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(test[0].split("=")[1], "YYYYMMDD");
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(test[1].split("=")[1], "YYYYMMDD");
      return "From " + start.format(prettyDateFormat) + " to " + end.format(prettyDateFormat);
    },
    cachedTerms: function cachedTerms() {
      return this.$store.state.trends.cachedTrendsList;
    }
  },
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["getWordcountByDay", "updateCurrentSearchQueries", "getCachedTrends"]), {
    formattedTerm: function formattedTerm(query) {
      if (query.method == "ALL") {
        return query.query.trim().replace(/\s/g, "&");
      } else if (query.method == "EXACT") {
        return "\"" + query.query.trim() + "\"";
      } else if (query.method == "ANY") {
        return query.query.trim();
      }
      return query.query.trim();
    },
    clearError: function clearError() {
      this.errorMessage = "";
    },
    giveTrendIndication: function giveTrendIndication(newQuery, graphdata) {
      var trendData = [];
      $.each(graphdata, function (key, value) {
        trendData.push({ value: value });
      });
      var countTrend = 0;
      var falling = undefined;
      console.log(trendData.length);
      var tmp = trendData.length - 1;
      for (var i = 0; i < tmp; i--) {
        if (trendData[tmp].value - trendData[tmp - 1].value > 0 && falling == undefined) {
          falling = false;
          countTrend += 1;
          tmp--;
          continue;
        }
        if (trendData[tmp].value - trendData[tmp - 1].value < 0 && falling == undefined) {
          falling = true;
          countTrend += 1;
          tmp--;
          continue;
        }
        if (trendData[tmp].value - trendData[tmp - 1].value < 0 && falling == true) {
          countTrend += 1;
          tmp--;
          continue;
        }
        if (trendData[tmp].value - trendData[tmp - 1].value > 0 && falling == false) {
          countTrend += 1;
          tmp--;
          continue;
        }
        break;
      }
      if (countTrend > 2) {
        if (falling == true) {
          this.trendIndicatorMessage = "The trend for '" + newQuery.query + "' seems to have been fallen for a while and will probably fall more!";
        } else {
          this.trendIndicatorMessage = "The trend for '" + newQuery.query + "' seems to have been rising for a while and will probably rise more!";
        }
      }
      if (countTrend < 3 && countTrend > 0) {
        if (falling == true) {
          this.trendIndicatorMessage = "The trend for '" + newQuery.query + "'  is falling at the moment!";
        } else {
          this.trendIndicatorMessage = "The trend for '" + newQuery.query + "'  is rising at the moment!";
        }
      }
      if (countTrend == 0) {
        this.trendIndicatorMessage = "The trend has not been falling or rising at the moment for " + newQuery.query;
      }
      console.log("This is the message: " + this.trendIndicatorMessage + " ,The count: " + countTrend + " ,Falling?: " + falling);
    },
    setData: function setData(data) {
      console.log("setData:", data);
      this.isLoading = false;
      this.graphdata = data;
    },
    areQueriesEqual: function areQueriesEqual(oldQuery, newQuery) {
      return oldQuery.query === newQuery.query && oldQuery.method === newQuery.method;
    },
    hasQuery: function hasQuery(newQuery) {
      var _this = this;

      var oldQueryIndex = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(this.queries, function (q) {
        var isSingleTerm = q.query.trim().split(" ").length == 1;
        if (isSingleTerm) {
          return q.query === newQuery.query;
        } else {
          return _this.areQueriesEqual(q, newQuery);
        }
      });
      return oldQueryIndex >= 0;
    },
    removeQuery: function removeQuery(newQuery) {
      var _this2 = this;

      var oldQueryIndex = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(this.queries, function (q) {
        return _this2.areQueriesEqual(q, newQuery);
      });
      if (oldQueryIndex >= 0) {
        this.queries.splice(oldQueryIndex, 1);
        this.availableColors.push(newQuery.color);
      }
      this.updateCurrentSearchQueries(this.queries).then(function (resp) {
        console.log(_this2.$store.user.currentSearchQueries);
      }).catch(function (error) {});
    },
    addQueryData: function addQueryData(newQuery, data) {
      var _this3 = this;

      var oldQueryIndex = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(this.queries, function (q) {
        return _this3.areQueriesEqual(q, newQuery);
      });
      var color = this.colors[this.queries.length % this.colors.length];
      color = this.availableColors.pop();
      var _query = Object.assign({}, newQuery, { data: data, color: color });
      if (oldQueryIndex >= 0) {
        this.queries = Object.assign([].concat(_toConsumableArray(this.queries)), _defineProperty({}, oldQueryIndex, _query));
      } else {
        this.queries = [].concat(_toConsumableArray(this.queries), [_query]);
      }
      this.isLoading = false;
      this.updateCurrentSearchQueries(this.queries).then(function (resp) {
        console.log(_this3.$store.user.currentSearchQueries);
      }).catch(function (error) {});
    },
    fetchStateWordCountData: function fetchStateWordCountData(query, method, timerange) {
      return this.$store.getters.getTrendByDay(query, method, timerange);
    },
    fetchWordcountData: function fetchWordcountData(queryObj) {
      var _this4 = this;

      this.isLoading = true;

      var stateData = this.fetchStateWordCountData(queryObj.query, queryObj.method, queryObj.timerange);

      var reqObj = Object.assign({}, queryObj, { normalize: false });

      if (stateData != undefined && stateData.data != undefined) {
        console.log("stateData:", stateData);
        this.addQueryData(stateData, stateData.data);
        //this.setData(stateData.data);
      } else {
        this.getWordcountByDay(reqObj).then(function (resp) {
          _this4.reqStatus = resp.req;
          console.log(resp.trend);
          if (!resp.trend.data || Object.keys(resp.trend.data).length === 0) {
            return undefined;
          }
          //this.setData(resp.trend.data);
          // upload server result to firestore!

          _this4.addQueryData(queryObj, resp.trend.data);
          _this4.giveTrendIndication(queryObj, resp.trend.data);
        }).catch(function (requestStatus) {
          _this4.reqStatus = requestStatus;
          console.log(requestStatus);
          _this4.isLoading = false;
          graphdata: undefined;
        });
      }
    },
    onSearchQuerySubmitted: function onSearchQuerySubmitted(queryObj) {
      console.log("onSearchQuerySubmitted() ", queryObj);
      var query = {
        query: queryObj.query,
        method: queryObj.method,
        timerange: this.timerange
      };
      if (this.hasQuery(query)) {
        return;
      }
      if (this.queries.length >= 10) {
        this.errorMessage = "Only up to 10 terms allowed!";
        return;
      }
      this.queryTerm = "";
      this.fetchWordcountData(query);
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    this.availableColors = this.colors;
    this.getCachedTrends().then(function (response) {
      return console.log(response);
    }).catch(function (error) {
      return console.error(error);
    });
    var lastQueries = this.$store.state.user.currentSearchQueries;
    if (lastQueries && lastQueries.length > 0) {
      //this.timerange = lastQuery.timerange;
      lastQueries.forEach(function (query) {
        return _this5.fetchWordcountData(query);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1953c56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1953c56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1953c56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(457);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("589c25ec", content, true);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_vm._t("title"),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._t("subTitle")],2)],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content"),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Searchbar_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1190b276_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Searchbar_vue__ = __webpack_require__(464);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1190b276"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Searchbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1190b276_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Searchbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(462);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0aa25984", content, true);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".pretty [data-v-1190b276]{box-sizing:border-box}.pretty input[data-v-1190b276]:not([type=checkbox]):not([type=radio]){display:none}.pretty[data-v-1190b276]{position:relative;display:inline-block;margin-right:1em;white-space:nowrap;line-height:1}.pretty input[data-v-1190b276]{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.pretty .state label[data-v-1190b276]{position:static;display:inline-block;font-weight:400;margin:0;text-indent:1.5em;min-width:calc(1em + 2px)}.pretty .state label[data-v-1190b276]:after,.pretty .state label[data-v-1190b276]:before{content:\"\";width:calc(1em + 2px);height:calc(1em + 2px);display:block;box-sizing:border-box;border-radius:0;border:1px solid transparent;z-index:0;position:absolute;left:0;top:calc((0% - (100% - 1em)) - 8%);background-color:transparent}.pretty .state label[data-v-1190b276]:before{border-color:#bdc3c7}.pretty .state.p-is-hover[data-v-1190b276],.pretty .state.p-is-indeterminate[data-v-1190b276]{display:none}@keyframes zoom-data-v-1190b276{0%{opacity:0;transform:scale(0)}}@keyframes tada-data-v-1190b276{0%{animation-timing-function:ease-in;opacity:0;transform:scale(7)}38%{animation-timing-function:ease-out;opacity:1;transform:scale(1)}55%{animation-timing-function:ease-in;transform:scale(1.5)}72%{animation-timing-function:ease-out;transform:scale(1)}81%{animation-timing-function:ease-in;transform:scale(1.24)}89%{animation-timing-function:ease-out;transform:scale(1)}95%{animation-timing-function:ease-in;transform:scale(1.04)}to{animation-timing-function:ease-out;transform:scale(1)}}@keyframes jelly-data-v-1190b276{0%{transform:scaleX(1)}30%{transform:scale3d(.75,1.25,1)}40%{transform:scale3d(1.25,.75,1)}50%{transform:scale3d(.85,1.15,1)}65%{transform:scale3d(1.05,.95,1)}75%{transform:scale3d(.95,1.05,1)}to{transform:scaleX(1)}}@keyframes rotate-data-v-1190b276{0%{opacity:0;transform:translateZ(-200px) rotate(-45deg)}to{opacity:1;transform:translateZ(0) rotate(0)}}@keyframes pulse-data-v-1190b276{0%{box-shadow:0 0 0 0 #bdc3c7}to{box-shadow:0 0 0 1.5em hsla(204,8%,76%,0)}}.pretty.p-default.p-fill .state label[data-v-1190b276]:after{transform:scale(1)}.pretty.p-default .state label[data-v-1190b276]:after{transform:scale(.6)}.pretty.p-default input:checked~.state label[data-v-1190b276]:after{background-color:#bdc3c7!important}.pretty.p-default.p-thick .state label[data-v-1190b276]:after,.pretty.p-default.p-thick .state label[data-v-1190b276]:before{border-width:0.14286em}.pretty.p-default.p-thick .state label[data-v-1190b276]:after{transform:scale(.4)!important}.pretty.p-icon .state .icon[data-v-1190b276]{position:absolute;font-size:1em;width:calc(1em + 2px);height:calc(1em + 2px);left:0;z-index:1;text-align:center;line-height:normal;top:calc((0% - (100% - 1em)) - 8%);border:1px solid transparent;opacity:0}.pretty.p-icon .state .icon[data-v-1190b276]:before{margin:0;width:100%;height:100%;text-align:center;display:flex;flex:1;justify-content:center;align-items:center;line-height:1}.pretty.p-icon input:checked~.state .icon[data-v-1190b276]{opacity:1}.pretty.p-icon input:checked~.state label[data-v-1190b276]:before{border-color:#5a656b}.pretty.p-svg .state .svg[data-v-1190b276]{position:absolute;font-size:1em;width:calc(1em + 2px);height:calc(1em + 2px);left:0;z-index:1;text-align:center;line-height:normal;top:calc((0% - (100% - 1em)) - 8%);border:1px solid transparent;opacity:0}.pretty.p-svg .state svg[data-v-1190b276]{margin:0;width:100%;height:100%;text-align:center;display:flex;flex:1;justify-content:center;align-items:center;line-height:1}.pretty.p-svg input:checked~.state .svg[data-v-1190b276]{opacity:1}.pretty.p-image .state img[data-v-1190b276]{opacity:0;position:absolute;width:calc(1em + 2px);height:calc(1em + 2px);top:0;top:calc((0% - (100% - 1em)) - 8%);left:0;z-index:0;text-align:center;line-height:normal;transform:scale(.8)}.pretty.p-image input:checked~.state img[data-v-1190b276]{opacity:1}.pretty.p-switch input[data-v-1190b276]{min-width:2em}.pretty.p-switch .state[data-v-1190b276]{position:relative}.pretty.p-switch .state[data-v-1190b276]:before{content:\"\";border:1px solid #bdc3c7;border-radius:60px;width:2em;box-sizing:unset;height:calc(1em + 2px);position:absolute;top:0;top:calc((0% - (100% - 1em)) - 16%);z-index:0;transition:all .5s ease}.pretty.p-switch .state label[data-v-1190b276]{text-indent:2.5em}.pretty.p-switch .state label[data-v-1190b276]:after,.pretty.p-switch .state label[data-v-1190b276]:before{transition:all .5s ease;border-radius:100%;left:0;border-color:transparent;transform:scale(.8)}.pretty.p-switch .state label[data-v-1190b276]:after{background-color:#bdc3c7!important}.pretty.p-switch input:checked~.state[data-v-1190b276]:before{border-color:#5a656b}.pretty.p-switch input:checked~.state label[data-v-1190b276]:before{opacity:0}.pretty.p-switch input:checked~.state label[data-v-1190b276]:after{background-color:#5a656b!important;left:1em}.pretty.p-switch.p-fill input:checked~.state[data-v-1190b276]:before{border-color:#5a656b;background-color:#5a656b!important}.pretty.p-switch.p-fill input:checked~.state label[data-v-1190b276]:before{opacity:0}.pretty.p-switch.p-fill input:checked~.state label[data-v-1190b276]:after{background-color:#fff!important;left:1em}.pretty.p-switch.p-slim .state[data-v-1190b276]:before{height:.1em;background:#bdc3c7!important;top:calc(50% - .1em)}.pretty.p-switch.p-slim input:checked~.state[data-v-1190b276]:before{border-color:#5a656b;background-color:#5a656b!important}.pretty.p-has-hover input:hover~.state[data-v-1190b276]:not(.p-is-hover){display:none}.pretty.p-has-hover input:hover~.state.p-is-hover .icon[data-v-1190b276],.pretty.p-has-hover input:hover~.state.p-is-hover[data-v-1190b276]{display:block}.pretty.p-has-focus input:focus~.state label[data-v-1190b276]:before{box-shadow:0 0 3px 0 #bdc3c7}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state[data-v-1190b276]:not(.p-is-indeterminate){display:none}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state.p-is-indeterminate[data-v-1190b276]{display:block}.pretty.p-has-indeterminate input[type=checkbox]:indeterminate~.state.p-is-indeterminate .icon[data-v-1190b276]{display:block;opacity:1}.pretty.p-toggle .state.p-on[data-v-1190b276]{opacity:0;display:none}.pretty.p-toggle .state .icon[data-v-1190b276],.pretty.p-toggle .state.p-off[data-v-1190b276],.pretty.p-toggle .state .svg[data-v-1190b276],.pretty.p-toggle .state img[data-v-1190b276]{opacity:1;display:inherit}.pretty.p-toggle .state.p-off .icon[data-v-1190b276]{color:#bdc3c7}.pretty.p-toggle input:checked~.state.p-on[data-v-1190b276]{opacity:1;display:inherit}.pretty.p-toggle input:checked~.state.p-off[data-v-1190b276]{opacity:0;display:none}.pretty.p-plain.p-toggle .state label[data-v-1190b276]:before,.pretty.p-plain input:checked~.state label[data-v-1190b276]:before{content:none}.pretty.p-plain.p-plain .icon[data-v-1190b276]{transform:scale(1.1)}.pretty.p-round .state label[data-v-1190b276]:after,.pretty.p-round .state label[data-v-1190b276]:before{border-radius:100%}.pretty.p-round.p-icon .state .icon[data-v-1190b276]{border-radius:100%;overflow:hidden}.pretty.p-round.p-icon .state .icon[data-v-1190b276]:before{transform:scale(.8)}.pretty.p-curve .state label[data-v-1190b276]:after,.pretty.p-curve .state label[data-v-1190b276]:before{border-radius:20%}.pretty.p-smooth .icon[data-v-1190b276],.pretty.p-smooth .svg[data-v-1190b276],.pretty.p-smooth label[data-v-1190b276]:after,.pretty.p-smooth label[data-v-1190b276]:before{transition:all .5s ease}.pretty.p-smooth input:checked+.state label[data-v-1190b276]:after{transition:all .3s ease}.pretty.p-smooth.p-default input:checked+.state label[data-v-1190b276]:after,.pretty.p-smooth input:checked+.state .icon[data-v-1190b276],.pretty.p-smooth input:checked+.state .svg[data-v-1190b276],.pretty.p-smooth input:checked+.state img[data-v-1190b276]{animation:zoom-data-v-1190b276 .2s ease}.pretty.p-smooth.p-plain input:checked+.state label[data-v-1190b276]:before{content:\"\";transform:scale(0);transition:all .5s ease}.pretty.p-tada:not(.p-default) input:checked+.state .icon[data-v-1190b276],.pretty.p-tada:not(.p-default) input:checked+.state .svg[data-v-1190b276],.pretty.p-tada:not(.p-default) input:checked+.state img[data-v-1190b276],.pretty.p-tada:not(.p-default) input:checked+.state label[data-v-1190b276]:after,.pretty.p-tada:not(.p-default) input:checked+.state label[data-v-1190b276]:before{animation:tada-data-v-1190b276 .7s cubic-bezier(.25,.46,.45,.94) 1 alternate;opacity:1}.pretty.p-jelly:not(.p-default) input:checked+.state .icon[data-v-1190b276],.pretty.p-jelly:not(.p-default) input:checked+.state .svg[data-v-1190b276],.pretty.p-jelly:not(.p-default) input:checked+.state img[data-v-1190b276],.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-1190b276]:after,.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-1190b276]:before{animation:jelly-data-v-1190b276 .7s cubic-bezier(.25,.46,.45,.94);opacity:1}.pretty.p-jelly:not(.p-default) input:checked+.state label[data-v-1190b276]:before{border-color:transparent}.pretty.p-rotate:not(.p-default) input:checked~.state .icon[data-v-1190b276],.pretty.p-rotate:not(.p-default) input:checked~.state .svg[data-v-1190b276],.pretty.p-rotate:not(.p-default) input:checked~.state img[data-v-1190b276],.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-1190b276]:after,.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-1190b276]:before{animation:rotate-data-v-1190b276 .7s cubic-bezier(.25,.46,.45,.94);opacity:1}.pretty.p-rotate:not(.p-default) input:checked~.state label[data-v-1190b276]:before{border-color:transparent}.pretty.p-pulse:not(.p-switch) input:checked~.state label[data-v-1190b276]:before{animation:pulse-data-v-1190b276 1s}.pretty input[disabled][data-v-1190b276]{cursor:not-allowed;display:none}.pretty input[disabled]~[data-v-1190b276]{opacity:.5}.pretty.p-locked input[data-v-1190b276]{display:none;cursor:not-allowed}.pretty.p-toggle .state.p-primary label[data-v-1190b276]:after,.pretty input:checked~.state.p-primary label[data-v-1190b276]:after{background-color:#428bca!important}.pretty.p-toggle .state.p-primary .icon[data-v-1190b276],.pretty.p-toggle .state.p-primary .svg[data-v-1190b276],.pretty input:checked~.state.p-primary .icon[data-v-1190b276],.pretty input:checked~.state.p-primary .svg[data-v-1190b276]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-primary-o label[data-v-1190b276]:before,.pretty input:checked~.state.p-primary-o label[data-v-1190b276]:before{border-color:#428bca}.pretty.p-toggle .state.p-primary-o label[data-v-1190b276]:after,.pretty input:checked~.state.p-primary-o label[data-v-1190b276]:after{background-color:transparent}.pretty.p-toggle .state.p-primary-o .icon[data-v-1190b276],.pretty.p-toggle .state.p-primary-o .svg[data-v-1190b276],.pretty.p-toggle .state.p-primary-o svg[data-v-1190b276],.pretty input:checked~.state.p-primary-o .icon[data-v-1190b276],.pretty input:checked~.state.p-primary-o .svg[data-v-1190b276],.pretty input:checked~.state.p-primary-o svg[data-v-1190b276]{color:#428bca;stroke:#428bca}.pretty.p-default:not(.p-fill) input:checked~.state.p-primary-o label[data-v-1190b276]:after{background-color:#428bca!important}.pretty.p-switch input:checked~.state.p-primary[data-v-1190b276]:before{border-color:#428bca}.pretty.p-switch.p-fill input:checked~.state.p-primary[data-v-1190b276]:before{background-color:#428bca!important}.pretty.p-switch.p-slim input:checked~.state.p-primary[data-v-1190b276]:before{border-color:#245682;background-color:#245682!important}.pretty.p-toggle .state.p-info label[data-v-1190b276]:after,.pretty input:checked~.state.p-info label[data-v-1190b276]:after{background-color:#5bc0de!important}.pretty.p-toggle .state.p-info .icon[data-v-1190b276],.pretty.p-toggle .state.p-info .svg[data-v-1190b276],.pretty input:checked~.state.p-info .icon[data-v-1190b276],.pretty input:checked~.state.p-info .svg[data-v-1190b276]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-info-o label[data-v-1190b276]:before,.pretty input:checked~.state.p-info-o label[data-v-1190b276]:before{border-color:#5bc0de}.pretty.p-toggle .state.p-info-o label[data-v-1190b276]:after,.pretty input:checked~.state.p-info-o label[data-v-1190b276]:after{background-color:transparent}.pretty.p-toggle .state.p-info-o .icon[data-v-1190b276],.pretty.p-toggle .state.p-info-o .svg[data-v-1190b276],.pretty.p-toggle .state.p-info-o svg[data-v-1190b276],.pretty input:checked~.state.p-info-o .icon[data-v-1190b276],.pretty input:checked~.state.p-info-o .svg[data-v-1190b276],.pretty input:checked~.state.p-info-o svg[data-v-1190b276]{color:#5bc0de;stroke:#5bc0de}.pretty.p-default:not(.p-fill) input:checked~.state.p-info-o label[data-v-1190b276]:after{background-color:#5bc0de!important}.pretty.p-switch input:checked~.state.p-info[data-v-1190b276]:before{border-color:#5bc0de}.pretty.p-switch.p-fill input:checked~.state.p-info[data-v-1190b276]:before{background-color:#5bc0de!important}.pretty.p-switch.p-slim input:checked~.state.p-info[data-v-1190b276]:before{border-color:#2390b0;background-color:#2390b0!important}.pretty.p-toggle .state.p-success label[data-v-1190b276]:after,.pretty input:checked~.state.p-success label[data-v-1190b276]:after{background-color:#5cb85c!important}.pretty.p-toggle .state.p-success .icon[data-v-1190b276],.pretty.p-toggle .state.p-success .svg[data-v-1190b276],.pretty input:checked~.state.p-success .icon[data-v-1190b276],.pretty input:checked~.state.p-success .svg[data-v-1190b276]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-success-o label[data-v-1190b276]:before,.pretty input:checked~.state.p-success-o label[data-v-1190b276]:before{border-color:#5cb85c}.pretty.p-toggle .state.p-success-o label[data-v-1190b276]:after,.pretty input:checked~.state.p-success-o label[data-v-1190b276]:after{background-color:transparent}.pretty.p-toggle .state.p-success-o .icon[data-v-1190b276],.pretty.p-toggle .state.p-success-o .svg[data-v-1190b276],.pretty.p-toggle .state.p-success-o svg[data-v-1190b276],.pretty input:checked~.state.p-success-o .icon[data-v-1190b276],.pretty input:checked~.state.p-success-o .svg[data-v-1190b276],.pretty input:checked~.state.p-success-o svg[data-v-1190b276]{color:#5cb85c;stroke:#5cb85c}.pretty.p-default:not(.p-fill) input:checked~.state.p-success-o label[data-v-1190b276]:after{background-color:#5cb85c!important}.pretty.p-switch input:checked~.state.p-success[data-v-1190b276]:before{border-color:#5cb85c}.pretty.p-switch.p-fill input:checked~.state.p-success[data-v-1190b276]:before{background-color:#5cb85c!important}.pretty.p-switch.p-slim input:checked~.state.p-success[data-v-1190b276]:before{border-color:#357935;background-color:#357935!important}.pretty.p-toggle .state.p-warning label[data-v-1190b276]:after,.pretty input:checked~.state.p-warning label[data-v-1190b276]:after{background-color:#f0ad4e!important}.pretty.p-toggle .state.p-warning .icon[data-v-1190b276],.pretty.p-toggle .state.p-warning .svg[data-v-1190b276],.pretty input:checked~.state.p-warning .icon[data-v-1190b276],.pretty input:checked~.state.p-warning .svg[data-v-1190b276]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-warning-o label[data-v-1190b276]:before,.pretty input:checked~.state.p-warning-o label[data-v-1190b276]:before{border-color:#f0ad4e}.pretty.p-toggle .state.p-warning-o label[data-v-1190b276]:after,.pretty input:checked~.state.p-warning-o label[data-v-1190b276]:after{background-color:transparent}.pretty.p-toggle .state.p-warning-o .icon[data-v-1190b276],.pretty.p-toggle .state.p-warning-o .svg[data-v-1190b276],.pretty.p-toggle .state.p-warning-o svg[data-v-1190b276],.pretty input:checked~.state.p-warning-o .icon[data-v-1190b276],.pretty input:checked~.state.p-warning-o .svg[data-v-1190b276],.pretty input:checked~.state.p-warning-o svg[data-v-1190b276]{color:#f0ad4e;stroke:#f0ad4e}.pretty.p-default:not(.p-fill) input:checked~.state.p-warning-o label[data-v-1190b276]:after{background-color:#f0ad4e!important}.pretty.p-switch input:checked~.state.p-warning[data-v-1190b276]:before{border-color:#f0ad4e}.pretty.p-switch.p-fill input:checked~.state.p-warning[data-v-1190b276]:before{background-color:#f0ad4e!important}.pretty.p-switch.p-slim input:checked~.state.p-warning[data-v-1190b276]:before{border-color:#c77c11;background-color:#c77c11!important}.pretty.p-toggle .state.p-danger label[data-v-1190b276]:after,.pretty input:checked~.state.p-danger label[data-v-1190b276]:after{background-color:#d9534f!important}.pretty.p-toggle .state.p-danger .icon[data-v-1190b276],.pretty.p-toggle .state.p-danger .svg[data-v-1190b276],.pretty input:checked~.state.p-danger .icon[data-v-1190b276],.pretty input:checked~.state.p-danger .svg[data-v-1190b276]{color:#fff;stroke:#fff}.pretty.p-toggle .state.p-danger-o label[data-v-1190b276]:before,.pretty input:checked~.state.p-danger-o label[data-v-1190b276]:before{border-color:#d9534f}.pretty.p-toggle .state.p-danger-o label[data-v-1190b276]:after,.pretty input:checked~.state.p-danger-o label[data-v-1190b276]:after{background-color:transparent}.pretty.p-toggle .state.p-danger-o .icon[data-v-1190b276],.pretty.p-toggle .state.p-danger-o .svg[data-v-1190b276],.pretty.p-toggle .state.p-danger-o svg[data-v-1190b276],.pretty input:checked~.state.p-danger-o .icon[data-v-1190b276],.pretty input:checked~.state.p-danger-o .svg[data-v-1190b276],.pretty input:checked~.state.p-danger-o svg[data-v-1190b276]{color:#d9534f;stroke:#d9534f}.pretty.p-default:not(.p-fill) input:checked~.state.p-danger-o label[data-v-1190b276]:after{background-color:#d9534f!important}.pretty.p-switch input:checked~.state.p-danger[data-v-1190b276]:before{border-color:#d9534f}.pretty.p-switch.p-fill input:checked~.state.p-danger[data-v-1190b276]:before{background-color:#d9534f!important}.pretty.p-switch.p-slim input:checked~.state.p-danger[data-v-1190b276]:before{border-color:#a02622;background-color:#a02622!important}.pretty.p-bigger .icon[data-v-1190b276],.pretty.p-bigger .img[data-v-1190b276],.pretty.p-bigger .svg[data-v-1190b276],.pretty.p-bigger label[data-v-1190b276]:after,.pretty.p-bigger label[data-v-1190b276]:before{font-size:1.2em!important;top:calc((0% - (100% - 1em)) - 35%)!important}.pretty.p-bigger label[data-v-1190b276]{text-indent:1.7em}@media print{.pretty .state .icon[data-v-1190b276],.pretty .state[data-v-1190b276]:before,.pretty .state label[data-v-1190b276]:after,.pretty .state label[data-v-1190b276]:before{color-adjust:exact;-webkit-print-color-adjust:exact;print-color-adjust:exact}}.pretty.p-default input:checked~.state label[data-v-1190b276]:after{background-color:#127281!important}.pretty .state label[data-v-1190b276]{vertical-align:middle}.searchtype[data-v-1190b276]{margin:5px 5px 15px}ul.suggestions[data-v-1190b276]{box-shadow:0 2px 2px hsla(38,16%,76%,.5);position:absolute;top:50px;padding:0;right:48px;left:0;list-style:none;background:#fff;max-height:200px;overflow:auto;z-index:1}ul.suggestions li[data-v-1190b276]{padding:5px 19px}ul.suggestions li.active[data-v-1190b276],ul.suggestions li[data-v-1190b276]:hover{background:#f8f8f8;color:#127281}ul.suggestions p[data-v-1190b276]{cursor:pointer;margin:0}ul.suggestions small[data-v-1190b276]{font-size:.6em;color:#127281}.searchbox[data-v-1190b276]{display:inline-block;position:relative;width:100%;height:45px;white-space:nowrap;box-sizing:border-box;font-size:16px}.searchbox .searchbox_wrapper[data-v-1190b276]{width:100%;height:100%;box-shadow:0 2px 2px hsla(38,16%,76%,.5);border:0;border-radius:6px}.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276]{display:inline-block;transition:box-shadow .4s ease,background .4s ease;border:0;border-radius:6px;background:#fff;padding:0;padding-right:77px;padding-left:18px;width:100%;height:100%;vertical-align:middle;white-space:normal;font-size:inherit;appearance:none}.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] ::-webkit-search-cancel-button,.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] ::-webkit-search-decoration,.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] ::-webkit-search-results-button,.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] ::-webkit-search-results-decoration{display:none}.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] :hover{box-shadow:inset 0 0 0 1px silver}.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] :active,.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] :focus{outline:0;box-shadow:inset 0 0 0 1px #aaa;background:#fff}.searchbox .searchbox_wrapper .searchbar_input[data-v-1190b276] ::placeholder{color:#aaa}.searchbox .searchbox_wrapper .submit[data-v-1190b276]{position:absolute;top:0;right:0;left:inherit;margin:0;border:0;border-radius:0 3px 3px 0;background-color:#127281;padding:0;width:47px;height:100%;vertical-align:middle;text-align:center;font-size:inherit;user-select:none}.searchbox .searchbox_wrapper .submit i[data-v-1190b276]{width:19px;height:19px;vertical-align:middle;color:#fff}.searchbox .searchbox_wrapper .submit[data-v-1190b276] :active,.searchbox .searchbox_wrapper .submit[data-v-1190b276] :hover{cursor:pointer}.searchbox .searchbox_wrapper .submit[data-v-1190b276] :focus{outline:0}.searchbox .searchbox_wrapper .searchbar_input:valid~.reset[data-v-1190b276]{display:block;animation-name:reset-in-data-v-1190b276;animation-duration:.15s}.searchbox .searchbox_wrapper .reset[data-v-1190b276]{display:none;position:absolute;top:12px;right:57px;margin:0;border:0;background:none;cursor:pointer;padding:0;font-size:inherit;user-select:none;fill:rgba(0,0,0,.5)}.searchbox .searchbox_wrapper .reset[data-v-1190b276] :focus{outline:0}.searchbox .searchbox_wrapper .reset i[data-v-1190b276]{display:block;margin:4px;width:13px;height:13px}@keyframes reset-in-data-v-1190b276{0%{transform:translate3d(-20%,0,0);opacity:0}to{transform:none;opacity:1}}", ""]);

// exports


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "search-bar",
  components: {},
  props: {
    initialSearchType: {
      validator: function validator(value) {
        return value === "ANY" || value === "EXACT" || value === "ALL";
      },
      default: function _default() {
        return "ANY";
      }
    },
    initialSearchTerm: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    cachedSearchTerms: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      searchTerm: this.initialSearchTerm,
      searchType: this.initialSearchType,
      cachedTerms: this.cachedSearchTerms,
      activeSuggestionsIndex: -1
    };
  },
  watch: {
    initialSearchTerm: function initialSearchTerm(newVal, oldValue) {
      this.searchTerm = newVal;
    },
    initialSearchType: function initialSearchType(newVal, oldValue) {
      this.searchType = newVal;
    },
    cachedSearchTerms: function cachedSearchTerms(newVal, oldVal) {
      console.log(newVal);
      this.cachedTerms = newVal;
    }
  },
  computed: {
    showSuggestions: function showSuggestions() {
      var showSuggestions = false;
      var distinctSuggestions = this.currentSuggestions.reduce(function (total, current) {
        if (total.length == 0 || total.indexOf(current.query) < 0) {
          total.push(current.query);
        }
        return total;
      }, []);
      if (distinctSuggestions.length == 1) {
        showSuggestions = this.searchTerm.toLowerCase() != distinctSuggestions[0].toLowerCase();
      } else {
        showSuggestions = distinctSuggestions.length > 1 && this.searchTerm.length > 1;
      }
      if (!showSuggestions) {
        this.activeSuggestionsIndex = -1;
      }
      return showSuggestions || this.forceShowAllSuggestions;
    },
    currentSuggestions: function currentSuggestions() {
      var _this = this;

      var filteredSuggestions = this.cachedTerms.filter(function (queryObj) {
        return queryObj.query.toLowerCase().indexOf(_this.searchTerm.toLowerCase()) >= 0;
      });

      if (this.activeSuggestionsIndex > filteredSuggestions.length - 1) {
        this.activeSuggestionsIndex = -1;
      }
      return filteredSuggestions;
    }
  },
  methods: {
    isSuggestionActive: function isSuggestionActive(index) {
      return this.activeSuggestionsIndex == index;
    },
    selecteNextSuggestion: function selecteNextSuggestion() {
      if (this.activeSuggestionsIndex < this.currentSuggestions.length - 1) {
        this.activeSuggestionsIndex++;
      }
    },
    selectPreviousSuggestion: function selectPreviousSuggestion() {
      if (this.activeSuggestionsIndex > 0) {
        this.activeSuggestionsIndex--;
      }
    },
    submit: function submit() {
      if (this.showSuggestions && this.activeSuggestionsIndex >= 0) {
        var suggestion = this.currentSuggestions[this.activeSuggestionsIndex];
        this.searchTerm = suggestion.query;
        this.searchType = suggestion.method;
        this.clickedSuggestion = true;
      }
      if (this.searchTerm.length <= 0) {
        return;
      }
      var query = this.searchTerm;
      var method = this.searchType;

      console.log("query:" + query);
      console.log("method:" + method);
      this.$emit("querySubmitted", {
        query: query,
        method: method
      });
    },
    suggestionClick: function suggestionClick(termObj) {
      if (termObj.query.length <= 0 || termObj.method.length <= 0) {
        return;
      }
      this.searchTerm = termObj.query;
      this.searchType = termObj.method;
      this.clickedSuggestion = true;
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar"},[_c('form',{staticClass:"searchbox",attrs:{"novalidate":"novalidate","onsubmit":"return false;"}},[_c('div',{staticClass:"searchbox_wrapper",attrs:{"role":"search"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.searchTerm),expression:"searchTerm",modifiers:{"trim":true}}],staticClass:"searchbar_input",attrs:{"type":"search","name":"search","placeholder":"Trendsearch","autocomplete":"off","required":"required"},domProps:{"value":(_vm.searchTerm)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.submit()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.stopPropagation();_vm.selectPreviousSuggestion()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.stopPropagation();_vm.selecteNextSuggestion()}],"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"submit",attrs:{"type":"submit","title":"Submit your search query."},on:{"click":function($event){$event.stopPropagation();_vm.submit()}}},[_c('i',{staticClass:"ti-search"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestions),expression:"showSuggestions"}],staticClass:"suggestions"},_vm._l((_vm.currentSuggestions),function(term,index){return _c('li',{class:{'active': _vm.isSuggestionActive(index)},on:{"click":function($event){_vm.suggestionClick(term)}}},[_c('p',[_vm._v(_vm._s(term.query.toLowerCase())+" "),_c('small',[_vm._v(_vm._s(term.method))])])])}))])]),_vm._v(" "),_c('div',{staticClass:"searchtype"},[_c('b',[_vm._v("Search type: ")]),_vm._v(" "),_c('div',{staticClass:"pretty p-default p-round"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchType),expression:"searchType"}],attrs:{"type":"radio","name":"searchType"},domProps:{"value":'ANY',"checked":_vm._q(_vm.searchType,'ANY')},on:{"change":function($event){_vm.searchType='ANY'}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"pretty p-default p-round"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchType),expression:"searchType"}],attrs:{"type":"radio","name":"searchType"},domProps:{"value":'ALL',"checked":_vm._q(_vm.searchType,'ALL')},on:{"change":function($event){_vm.searchType='ALL'}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"pretty p-default p-round"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchType),expression:"searchType"}],attrs:{"type":"radio","name":"searchType"},domProps:{"value":'EXACT',"checked":_vm._q(_vm.searchType,'EXACT')},on:{"change":function($event){_vm.searchType='EXACT'}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"reset",attrs:{"type":"reset","title":"Clear the search query."}},[_c('i',{staticClass:"ti-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state"},[_c('label',[_vm._v("Match any of the terms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state"},[_c('label',[_vm._v("Match all terms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state"},[_c('label',[_vm._v("Exact Match")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a69a1ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__ = __webpack_require__(761);
function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a69a1ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_utils_datahelper__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "graph",
  data: function data() {
    return {
      dataset: this.data,
      useNormalizedData: this.normalize
    };
  },

  props: {
    data: {
      type: Array,
      required: true
    },
    normalize: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    data: function data(newDataArray, oldData) {
      this.dataset = newDataArray;
      this.updateDataArray(newDataArray);
    },
    normalize: function normalize(normalizeVal, oldData) {
      this.useNormalizedData = normalizeVal;
      this.updateDataArray(this.dataset);
    }
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },


  methods: {
    updateDataArray: function updateDataArray(newDataArray) {
      $("svg").remove();

      if (newDataArray.length > 0) {
        var data = this.useNormalizedData ? Object(__WEBPACK_IMPORTED_MODULE_1_js_utils_datahelper__["b" /* normalizeDataArray */])(newDataArray) : newDataArray;
        this.prepareData(data);
      }
    },
    prepareData: function prepareData(data) {
      this.smoothed_data = new Array();
      this.colors = new Array();
      var parseTime = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* timeParse */]("%Y%m%d");
      var count = 0;
      var self = this;
      $.each(data, function (index, item) {
        self.colors.push(item.color);
        $.each(item.data, function (key, value) {
          count++;
          if (!(parseTime(key).getDay() == 0) && !(parseTime(key).getDay() == 6)) {
            self.smoothed_data.push({
              query: index,
              date: parseTime(key),
              count: value
            });
          }
        });
      });
      this.group = __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* nest */]().key(function (d) {
        return d.query;
      }).entries(this.smoothed_data);
      this.buildGraph(this.smoothed_data);
    },

    buildGraph: function buildGraph(data) {
      var parentW = document.getElementById("graph").clientWidth;
      this.parentH = 400;
      this.margin = { top: 20, right: 50, bottom: 50, left: 50 };

      this.x = __WEBPACK_IMPORTED_MODULE_0_d3__["h" /* scaleTime */]().range([0, this.parentW - this.margin.left - this.margin.right]);
      this.y = __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* scaleLinear */]().range([this.parentH - this.margin.top - this.margin.bottom, 0]);

      this.xAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* axisBottom */]().scale(this.x);
      this.yAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* axisLeft */]().scale(this.y);

      this.x.domain(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* extent */](data, function (d) {
        return d.date;
      }));
      this.y.domain([0, __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* max */](data, function (d) {
        return d.count;
      })]);

      this.buildLines(this.group);
    },

    buildLines: function buildLines(data) {
      var self = this;
      this.patharray = new Array();

      this.svg = __WEBPACK_IMPORTED_MODULE_0_d3__["i" /* select */]("#graph").append("svg").attr("height", this.parentH);
      this.canvas = this.svg.append("g").attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

      $.each(data, function (index, item) {
        self.patharray[index] = self.canvas.append("path").attr("class", "line").style("stroke", self.colors[index]);
      });

      this.xEl = this.canvas.append("g").attr("transform", "translate(0 " + (this.parentH - this.margin.top - this.margin.bottom) + ")");
      this.yEl = this.canvas.append("g").call(this.yAxis);

      this.updateValues(this.x, this.y, data);
    },

    updateValues: function updateValues(x, y, data) {
      var parentW = document.getElementById("graph").clientWidth;

      this.svg.attr("width", parentW);
      x.range([0, parentW - this.margin.left - this.margin.right]);
      this.xAxis.scale(x);
      this.xEl.call(this.xAxis);

      var line = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* line */]().x(function (d) {
        return x(d.date);
      }).y(function (d) {
        return y(d.count);
      });

      $.each(this.patharray, function (index, item) {
        item.attr("d", line(data[index].values));
      });
    },

    onResize: function onResize(event) {
      if ($("#graph").is(":parent")) {
        this.updateValues(this.x, this.y, this.group);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"graph"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataTable_vue__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1708ba28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataTable_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1708ba28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1708ba28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(764);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("19161225", content, true);

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "table thead[data-v-1708ba28]{background-color:#053948;color:#fff}table thead th[data-v-1708ba28]{font-weight:700}", ""]);

// exports


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_js_components_engagement_common_AdditionalDataTableRow__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_utils_datahelper__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "additional-graph-data",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    DataRow: __WEBPACK_IMPORTED_MODULE_0_src_js_components_engagement_common_AdditionalDataTableRow__["a" /* default */]
  },
  data: function data() {
    return {
      tableData: [{
        query: "Test",
        color: "#e6194b",
        min: 0,
        max: 543,
        avg: 65,
        median: 76
      }, {
        query: "Trump",
        color: "#3cb44b",
        min: 68,
        max: 6785,
        avg: 4575,
        median: 4690
      }, {
        query: "Bitcoin",
        color: "#f58231",
        min: 5,
        max: 4678,
        avg: 2545,
        median: 3245
      }],
      dataset: this.data
    };
  },
  watch: {
    data: function data(newDataArray, oldData) {
      console.log(newDataArray);
      this.dataset = Object(__WEBPACK_IMPORTED_MODULE_1_js_utils_datahelper__["a" /* aggregateDataArray */])(newDataArray);
      console.log(this.dataset);
    }
  },
  computed: {
    computedData: function computedData() {
      var _this = this;

      var globalMaxMin = 1;
      var globalMax = 1;
      var globalMaxAvg = 1;
      var globalMaxMedian = 1;
      console.log(this.dataset);

      this.dataset.forEach(function (value) {
        if (value.min > globalMaxMin) {
          globalMaxMin = value.min;
        }
        if (value.max > globalMax) {
          globalMax = value.max;
        }
        if (value.avg > globalMaxAvg) {
          globalMaxAvg = value.avg;
        }
        if (value.median > globalMaxMedian) {
          globalMaxMedian = value.median;
        }
      });
      var transformedData = this.dataset.map(function (val) {
        return Object.assign({}, {
          query: _this.formattedTerm(val),
          color: val.color,
          min: [val.min, globalMaxMin],
          max: [val.max, globalMax],
          avg: [val.avg, globalMaxAvg],
          median: [val.median, globalMaxMedian]
        });
      });

      return transformedData;
    }
  },
  methods: {
    formattedTerm: function formattedTerm(query) {
      if (query.method == "ALL") {
        return query.query.trim().replace(/\s/g, "&");
      } else if (query.method == "EXACT") {
        return "\"" + query.query.trim() + "\"";
      } else if (query.method == "ANY") {
        return query.query.trim();
      }
      return query.query.trim();
    }
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataTableRow_vue__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ead47c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataTableRow_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35ead47c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataTableRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ead47c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataTableRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3b32c3bc", content, true);

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td[data-v-35ead47c]{padding:0;margin:0 5px;position:relative}.table>tbody>tr>td div.value[data-v-35ead47c]{padding:12px;position:relative}.table>tbody>tr>td div.background[data-v-35ead47c]{position:absolute;margin:0 1%;width:80%;height:100%;visibility:visible}", ""]);

// exports


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "additional-graph-data-row",
  props: {
    rowData: {
      type: Object,
      default: function _default() {
        return {
          query: "Test",
          color: "#e6194b",
          min: [25, 5],
          max: [67, 100],
          avg: [50, 50],
          median: [35, 45]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  watch: {},
  computed: {
    backgroundColor: function backgroundColor() {
      return this.rowData.color;
    },
    normalizedMin: function normalizedMin() {
      return parseFloat(this.rowData.min[0] / this.rowData.min[1] * 100).toFixed(0);
    },
    minBackgroundWidth: function minBackgroundWidth() {
      return Math.max(0, this.normalizedMin - 2) + "%";
    },
    normalizedMax: function normalizedMax() {
      return parseFloat(this.rowData.max[0] / this.rowData.max[1] * 100).toFixed(2);
    },
    maxBackgroundWidth: function maxBackgroundWidth() {
      return Math.max(0, this.normalizedMax - 2) + "%";
    },
    normalizedAvg: function normalizedAvg() {
      return parseFloat(this.rowData.avg[0] / this.rowData.avg[1] * 100).toFixed(2);
    },
    avgBackgroundWidth: function avgBackgroundWidth() {
      return Math.max(0, this.normalizedAvg - 2) + "%";
    },
    normalizedMedian: function normalizedMedian() {
      return parseFloat(this.rowData.median[0] / this.rowData.median[1] * 100).toFixed(2);
    },
    medianBackgroundWidth: function medianBackgroundWidth() {
      return Math.max(0, this.normalizedMedian - 2) + "%";
    }
  },
  methods: {}
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rowData.query))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"background min",style:({backgroundColor: _vm.backgroundColor, width: _vm.minBackgroundWidth})}),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rowData.min[0]))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"background max",style:({backgroundColor: _vm.backgroundColor, width: _vm.maxBackgroundWidth})}),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rowData.max[0]))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"background avg",style:({backgroundColor: _vm.backgroundColor, width: _vm.avgBackgroundWidth})}),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rowData.avg[0]))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"background median",style:({backgroundColor: _vm.backgroundColor, width: _vm.medianBackgroundWidth})}),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rowData.median[0]))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_c('table',{staticClass:"table table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.computedData),function(row){return _c('data-row',{key:row.query,attrs:{"rowData":row}})}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Query Name")]),_vm._v(" "),_c('th',[_vm._v("min (rel)")]),_vm._v(" "),_c('th',[_vm._v("max (rel)")]),_vm._v(" "),_c('th',[_vm._v("avg (rel)")]),_vm._v(" "),_c('th',[_vm._v("median (rel)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BounceLoader_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_33f40e45_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_BounceLoader_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BounceLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_33f40e45_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_BounceLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'BounceLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        borderRadius: this.radius,
        opacity: 0.6,
        position: 'absolute',
        top: 0,
        left: 0
      }
    };
  },

  computed: {
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-bounce v-bounce1",style:(_vm.spinnerBasicStyle)},[_c('div',{staticClass:"v-bounce v-bounce2",style:(_vm.spinnerStyle)}),_c('div',{staticClass:"v-bounce v-bounce3",style:(_vm.spinnerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('search-bar',{attrs:{"initialSearchType":_vm.queryMethod,"initialSearchTerm":_vm.queryTerm,"cachedSearchTerms":_vm.cachedTerms},on:{"querySubmitted":_vm.onSearchQuerySubmitted}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"col-lg-12 col-sm-12 alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"      "),_c('i',{staticClass:"ti-close",on:{"click":function($event){$event.stopPropagation();_vm.clearError($event)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasTrends),expression:"hasTrends"}],staticClass:"col-lg-12 col-sm-12"},[_c('card',[_c('div',{staticClass:"topic-chips clearfix",attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Terms:")]),_vm._v(" "),_vm._l((_vm.queries),function(query){return _c('span',{staticClass:"label label-primary",style:({backgroundColor: query.color})},[_c('span',[_vm._v(_vm._s(_vm.formattedTerm(query)))]),_vm._v(" "),_c('i',{staticClass:"ti-close",on:{"click":function($event){$event.stopPropagation();_vm.removeQuery(query)}}})])})],2)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasTrends),expression:"hasTrends"}],staticClass:"col-lg-12 col-sm-12"},[_c('card',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n          Trend Graphs \n        ")]),_vm._v(" "),_c('div',{attrs:{"slot":"subTitle"},slot:"subTitle"},[_c('div',{staticClass:"pretty p-default"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showNormalizedData),expression:"showNormalizedData"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showNormalizedData)?_vm._i(_vm.showNormalizedData,null)>-1:(_vm.showNormalizedData)},on:{"change":function($event){var $$a=_vm.showNormalizedData,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showNormalizedData=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showNormalizedData=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showNormalizedData=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"state p-primary"},[_c('label',[_vm._v("Normalize Data")])])])]),_vm._v(" "),_c('div',{staticClass:"contentframe",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"overlay",class:{hide: !_vm.isLoading},attrs:{"id":"spinner"}},[_c('bounce-loader',{attrs:{"loading":_vm.isLoading,"color":"#127281"}})],1),_vm._v(" "),_c('graph',{attrs:{"data":_vm.queries,"normalize":_vm.showNormalizedData}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.trendIndicatorMessage))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.prettyTimerange))])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasTrends),expression:"hasTrends"}],staticClass:"col-lg-12 col-sm-12"},[_c('card',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n          Data Analysis\n        ")]),_vm._v(" "),_c('div',{staticClass:"contentframe datatable",attrs:{"slot":"content"},slot:"content"},[_c('additional-data',{attrs:{"data":_vm.queries}})],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertHome_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5577b5dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertHome_vue__ = __webpack_require__(785);
function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5577b5dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5577b5dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(779);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a3d13d30", content, true);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "img[data-v-5577b5dc]{width:100%}", ""]);

// exports


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserCard_vue__ = __webpack_require__(781);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UserCard: __WEBPACK_IMPORTED_MODULE_0__UserCard_vue__["a" /* default */]
  }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7389d714_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7389d714_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: "12",
        subTitle: "Files"
      }, {
        title: "2GB",
        subTitle: "Used"
      }, {
        title: "24,6$",
        subTitle: "Spent"
      }]
    };
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
    // arrow functions can make the code very succinct!
    user: function user(state) {
      return state.user.user;
    }
  })),
  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-md-3 col-md-offset-1";
      } else if (remainder === 2) {
        return "col-md-4";
      } else {
        return "col-md-3";
      }
    }
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"/static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.user.firstname)+" "+_vm._s(_vm.user.lastname)+"\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@"+_vm._s(_vm.user.email))])])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"/static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('img',{attrs:{"src":__webpack_require__(786)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mockup-alerts.fc86c2f.png";

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorNotFound_vue__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03649ae4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorNotFound_vue__ = __webpack_require__(791);
function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03649ae4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03649ae4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(789);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0dff856e", content, true);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".wrap[data-v-03649ae4]{margin:0 auto;width:96%}h1[data-v-03649ae4]{margin-top:20px;color:#127281;font-size:3em;text-transform:uppercase;font-weight:700}.banner[data-v-03649ae4]{text-align:center;margin-top:30px}.banner img[data-v-03649ae4]{margin-top:0}.page[data-v-03649ae4]{text-align:center;font-family:Century Gothic}.page h2[data-v-03649ae4]{font-size:3em;color:#127281;font-weight:700}.footer[data-v-03649ae4]{font-family:Century Gothic;text-align:right;margin-top:2em}.footer p[data-v-03649ae4]{font-size:1em;color:#603813}.footer a[data-v-03649ae4]{color:#f9614d}.footer a[data-v-03649ae4]:hover{text-decoration:underline}", ""]);

// exports


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"banner"},[_c('router-link',{attrs:{"to":{path:'/'}}},[_c('img',{attrs:{"src":__webpack_require__(792),"alt":""}})])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("Seems like 404 is trending right now.")]),_vm._v(" "),_c('h2',[_vm._v("This trend predicts that this page is not found!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("© 2013 Poses-404. All Rights Reserved | Design by "),_c('a',{attrs:{"href":"http://w3layouts.com"}},[_vm._v("w3layouts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.6da8aa6.png";

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertHome_vue__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19479018_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertHome_vue__ = __webpack_require__(801);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19479018"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19479018_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(795);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("896fc61e", content, true);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "img[data-v-19479018]{width:100%}", ""]);

// exports


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserCard_vue__ = __webpack_require__(797);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UserCard: __WEBPACK_IMPORTED_MODULE_0__UserCard_vue__["a" /* default */]
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ec1964_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ec1964_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: "12",
        subTitle: "Files"
      }, {
        title: "2GB",
        subTitle: "Used"
      }, {
        title: "24,6$",
        subTitle: "Spent"
      }]
    };
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
    // arrow functions can make the code very succinct!
    user: function user(state) {
      return state.user.user;
    }
  })),
  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-md-3 col-md-offset-1";
      } else if (remainder === 2) {
        return "col-md-4";
      } else {
        return "col-md-3";
      }
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"/static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.user.firstname)+" "+_vm._s(_vm.user.lastname)+"\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@"+_vm._s(_vm.user.email))])])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"/static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('img',{attrs:{"src":__webpack_require__(802)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/related-terms.b15871e.png";

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CachedTerms_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9ba008_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CachedTerms_vue__ = __webpack_require__(807);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b9ba008"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CachedTerms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9ba008_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CachedTerms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(805);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("045f5eb2", content, true);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "ul[data-v-9b9ba008]{box-shadow:0 2px 2px hsla(38,16%,76%,.5);padding:0;list-style:none;background:#fff}ul li[data-v-9b9ba008]{padding:5px 19px}ul li.active[data-v-9b9ba008],ul li[data-v-9b9ba008]:hover{background:#f8f8f8;color:#127281}ul p[data-v-9b9ba008]{cursor:pointer;margin:0}ul small[data-v-9b9ba008]{font-size:.6em;color:#127281}", ""]);

// exports


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_js_router__ = __webpack_require__(43);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    cachedTerms: function cachedTerms() {
      return this.$store.state.trends.cachedTrendsList;
    }
  },
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(["getCachedTrends", "updateCurrentSearchQueries"]), {
    suggestionClick: function suggestionClick(termObj) {
      if (termObj.query.length <= 0 || termObj.method.length <= 0) {
        return;
      }
      this.updateCurrentSearchQueries([termObj]).then(function (resp) {
        console.log(resp);
        __WEBPACK_IMPORTED_MODULE_1_src_js_router__["a" /* default */].push({
          path: "/engagement/dashboard"
        });
      }).catch(function (error) {});
      console.dir("suggestionClick()" + termObj);
    },
    updateCachedTrends: function updateCachedTrends() {
      this.getCachedTrends().then(function (response) {
        return console.log(response);
      }).catch(function (error) {
        return console.error(error);
      });
    }
  }),
  mounted: function mounted() {
    this.updateCachedTrends();
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cached-terms"}},[_c('ul',_vm._l((_vm.cachedTerms),function(term,index){return _c('li',{on:{"click":function($event){_vm.suggestionClick(term)}}},[_c('p',[_vm._v(_vm._s(term.query.toLowerCase())+" "),_c('small',[_vm._v(_vm._s(term.method))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */,
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__(810);


var SidebarStore = {
    showSidebar: false,
    sidebarLinks: [{
        name: 'Dashboard',
        icon: 'ti-panel',
        path: '/engagement/dashboard'
    }, {
        name: 'Alerts',
        icon: 'ti-alarm-clock',
        path: '/engagement/alerts'
    }, {
        name: 'Cached Terms',
        icon: 'ti-save',
        path: '/engagement/cached'
    }, {
        name: 'Related Terms',
        icon: 'ti-view-list-alt',
        path: '/engagement/related'
    }],
    displaySidebar: function displaySidebar(value) {
        this.showSidebar = value;
    }
};

var SidebarPlugin = {
    install: function install(Vue) {
        Vue.mixin({
            data: function data() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get: function get() {
                return this.$root.sidebarStore;
            }
        });
        Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5fbb54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__(819);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d5fbb54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5fbb54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7b7d55fd", content, true);

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".logo-img[data-v-0d5fbb54]{background:transparent!important}", ""]);

// exports


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MovingArrow_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: "sidebar",
      validator: function validator(value) {
        var acceptedValues = ["sidebar", "navbar"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: "pretrendr",
      validator: function validator(value) {
        var acceptedValues = ["white", "black", "darkblue", "pretrendr"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: "pretrendr",
      validator: function validator(value) {
        var acceptedValues = ["primary", "info", "success", "warning", "danger", "pretrendr"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    MovingArrow: __WEBPACK_IMPORTED_MODULE_0__MovingArrow_vue__["a" /* default */]
  },
  computed: _extends({
    sidebarClasses: function sidebarClasses() {
      if (this.type === "sidebar") {
        return "sidebar";
      } else {
        return "collapse navbar-collapse off-canvas-sidebar";
      }
    },
    navClasses: function navClasses() {
      if (this.type === "sidebar") {
        return "nav";
      } else {
        return "nav navbar-nav";
      }
    },

    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx: function arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    // arrow functions can make the code very succinct!
    user: function user(state) {
      return state.user.user;
    }
  })),
  data: function data() {
    return {
      linkHeight: 60,
      activeLinkIndex: 0,

      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false
    };
  },

  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      this.sidebarLinks.find(function (element, index) {
        var found = element.path === _this.$route.path;
        if (found) {
          _this.activeLinkIndex = index;
        }
        return found;
      });
    },
    logout: function logout() {
      this.$store.dispatch("logoutUser").then(function (event) {
        console.log("logged out");
        /*this.$router.push({
            path: "/"
          });*/
      }).catch();
    },
    clearData: function clearData() {
      console.log("Clear Trends Data");
      this.$store.dispatch("clearTrends").then(function (event) {
        console.log("trends cleared");
        /*this.$router.push({
            path: "/"
          });*/
      }).catch();
    }
  },
  mounted: function mounted() {
    this.findActiveLink();
  },

  watch: {
    $route: function $route(newRoute, oldRoute) {
      this.findActiveLink();
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovingArrow_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b19cf3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovingArrow_vue__ = __webpack_require__(818);
function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54b19cf3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovingArrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b19cf3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovingArrow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("decabe06", content, true);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, ".moving-arrow[data-v-54b19cf3]{border-right:17px solid #f4f3ef;border-top:17px solid transparent;border-bottom:17px solid transparent;display:inline-block;position:absolute;left:243px;top:95px;transition:all .5s cubic-bezier(.29,1.42,.79,1)}", ""]);

// exports


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    moveY: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * Styles to animate the arrow
     * @returns {{transform: string}}
     */
    arrowStyle: function arrowStyle() {
      return {
        transform: "translate3d(0px, " + this.moveY + "px, 0px)"
      };
    }
  }
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moving-arrow",style:(_vm.arrowStyle)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"sidebar-wrapper",attrs:{"id":"style-3"}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":""}},[_vm._m(0),_vm._v("\n        "+_vm._s(_vm.user.firstname)+" "+_vm._s(_vm.user.lastname)+"\n      ")])]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._l((_vm.sidebarLinks),function(link,index){return _c('router-link',{key:link.name + index,ref:link.name,refInFor:true,attrs:{"to":link.path,"tag":"li","active-class":"active"}},[_c('a',[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name)+"\n          ")])])])}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.clearData($event)}}},[_c('i',{staticClass:"ti-trash"}),_vm._v(" "),_c('p',[_vm._v("Clear Trends Cache")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.logout($event)}}},[_c('i',{staticClass:"ti-power-off"}),_vm._v(" "),_c('p',[_vm._v("Logout")])])])],2),_vm._v(" "),_c('moving-arrow',{attrs:{"move-y":_vm.arrowMovePx}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":__webpack_require__(820),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Dropdown_vue__ = __webpack_require__(822);


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_0__components_common_Dropdown_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa87858_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(824);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa87858_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    icon: String
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"dropdown",class:{open:_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])],2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[324]);


// WEBPACK FOOTER //
// js/main.9cf1a860d153a3d91715.js